import logo from './logo.svg';
import { QRCodeCanvas } from 'qrcode.react';
import greenmark from './img/greenmark.png';
import FintechSuccessModal from './components/BrokerProgram/FintechSuccessModal';
import walletincircle from './img/tg_image_3753232113.png';
import defaultSettings from './config/defaultSettings.json';
import { generateAmountsForTariff } from './utils/amountGenerator';
import './App.css';
import { Dashbroad } from "./components/Dashbroad";
import { Header } from "./components/Header/Header";
import { NavBar } from "./components/NavBar/NavBar";
import s from './App.module.sass';
import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { toast as sonnerToast } from "sonner";
import { useSimpleTranslation } from './hooks/useTranslation';
import useToast from './hooks/useToast';
import { TradingDashboard } from "./components/TradingDashboard/TradingDashboard";
import { Wallet } from "./components/Wallet/Wallet";
import { Mailbox } from "./components/Mailbox/Mailbox";
import FlagIcon from './components/FlagIcon/FlagIcon';
import ConfirmDialog from './components/ConfirmDialog/ConfirmDialog';
import Chat from "./components/Chat/Chat";
import telegram from "./img/enviar.png";
import convert from "./img/convert.png";
import buy from "./img/buy.png";
import comsImage from './img/coms.png';
import verifImage from './img/verif.png';
import trade from "./img/trade.png";
import { ToggleSwitch } from "./components/ToggleSwitch/ToggleSwitch";
import tron from "./img/tron.png";
import bitcoin from "./img/Bitcoin.svg.png";
import etherium from "./img/Ethereum-ETH-icon.png";
import binance from "./img/binance-coin-bnb-logo-CD94CC6D31-seeklogo.com.png";
import usdclogo from "./img/usdclogo.png";
import solana from "./img/solana.png";
import triangle from "./img/triangle-filled-svgrepo-com.svg";
import mercadopago from "./img/mercadopago.png";
import naranjax from "./img/naranja.png";
import BNA from "./img/bna.png";
import UALA from "./img/uala.png";
import brubank from "./img/brubank.png";
import cuentadni from "./img/cuentadni.png";
import lemoncash from "./img/lemon.png";
import santander from "./img/santander.png";
import galicia from "./img/galicia.png";
import bbva from "./img/bbva.png";
import personalpay from "./img/personalpay.png";
import prex from "./img/prex.png";
import fiwind from "./img/fiwind.png";
import provincia from "./img/provincia.png";
import macro from "./img/macro.png";
import pampa from "./img/pampa.png";
import ciudad from "./img/ciudad.png";
import astropay from "./img/astropay.png";
import patagonia from "./img/patagonia.png";
import supervielle from "./img/supervielle.png";
import visa from "./img/visa.png";
import mastercard from "./img/mastercard.png";
import credicoop from "./img/credicoop.png";
import otrobanco from "./img/otrobanco.png";
import defaultBankIcon from "./img/bankicons/default-bank.png";
import icbc from "./img/ICBC.png";
import belo from "./img/belo.png";
import { BrokerProgram } from "./components/BrokerProgram/BrokerProgram";
import { Settings } from "./components/Settings/Settings";
import { AdminPanel } from "./components/AdminPanel/AdminPanel";
import SiteSettingsPage from "./components/SiteSettings/SiteSettings";
import LoginScreen from "./components/LoginScreen/LoginScreen";
import Toast from './components/Toast/Toast';
import { canAccessSiteSettings, getCurrentUserRole, getAllowedConfigs } from './utils/permissions';
import { loadFontByValue } from './utils/fontLoader';
import { initFrontendDeterrents } from './utils/frontendDeterrents';
import { initGlobalInteractionAudit } from './utils/globalInteractionAudit';
import { buildWalletsByCurrencyFromLegacy, resolveWallet, resolveBankWallet, isBankPaymentMode } from './utils/walletResolver';
import toastStyles from './components/Toast/Toast.module.sass';
import MiniFigma from "./components/MiniFigma/MiniFigma";
import { lazy, Suspense } from "react";
import { AppProvider } from "./app-core/AppContext";
// import irsImage from './img/irs.png'; // Заменено на динамическую настройку
import irsStamp from './img/irs-stamp.png';
import irsSmall1 from './img/irs-small1.png';
import irsSmall2 from './img/irs-small2.png';
import visible from './img/visible-icon.png';
import hidden from './img/hidden-icon.png';

// Импорт иконок тарифов
import tarif1Icon from './img/iconsas/1tarif.png';
import tarif2Icon from './img/iconsas/2tarif.png';
import tarif3Icon from './img/iconsas/3tarif.png';
import tarif4Icon from './img/iconsas/4tarif.png';
import viptarifIcon from './img/iconsas/viptarif.png';

const NovaApp = lazy(() => import("./themes/nova/NovaApp"));
const NovaCommissionModal = lazy(() => import("./themes/nova/modals/NovaCommissionModal"));
const NovaVerificationModal = lazy(() => import("./themes/nova/modals/NovaVerificationModal"));
const NovaSuccessModal = lazy(() => import("./themes/nova/modals/NovaSuccessModal"));
const NovaConversionModal = lazy(() => import("./themes/nova/modals/NovaConversionModal"));
const NovaBankConversionModal = lazy(() => import("./themes/nova/modals/NovaBankConversionModal"));
const NovaPremiumModal = lazy(() => import("./themes/nova/modals/NovaPremiumModal"));
const NovaCodeModal = lazy(() => import("./themes/nova/modals/NovaCodeModal"));

// Определение кошельков для каждого модального окна
// Crypto wallet addresses - moved into component to make dynamic

const tariffs = [
    {
        label: '💰 1 ТАРИФ',
        backgroundColor: '#6A9A70',
        hoverColor: '#587F5D',
        commissionAmount: 549,
        baseAmount: 10532.71,
        additionalAmount: 5499.27,
        taxAmount: '3.281.470,08',
            taxPercent: 4.7,
            conversionCommission: 459,
            bankConversionFee: 385
    },
    {
        label: '❗❗ 2 ТАРИФ',
        backgroundColor: '#C9924D',
        hoverColor: '#B47E3C',
        commissionAmount: 589,
        baseAmount: 17808.03,
        additionalAmount: 9263.18,
        taxAmount: '4.645.582,92',
            taxPercent: 3.8,
            conversionCommission: 559,
            bankConversionFee: 485.00
    },
    {
        label: '❗❗❗ 3 ТАРИФ',
        backgroundColor: '#C2744B',
        hoverColor: '#A9613E',
        commissionAmount: 659,
        baseAmount: 32728.31,
        additionalAmount: 13747.52,
        taxAmount: '9.384.343,81',
        taxPercent: 2.2,
        conversionCommission: 659,
        bankConversionFee: 585.00
    },
    {
        label: '❗❗❗❗ 4 ТАРИФ',
        backgroundColor: '#B44A4A',
        hoverColor: '#993D3D',
        commissionAmount: 889,
        baseAmount: 43357.29,
        additionalAmount: 18569.92,
        taxAmount: '12.475.382,90',
        taxPercent: 1.8,
        conversionCommission: 759,
        bankConversionFee: 685.00
    },
    {
        label: '⚠️ VIP ТАРИФ',
        backgroundColor: '#8364A1',
        hoverColor: '#6F5388',
        commissionAmount: 1099,
        baseAmount: 76052.81,
        additionalAmount: 37765.44,
        taxAmount: '21.475.382,90',
        taxPercent: 1.3,
        conversionCommission: 859,
        bankConversionFee: 785
    }
];

// Компонент-обертка для кастомного модала с поддержкой QR кода и закрытия
const CustomModalWrapper = ({ modalKey, processedHtml, cssStyles, qrValue, onClose }) => {
    const modalContentRef = useRef(null);
    const modalContainerRef = useRef(null);
    
    // Обработка QR кода после рендера
    useEffect(() => {
        if (!modalContentRef.current || !qrValue) {
            console.log('🔍 CustomModal QR: modalContentRef или qrValue отсутствует', { 
                hasRef: !!modalContentRef.current, 
                qrValue 
            });
            return;
        }
        
        // Используем setTimeout чтобы убедиться что DOM обновлен
        const timer = setTimeout(() => {
            const placeholders = modalContentRef.current.querySelectorAll('.custom-modal-qr-placeholder');
            console.log('🔍 CustomModal QR: найдено placeholders', placeholders.length);
            
            placeholders.forEach((placeholder, index) => {
                if (placeholder.querySelector('canvas')) {
                    console.log(`🔍 CustomModal QR: placeholder ${index} уже имеет canvas`);
                    return; // Уже заменен
                }
                
                const qrValueAttr = placeholder.getAttribute('data-qr-value') || qrValue;
                console.log(`🔍 CustomModal QR: заменяю placeholder ${index} с значением`, qrValueAttr);
                
                const qrContainer = document.createElement('div');
                qrContainer.style.display = 'flex';
                qrContainer.style.justifyContent = 'center';
                qrContainer.style.alignItems = 'center';
                qrContainer.style.padding = '10px';
                
                // Используем ReactDOM для рендеринга QRCodeCanvas
                try {
                    const ReactDOM = require('react-dom/client');
                    const qrRoot = ReactDOM.createRoot(qrContainer);
                    qrRoot.render(
                        React.createElement(QRCodeCanvas, {
                            value: qrValueAttr,
                            size: 120,
                            bgColor: '#ffffff',
                            fgColor: '#2d3748'
                        })
                    );
                    
                    placeholder.innerHTML = '';
                    placeholder.appendChild(qrContainer);
                    console.log(`✅ CustomModal QR: placeholder ${index} успешно заменен`);
                } catch (error) {
                    console.error('❌ CustomModal QR: ошибка при создании QR кода', error);
                    // Fallback: используем URL для QR кода
                    const qrImg = document.createElement('img');
                    qrImg.src = `https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(qrValueAttr)}`;
                    qrImg.alt = 'QR Code';
                    qrImg.style.maxWidth = '120px';
                    placeholder.innerHTML = '';
                    placeholder.appendChild(qrImg);
                }
            });
        }, 100);
        
        return () => clearTimeout(timer);
    }, [qrValue, processedHtml]);
    
            // Обработка кликов на кнопки закрытия через делегирование событий
    useEffect(() => {
        if (!modalContainerRef.current) return;
        
        const handleClick = (e) => {
            const target = e.target;
            const targetTag = target.tagName;
            
            // ЛЮБАЯ кнопка закрывает модал
            if (targetTag === 'BUTTON' || target.closest('button')) {
                console.log('✅ CustomModal: закрытие модала по клику на кнопку');
                e.preventDefault();
                e.stopPropagation();
                onClose();
                return;
            }
        };
        
        modalContainerRef.current.addEventListener('click', handleClick, true); // Используем capture phase
        
        return () => {
            if (modalContainerRef.current) {
                modalContainerRef.current.removeEventListener('click', handleClick, true);
            }
        };
    }, [onClose]);
    
    // Обработка клика вне модала (на overlay)
    const handleOverlayClick = (e) => {
        // Если клик был непосредственно на overlay (не на дочерних элементах)
        if (e.target === e.currentTarget) {
            console.log('✅ CustomModal: закрытие модала по клику вне поля');
            onClose();
        }
    };
    
    return (
        <div
            className={s.customModalOverlay}
            onClick={handleOverlayClick}
            style={{ 
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 5000
            }}
        >
            <div
                ref={modalContainerRef}
                style={{
                    background: 'white',
                    borderRadius: '12px',
                    maxWidth: '500px',
                    width: '90%',
                    maxHeight: '90vh',
                    overflow: 'auto',
                    position: 'relative'
                }}
                onClick={(e) => {
                    // Останавливаем всплытие для всех кликов внутри модала
                    e.stopPropagation();
                }}
            >
                <style>{cssStyles}</style>
                <div 
                    ref={modalContentRef}
                    dangerouslySetInnerHTML={{ __html: processedHtml }}
                />
            </div>
        </div>
    );
};

// Разделы левого меню ⇄ URL-пути: сайт.ком/dashboard, /trading, /wallet и т.д.
// Ключ — значение showExactMenu, значение — путь в адресной строке.
const SECTION_TO_PATH = {
    dashboard: '/dashboard',
    trade: '/trading',
    wallet: '/wallet',
    broker: '/broker',
    mailbox: '/mailbox',
    // ВАЖНО: не '/settings' — этот путь занят страницей Site Settings (index.js)
    settings: '/account',
};
const PATH_TO_SECTION = Object.fromEntries(
    Object.entries(SECTION_TO_PATH).map(([section, path]) => [path, section])
);

// Разбираем текущий URL: раздел определяем по ПОСЛЕДНЕМУ сегменту пути,
// всё, что стоит перед ним, считаем префиксом (базой). Благодаря этому
// работает и exchange.local/dashboard, и exchange.local/что-то/ещё/dashboard.
function parseLocationSection() {
    const segments = window.location.pathname.split('/').filter(Boolean);
    const last = segments.length ? '/' + segments[segments.length - 1] : '';
    const section = PATH_TO_SECTION[last];
    const base = section ? segments.slice(0, -1).join('/') : '';
    return { section, base: base ? '/' + base : '' };
}

function App() {
    const { toasts, success: baseSuccess, error: baseError, warning: baseWarning, info: baseInfo, hideToast } = useToast();

    // Тосты: в теме Nova уходят в Sonner (Toaster смонтирован в NovaApp),
    // в оригинальной теме — прежние самодельные. Ref, а не замыкание:
    // тема может смениться в рантайме без пересоздания колбэков
    const novaToastRef = useRef(false);
    const success = useCallback((msg, d) => novaToastRef.current
        ? sonnerToast.success(msg, { duration: d ?? 3000 })
        : baseSuccess(msg, d), [baseSuccess]);
    const error = useCallback((msg, d) => novaToastRef.current
        ? sonnerToast.error(msg, { duration: d ?? 3000 })
        : baseError(msg, d), [baseError]);
    const warning = useCallback((msg, d) => novaToastRef.current
        ? sonnerToast.warning(msg, { duration: d ?? 3000 })
        : baseWarning(msg, d), [baseWarning]);
    const info = useCallback((msg, d) => novaToastRef.current
        ? sonnerToast.info(msg, { duration: d ?? 3000 })
        : baseInfo(msg, d), [baseInfo]);

    useEffect(() => {
        const cleanupDeterrents = initFrontendDeterrents();
        const cleanupInteractionAudit = initGlobalInteractionAudit();

        return () => {
            cleanupDeterrents?.();
            cleanupInteractionAudit?.();
        };
    }, []);
    
    // Состояние аутентификации
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('isAuthenticated') === 'true';
    });
    const [currentUser, setCurrentUser] = useState(() => {
        const user = localStorage.getItem('currentUser');
        return user ? JSON.parse(user) : null;
    });

    const handleLogin = (user) => {
        setIsAuthenticated(true);
        setCurrentUser(user);
        // Загружаем роль пользователя после логина
        getCurrentUserRole().then(async (role) => {
            setUserRole(role);
            setCanAccessSiteSettingsPage(canAccessSiteSettings(role));
            
            // Проверяем, нужно ли автоматически применить конфиг.
            // allowedConfigs === null → админ: разрешено состояние «не выбран».
            // Массив (не-админ) → всегда применяем ПЕРВЫЙ доступный, чтобы у
            // сотрудника не было пустого выбора.
            const allowedConfigs = await getAllowedConfigs();

            // Сначала пробуем восстановить последний конфиг этого пользователя
            const lastConfig = getLastConfigForUser();
            if (lastConfig) {
                const match = Array.isArray(allowedConfigs)
                    ? allowedConfigs.find(c => c === lastConfig || c === `${lastConfig}.json` || `${c}.json` === lastConfig)
                    : (lastConfig.endsWith('.json') ? lastConfig : `${lastConfig}.json`);
                if (match) {
                    try {
                        const { loadLocalConfig } = await import('./utils/configUtils');
                        const configData = await loadLocalConfig(match);
                        handleApplyConfig(configData, match);
                        console.log('Восстановлен последний конфиг пользователя при логине:', match);
                        return;
                    } catch (error) {
                        console.error('Не удалось восстановить последний конфиг при логине (упадём в первый):', error);
                    }
                }
            }

            if (Array.isArray(allowedConfigs) && allowedConfigs.length >= 1) {
                try {
                    const { loadLocalConfig } = await import('./utils/configUtils');
                    const configData = await loadLocalConfig(allowedConfigs[0]);
                    handleApplyConfig(configData, allowedConfigs[0]);
                    console.log('Автоматически применён первый доступный конфиг при логине:', allowedConfigs[0]);
                } catch (error) {
                    console.error('Ошибка автоматического применения конфига при логине:', error);
                }
            }
        });
    };

    const handleLogout = useCallback(() => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('authToken');
        setIsAuthenticated(false);
        setCurrentUser(null);
    }, []);

    useEffect(() => {
        if (isAuthenticated && !localStorage.getItem('authToken')) {
            handleLogout();
        }
    }, [isAuthenticated, handleLogout]);

    // Проверка активных сессий - если пользователь удален, автоматически разлогиниваем
    useEffect(() => {
        if (!isAuthenticated || !currentUser) return;

        let lastCheckTime = 0;
        const MIN_CHECK_INTERVAL = 1000; // Минимальный интервал между проверками при событиях (1 секунда)
        let clickTimeout = null;

        const checkUserSession = async () => {
            const now = Date.now();
            // Предотвращаем слишком частые проверки при событиях
            if (now - lastCheckTime < MIN_CHECK_INTERVAL) {
                return;
            }
            lastCheckTime = now;

            try {
                const authToken = localStorage.getItem('authToken');
                if (!authToken) {
                    handleLogout();
                    return true;
                }

                // Проверяем валидность текущего токена
                const authResponse = await fetch(`/api/auth/me?t=${Date.now()}`, {
                    headers: { Authorization: `Bearer ${authToken}` }
                });
                if (authResponse.status === 401 || authResponse.status === 403) {
                    console.log('Сессия недействительна, выполняется выход...');
                    handleLogout();
                    return true;
                }

                // Добавляем timestamp для предотвращения кэширования
                const response = await fetch(`/api/files/saps/public?t=${Date.now()}`);
                if (response.ok) {
                    const data = await response.json();
                    const saps = Array.isArray(data.saps) ? data.saps : [];
                    
                    // Проверяем, существует ли текущий пользователь в списке сапов
                    const userExists = saps.some(sap => {
                        // Сравниваем ID как строки для надежности
                        const sapId = String(sap.id || '');
                        const userId = String(currentUser.id || '');
                        const sapUsername = (sap.username || '').toLowerCase();
                        const userUsername = (currentUser.username || '').toLowerCase();
                        
                        return (sapId === userId || sapId === currentUser.id || sap.id === userId) && 
                               sapUsername === userUsername;
                    });

                    if (!userExists) {
                        // Пользователь удален - разлогиниваем
                        console.log('Пользователь удален из системы, выполняется выход...');
                        handleLogout();
                        return true; // Пользователь удален
                    }
                }
            } catch (err) {
                console.error('Ошибка проверки сессии:', err);
            }
            return false; // Пользователь существует
        };

        // Проверяем сразу при загрузке
        checkUserSession();

        // Проверяем каждые 2 секунды для более быстрой реакции
        const intervalId = setInterval(checkUserSession, 2000);

        // Проверяем при возврате фокуса на окно (когда пользователь переключается обратно на вкладку)
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                checkUserSession();
            }
        };

        // Проверяем при фокусе на окно
        const handleFocus = () => {
            checkUserSession();
        };

        // Проверяем при клике на странице (пользователь активен) - с debounce
        const handleClick = () => {
            if (clickTimeout) {
                clearTimeout(clickTimeout);
            }
            clickTimeout = setTimeout(() => {
                checkUserSession();
            }, 500); // Debounce 500ms
        };

        // Проверяем при навигации (изменении маршрута)
        const handlePopState = () => {
            checkUserSession();
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', handleFocus);
        document.addEventListener('click', handleClick, true); // Используем capture phase для перехвата всех кликов
        window.addEventListener('popstate', handlePopState);

        return () => {
            clearInterval(intervalId);
            if (clickTimeout) {
                clearTimeout(clickTimeout);
            }
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('focus', handleFocus);
            document.removeEventListener('click', handleClick, true);
            window.removeEventListener('popstate', handlePopState);
        };
    }, [isAuthenticated, currentUser, handleLogout]);
    
    // Загружаем роль пользователя при монтировании компонента
    useEffect(() => {
        if (isAuthenticated && currentUser) {
            getCurrentUserRole().then(async (role) => {
                setUserRole(role);
                setCanAccessSiteSettingsPage(canAccessSiteSettings(role));
                
                // Проверяем, нужно ли автоматически применить конфиг
                const allowedConfigs = await getAllowedConfigs();

                // Возврат из /settings: восстанавливаем тот же конфиг, из
                // которого туда перешли (сохранён в localStorage перед уходом)
                let returnConfig = null;
                try { returnConfig = localStorage.getItem('nova-return-config'); } catch (_) { /* noop */ }
                if (returnConfig) {
                    try { localStorage.removeItem('nova-return-config'); } catch (_) { /* noop */ }
                    // allowedConfigs === null означает «админ — доступны все конфиги»,
                    // поэтому восстанавливаем сохранённый конфиг напрямую (нормализуя .json).
                    const match = Array.isArray(allowedConfigs)
                        ? allowedConfigs.find(c => c === returnConfig || c === `${returnConfig}.json` || `${c}.json` === returnConfig)
                        : (returnConfig.endsWith('.json') ? returnConfig : `${returnConfig}.json`);
                    if (match) {
                        try {
                            const { loadLocalConfig } = await import('./utils/configUtils');
                            const configData = await loadLocalConfig(match);
                            handleApplyConfig(configData, match);
                            console.log('Восстановлен конфиг после возврата из настроек:', match);
                            return;
                        } catch (error) {
                            console.error('Ошибка восстановления конфига после настроек:', error);
                        }
                    }
                }

                // Восстанавливаем ПОСЛЕДНИЙ выбранный этим пользователем конфиг
                // (если он есть и всё ещё доступен). Работает и для админа, и
                // для не-админа при нескольких конфигах. Приоритет ниже возврата
                // из настроек, но выше «первого доступного».
                const lastConfig = getLastConfigForUser();
                if (lastConfig) {
                    const match = Array.isArray(allowedConfigs)
                        ? allowedConfigs.find(c => c === lastConfig || c === `${lastConfig}.json` || `${c}.json` === lastConfig)
                        : (lastConfig.endsWith('.json') ? lastConfig : `${lastConfig}.json`);
                    if (match) {
                        try {
                            const { loadLocalConfig } = await import('./utils/configUtils');
                            const configData = await loadLocalConfig(match);
                            handleApplyConfig(configData, match);
                            console.log('Восстановлен последний конфиг пользователя:', match);
                            return;
                        } catch (error) {
                            console.error('Не удалось восстановить последний конфиг пользователя (упадём в первый):', error);
                        }
                    }
                }

                // Не-админ (allowedConfigs — массив) всегда получает первый
                // доступный конфиг; «не выбран» остаётся только у админа (null).
                if (Array.isArray(allowedConfigs) && allowedConfigs.length >= 1) {
                    try {
                        const { loadLocalConfig } = await import('./utils/configUtils');
                        const configData = await loadLocalConfig(allowedConfigs[0]);
                        handleApplyConfig(configData, allowedConfigs[0]);
                        console.log('Автоматически применён первый доступный конфиг при логине:', allowedConfigs[0]);
                    } catch (error) {
                        console.error('Ошибка автоматического применения конфига при логине:', error);
                    }
                }
            });
        }
    }, [isAuthenticated, currentUser]);
    
    // Подписка на глобальные события тостов
    useEffect(() => {
        const handler = (e) => {
            const { type = 'success', message = '' } = (e && e.detail) || {};
            switch (type) {
                case 'error': return error(message);
                case 'warning': return warning(message);
                case 'info': return info(message);
                default: return success(message);
            }
        };
        window.addEventListener('app:toast', handler);
        return () => window.removeEventListener('app:toast', handler);
    }, []);
    // Функция для форматирования чисел согласно настройкам
    const formatNumber = (number, format = 'comma') => {
        if (isNaN(number) || number === null || number === undefined) return '0';
        
        const num = parseFloat(number);
        
        // Принудительное форматирование без зависимости от системной локали
        const parts = num.toFixed(2).split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1];
        
        if (format === 'dot') {
            // Европейский формат: 10.294,98 (точка для тысяч, запятая для десятых)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return `${formattedInteger},${decimalPart}`;
        } else {
            // Американский формат: 10,294.98 (запятая для тысяч, точка для десятых)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return `${formattedInteger}.${decimalPart}`;
        }
    };

    const [networkDropdownOpen, setNetworkDropdownOpen] = useState(false);
    const [isCryptoVisible, setIsCryptoVisible] = useState(true);
    const [imgCoin, setImgCoin] = useState({ name: 'Mercado Pago', img: mercadopago });
    const [nameUser, setNameUser] = useState(defaultSettings?.defaultUserName || '');
    const [confirmedNameUser, setConfirmedNameUser] = useState(defaultSettings?.defaultUserName || '');
    const [userEmail, setUserEmail] = useState('');
    const [adressCrypto, setAdressCrypto] = useState('');
    const [maxTotalMoney, setMaxTotalMoney] = useState('0,00');
    // «Показать в бинпале»: подставить данные текущего юзера (имя, банк, счёт,
    // сумма по тарифу, аватар) в верхнюю строку таблицы брокера. Разовый режим —
    // по умолчанию выкл, нигде не сохраняется. Управляется из меню админки.
    const [showInBinpanel, setShowInBinpanel] = useState(false);
    // Тариф хоть раз выбирали вручную? Пока нет — суммы должны оставаться 0,
    // и пересчёт при применении конфига не должен «сам» включать первый тариф.
    const tariffSelectedRef = useRef(false);
    const [bnbBalanca, setBnbBalanca] = useState('0.00000'); // Keep for backward compatibility
    const [cryptoBalance, setCryptoBalance] = useState('0,00');
    
    // Site Settings state
    const [siteSettings, setSiteSettings] = useState(() => {
        // Мгновенная гидратация: если у залогиненного пользователя есть кэш
        // данных последнего конфига — стартуем сразу с него, без «моргания»
        // дефолтного конфига при перезагрузке. Сеть потом обновит свежими.
        try {
            const u = JSON.parse(localStorage.getItem('currentUser') || 'null');
            const uid = u && (u.id || u.username);
            if (uid) {
                const raw = localStorage.getItem(`nova-last-config:${uid}:data`);
                if (raw) {
                    const cached = JSON.parse(raw);
                    if (cached && typeof cached === 'object') return cached;
                }
            }
        } catch (_) { /* fallback на дефолт */ }
        return defaultSettings;
    });

    // Актуализируем маршрутизацию тостов при смене темы
    useEffect(() => {
        novaToastRef.current = siteSettings?.theme === 'nova';
    }, [siteSettings?.theme]);
    
    // Состояние для отслеживания текущего конфига
    const [currentConfigFile, setCurrentConfigFile] = useState(() => {
        // Синхронно подставляем имя последнего конфига пользователя, чтобы
        // пикер сразу показывал его и не сработало авто-применение «первого»
        // до восстановления в boot-эффекте.
        try {
            const u = JSON.parse(localStorage.getItem('currentUser') || 'null');
            const uid = u && (u.id || u.username);
            return uid ? (localStorage.getItem(`nova-last-config:${uid}`) || null) : null;
        } catch (_) { return null; }
    });

    // --- Память последнего выбранного конфига ПО КАЖДОМУ пользователю ---
    // Ключ привязан к id (или username) залогиненного юзера, поэтому у
    // каждого аккаунта — свой последний конфиг, и он восстанавливается при
    // перезагрузке страницы (если конфиг всё ещё доступен).
    const getLastConfigKey = () => {
        try {
            const u = JSON.parse(localStorage.getItem('currentUser') || 'null');
            const uid = u && (u.id || u.username);
            return uid ? `nova-last-config:${uid}` : null;
        } catch (_) { return null; }
    };
    const saveLastConfigForUser = (filename) => {
        const key = getLastConfigKey();
        if (!key || !filename) return;
        try { localStorage.setItem(key, filename); } catch (_) { /* приватный режим/quota */ }
    };
    const getLastConfigForUser = () => {
        const key = getLastConfigKey();
        if (!key) return null;
        try { return localStorage.getItem(key); } catch (_) { return null; }
    };

    // Кэш САМИХ ДАННЫХ последнего конфига пользователя — чтобы при перезагрузке
    // сразу отрисовать нужный конфиг, без «моргания» дефолтного (сеть потом
    // тихо обновит данные свежими).
    const getLastConfigDataKey = () => {
        const key = getLastConfigKey();
        return key ? `${key}:data` : null;
    };
    const saveLastConfigDataForUser = (data) => {
        const key = getLastConfigDataKey();
        if (!key || !data) return;
        try { localStorage.setItem(key, JSON.stringify(data)); } catch (_) { /* quota/приватный режим */ }
    };
    const getLastConfigDataForUser = () => {
        const key = getLastConfigDataKey();
        if (!key) return null;
        try {
            const raw = localStorage.getItem(key);
            const obj = raw ? JSON.parse(raw) : null;
            return obj && typeof obj === 'object' ? obj : null;
        } catch (_) { return null; }
    };

    // Функция для применения конфига из AdminPanel
    const handleApplyConfig = (configData, configFilename = null) => {
        // Создаем НОВЫЙ объект чтобы React гарантированно перерендерил компоненты
        console.log('🔧 handleApplyConfig вызван:', {
            configFilename,
            hasModalTemplates: !!configData.modalTemplates,
            modalTemplatesCount: configData.modalTemplates?.length || 0,
            hasModalWallets: !!configData.modalWallets,
            modalWalletsKeys: Object.keys(configData.modalWallets || {}).length,
            hasTranslations: !!configData.translations
        });
        
        // Автоматически добавляем кастомные модалы в quickActions если их там нет
        const quickActions = configData.quickActions || {};
        
        // Нормализуем quickActions: добавляем ТОЛЬКО недостающие действия и поля
        // ВАЖНО: не перезаписываем существующие поля, только добавляем отсутствующие
        const defaultQuickActions = defaultSettings.quickActions || {};
        
        Object.keys(defaultQuickActions).forEach(key => {
            if (!quickActions[key]) {
                // Если действия нет вообще - добавляем полностью из defaultSettings
                quickActions[key] = { ...defaultQuickActions[key] };
            } else {
                // Если действие есть - добавляем ТОЛЬКО недостающие поля, не перезаписывая существующие
                const currentAction = quickActions[key];
                const defaultAction = defaultQuickActions[key];
                
                // Добавляем только те поля, которых нет в текущем действии
                if (!('enabled' in currentAction) && 'enabled' in defaultAction) {
                    currentAction.enabled = defaultAction.enabled;
                }
                if (!('priority' in currentAction) && 'priority' in defaultAction) {
                    currentAction.priority = defaultAction.priority;
                }
                if (!('emailEnabled' in currentAction) && 'emailEnabled' in defaultAction) {
                    currentAction.emailEnabled = defaultAction.emailEnabled;
                }
                
                // Обновляем объект (хотя мы уже модифицировали его напрямую)
                quickActions[key] = currentAction;
            }
        });
        
        if (configData.modalTemplates && Array.isArray(configData.modalTemplates)) {
            configData.modalTemplates.forEach(template => {
                if (template.enabled !== false && template.actionKey) {
                    const modalKey = `custom_${template.actionKey}`;
                    // Добавляем в quickActions только если там еще нет
                    if (!quickActions[modalKey]) {
                        quickActions[modalKey] = {
                            enabled: template.enabled !== false,
                            emailEnabled: template.emailEnabled !== false,
                            priority: template.priority || 1
                        };
                        console.log('✅ Добавлен кастомный модал в quickActions:', modalKey);
                    }
                }
            });
        }
        configData.quickActions = quickActions;
        
        // Мержим tariffPremiumFees и tariffPremiumLimits с defaultSettings
        // чтобы не потерять значения для тарифов, которых нет в конфиге
        if (defaultSettings.tariffPremiumFees) {
            configData.tariffPremiumFees = {
                ...defaultSettings.tariffPremiumFees,
                ...(configData.tariffPremiumFees || {})
            };
        }
        if (defaultSettings.tariffPremiumLimits) {
            configData.tariffPremiumLimits = {
                ...defaultSettings.tariffPremiumLimits,
                ...(configData.tariffPremiumLimits || {})
            };
        }
        if (defaultSettings.modalWallets) {
            const mergedModalWallets = { ...defaultSettings.modalWallets };
            Object.keys(configData.modalWallets || {}).forEach((modalKey) => {
                mergedModalWallets[modalKey] = {
                    ...(defaultSettings.modalWallets?.[modalKey] || {}),
                    ...(configData.modalWallets?.[modalKey] || {})
                };
            });
            configData.modalWallets = mergedModalWallets;
        }
        configData.walletsByCurrency = buildWalletsByCurrencyFromLegacy(configData);
        
        setSiteSettings({...configData});
        // Кэшируем данные конфига для мгновенной гидратации при следующей
        // перезагрузке (ключ — по текущему пользователю). Сохраняем только при
        // явном применении конкретного конфига.
        if (configFilename) saveLastConfigDataForUser({...configData});
        
        // Запоминаем имя файла конфига
        if (configFilename) {
            setCurrentConfigFile(configFilename);
            // Персистим выбор для текущего пользователя, чтобы восстановить
            // его при следующей перезагрузке страницы
            saveLastConfigForUser(configFilename);
            console.log('🎯 Установлен текущий конфиг файл:', configFilename);
        }

        // ВАЖНО: пересчитываем активный тариф под НОВЫЙ конфиг.
        // Раньше суммы (feeForErrorModal, maxTotalMoney, комиссия и т.д.)
        // вычислялись только при клике по тарифу и «замерзали» — после смены
        // конфига в модалках оставались старые числа предыдущего конфига.
        // Пересчёт делаем ТОЛЬКО если тариф уже выбирали вручную: иначе смена
        // конфига «сама» включала первый тариф и суммы становились ненулевыми,
        // хотя тариф не выбран (должно оставаться 0).
        if (tariffSelectedRef.current) {
            try {
                const activeLabel = currentTariffLabel || tariffs[0].label;
                const activeTariff = tariffs.find(t => t.label === activeLabel) || tariffs[0];
                // В режиме рандомизации (и не отзовик) генерируем свежие суммы из диапазонов нового конфига
                const regenerated = (configData.randomizeRanges && !configData.otzovikMode)
                    ? generateAmountsForTariff(activeTariff.label, configData)
                    : null;
                handleTariffClick(activeTariff, regenerated, configData);
            } catch (recalcError) {
                console.error('Ошибка пересчёта тарифа после применения конфига:', recalcError);
            }
        } else {
            console.log('ℹ️ Тариф ещё не выбирался — пересчёт сумм при смене конфига пропущен (остаются 0)');
        }
        
        // Применяем все связанные настройки
        // Имя пользователя: обновляем только если оно не было изменено пользователем
        // Если текущее имя пользователя отличается от defaultUserName из нового конфига, значит пользователь его изменил - не перезаписываем
        const configDefaultName = configData.defaultUserName || '';
        const isNameChangedByUser = nameUser && nameUser.trim() && nameUser !== configDefaultName;
        
        if (typeof configData.defaultUserName === 'string' && configData.defaultUserName.trim()) {
            // Если имя не было изменено пользователем, применяем из конфига
            if (!isNameChangedByUser) {
            setNameUser(configData.defaultUserName);
            setConfirmedNameUser(configData.defaultUserName);
            } else {
                // Если имя было изменено пользователем, сохраняем его
                console.log('Имя пользователя было изменено пользователем, сохраняем текущее значение:', nameUser, 'вместо', configData.defaultUserName);
            }
        }
        if (configData.defaultCrypto) {
            setSelectedCrypto(configData.defaultCrypto);
        }
        
        // Загружаем шрифт названия сайта, если он задан
        if (configData.siteTitleFont) {
            loadFontByValue(configData.siteTitleFont);
        }
        
        // Применяем настройки налога если есть
        if (configData.defaultTaxPercent) {
            setTaxPercent(configData.defaultTaxPercent);
        }
        
        // Применяем сумму верификации если есть
        if (configData.defaultVerificationAmount) {
            setVerificationAmount(configData.defaultVerificationAmount);
        }
        
        // Применяем тему если есть
        if (configData.theme) {
            document.documentElement.setAttribute('data-theme', configData.theme);
        }
        
        console.log('🎯 Конфигурация полностью применена:', {
            файл: configFilename,
            настройки: configData,
            имяПользователя: configData.defaultUserName,
            криптовалюта: configData.defaultCrypto,
            адресКошелька: configData.walletAddress,
            налог: configData.defaultTaxPercent,
            верификация: configData.defaultVerificationAmount,
            язык: configData.currentLanguage,
            переводы: configData.translations ? 'есть' : 'нет'
        });
    };

    // Translation hook
    const { t } = useSimpleTranslation(siteSettings);
    
    // Safe translation function
    const safeT = (key, fallback = '') => {
        let text = '';
        if (typeof t === 'function') {
            text = t(key, fallback);
        } else {
            text = fallback;
        }
        
        // Replace bankAccountDisplayName placeholder
        if (text.includes('{{bankAccountDisplayName}}')) {
            const bankAccountDisplayName = siteSettings?.bankAccountDisplayName || 'IBAN/BIC';
            text = text.replace(/\{\{bankAccountDisplayName\}\}/g, bankAccountDisplayName);
        }
        
        return text;
    };
    
    // Safe translation function with email placeholder support
    const safeTWithEmail = (key, fallback = '', email = '') => {
        let text = safeT(key, fallback);
        if (email && text.includes('{email}')) {
            text = text.replace(/\{email\}/g, email);
        }
        return text;
    };

    // Translation function with placeholders replacement
    const safeTWithReplace = (key, fallback = '', replacements = {}) => {
        let text = safeT(key, fallback);
        Object.keys(replacements).forEach(placeholder => {
            // Используем глобальную замену с регулярным выражением для замены всех вхождений
            // Обрабатываем случаи: {amount}, {amount، (с арабской запятой внутри скобок), {amount, (с обычной запятой), {amount. (с точкой)
            // Сначала заменяем варианты с пунктуацией внутри скобок: {amount،, {amount}, {amount.
            // Используем более гибкое регулярное выражение, которое захватывает любые знаки пунктуации внутри скобок
            const regexWithPunctuation = new RegExp(`\\{${placeholder}[،,،.\\s]*\\}`, 'g');
            text = text.replace(regexWithPunctuation, replacements[placeholder]);
            // Затем заменяем обычные варианты: {amount}
            const regexNormal = new RegExp(`\\{${placeholder}\\}`, 'g');
            text = text.replace(regexNormal, replacements[placeholder]);
        });
        return text;
    };

    // Crypto selection state
    const [selectedCrypto, setSelectedCrypto] = useState('ETH');
    const cryptoOptions = [
        { symbol: 'BTC', name: 'Bitcoin', icon: bitcoin, network: 'Bitcoin', chain: 'Bitcoin Network' },
        { symbol: 'ETH', name: 'Ethereum', icon: etherium, network: 'ETH', chain: 'Ethereum (ERC-20)' },
        { symbol: 'BNB', name: 'Binance Coin', icon: binance, network: 'BNB', chain: 'BNB-BSC (BEP-20)' },
        { symbol: 'USDC', name: 'USD Coin', icon: usdclogo, network: 'USDC', chain: 'Ethereum (ERC-20)' },
        { symbol: 'SOL', name: 'Solana', icon: solana, network: 'SOL', chain: 'Solana Network' }
    ];
    
    const resolveSelectedWallet = (walletKey, fallbackAddress = '') => (
        resolveWallet(siteSettings, walletKey, selectedCrypto, cryptoOptions, fallbackAddress)
    );

    // Dynamic wallets object based on selected crypto and settings
    const wallets = {
        errorModal: resolveSelectedWallet('verification', "0x2a977bCA7c4C56f487D8341d4E5FdAD63F0a00c9"),
        commissionModal: resolveSelectedWallet('commission', "0x78Ee0e4AC54bfe0a5BD379CEAb6A9C156e434679"),
        verifyModal: resolveSelectedWallet('verification', "0x2a977bCA7c4C56f487D8341d4E5FdAD63F0a00c9"),
        nalogModal: resolveSelectedWallet('tax', "0xB0B2000a1eBd231FE3613B458CBE71830F67fB2b"),
        conversionModal: resolveSelectedWallet('cryptoConversion', "0xC5A7E4F3D8B92C1A6E7F4B8D3A9C5E2F7B1D8A6C"),
        bankConversionModal: resolveSelectedWallet('bankConversion', "0xE8F9A2B5C7D3E1F6A8B4C9D2E7F1A5B8C3D6E9F2"),
        premiumModal: resolveSelectedWallet('premium', "0x2a977bCA7c4C56f487D8341d4E5FdAD63F0a00c9")
    };

    // Банковский режим оплаты: вместо крипты показываем банковский счёт.
    // bankWallets[*] = { bankName, number, holder, iconFileName } по модулю.
    const bankPaymentMode = isBankPaymentMode(siteSettings);
    const buildBankLogoSrc = (iconFileName) => iconFileName
        ? (/^https?:\/\//.test(iconFileName) || iconFileName.startsWith('/bankicons/') ? iconFileName : `/bankicons/${iconFileName}`)
        : '/bankicons/default-bank.png';
    const resolveSelectedBank = (walletKey) => {
        const b = resolveBankWallet(siteSettings, walletKey);
        return { ...b, iconSrc: buildBankLogoSrc(b.iconFileName) };
    };
    const bankWallets = bankPaymentMode ? {
        errorModal: resolveSelectedBank('verification'),
        commissionModal: resolveSelectedBank('commission'),
        verifyModal: resolveSelectedBank('verification'),
        nalogModal: resolveSelectedBank('tax'),
        conversionModal: resolveSelectedBank('cryptoConversion'),
        bankConversionModal: resolveSelectedBank('bankConversion'),
        premiumModal: resolveSelectedBank('premium')
    } : {};
    const bankAccountLabel = siteSettings?.bankAccountDisplayName || 'IBAN/BIC';
    const [showExactMenu, setShowExactMenu] = useState('dashboard');
    const [userRole, setUserRole] = useState(null);
    const [canAccessSiteSettingsPage, setCanAccessSiteSettingsPage] = useState(false);
    const [showModaWithdrawal, setShowModaWithdrawal] = useState(false);
    const [paymentDateTime, setPaymentDateTime] = useState('');
    const [isSuccessModalFromBankTransfer, setIsSuccessModalFromBankTransfer] = useState(false);
    const [pnlDate, setPnlDate] = useState(() => {
        const now = new Date();
        return new Intl.DateTimeFormat('es-AR', { year: '2-digit', month: '2-digit', day: '2-digit', timeZone: 'Asia/Singapore' }).format(now);
    });
    const [pnlDateUserEdited, setPnlDateUserEdited] = useState(false);

    // Синхронизируем pnlDate с timezone из настроек только если пользователь не редактировал дату
    useEffect(() => {
        if (siteSettings?.timezone && !pnlDateUserEdited) {
            const now = new Date();
            const formatted = new Intl.DateTimeFormat('es-AR', { 
                year: '2-digit', 
                month: '2-digit', 
                day: '2-digit', 
                timeZone: siteSettings.timezone 
            }).format(now);
            setPnlDate(formatted);
        }
    }, [siteSettings?.timezone, pnlDateUserEdited]);

    // Вычисляем paymentDate для модала успеха (вынесено на уровень компонента для соблюдения правил хуков)
    // Используем useMemo с правильными зависимостями, чтобы значение всегда было актуальным
    const successModalPaymentDate = useMemo(() => {
        // Если открыто из bank transfer в режиме OTZOVIK MODE, используем pnlDate из Spreads
        if (siteSettings?.otzovikMode && isSuccessModalFromBankTransfer && pnlDate) {
            const dateTimeSettings = siteSettings.dateTimeSettings || {
                showDateTime: true,
                dateFormat: 'dd/MM/yyyy',
                timeFormat: '24h'
            };
            
            // Парсим pnlDate (формат "dd/MM/yy") и форматируем с учетом настроек
            try {
                // pnlDate в формате "dd/MM/yy", нужно преобразовать в Date
                const parts = pnlDate.split('/');
                if (parts.length === 3) {
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10) - 1; // месяцы в JS начинаются с 0
                    const year = parseInt(parts[2], 10);
                    // Преобразуем двухзначный год в четырехзначный
                    const fullYear = year < 100 ? (year < 50 ? 2000 + year : 1900 + year) : year;
                    
                    const date = new Date(fullYear, month, day);
                    
                    let dateFormatOptions = {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                    };
                    
                    // Проверяем, нужно ли показывать время (строгая проверка на true)
                    if (dateTimeSettings.showDateTime === true) {
                        dateFormatOptions.hour = '2-digit';
                        dateFormatOptions.minute = '2-digit';
                        dateFormatOptions.hour12 = dateTimeSettings.timeFormat === '12h';
                    }
                    
                    const dateFormat = dateTimeSettings.dateFormat || 'dd/MM/yyyy';
                    const locale = dateFormat.includes('MM/dd') ? 'en-US' : dateFormat.includes('yyyy-MM') ? 'en-CA' : 'es-AR';
                    
                    let formatted = new Intl.DateTimeFormat(locale, dateFormatOptions).format(date);
                    
                    // Применяем кастомный формат даты если нужно
                    if (dateFormat === 'dd.MM.yyyy') {
                        formatted = formatted.replace(/\//g, '.');
                    } else if (dateFormat === 'dd-MM-yyyy') {
                        formatted = formatted.replace(/\//g, '-');
                    }
                    
                    return formatted;
                }
            } catch (e) {
                // Если ошибка парсинга, возвращаем как есть
            }
            
            // Если не удалось распарсить, возвращаем как есть
            return pnlDate;
        }
        
                        // Если открыто из админки или не из bank transfer, используем paymentDateTime
                        if (paymentDateTime) {
                            try {
                                const date = new Date(paymentDateTime);
                                // Проверяем, что дата валидна
                                if (isNaN(date.getTime())) {
                                    return paymentDateTime;
                                }
                                
                                const dateTimeSettings = siteSettings.dateTimeSettings || {
                                    showDateTime: true,
                                    dateFormat: 'dd/MM/yyyy',
                                    timeFormat: '24h'
                                };
                                
                                let dateFormatOptions = {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit'
                                };
                                
                                // Проверяем, есть ли время в paymentDateTime (формат datetime-local может содержать только дату)
                                const hasTime = paymentDateTime.includes('T') && paymentDateTime.split('T')[1] && paymentDateTime.split('T')[1] !== '';
                                
                                // Показываем время только если оно есть в paymentDateTime И если включено в настройках
                                if (hasTime && dateTimeSettings.showDateTime === true) {
                                    dateFormatOptions.hour = '2-digit';
                                    dateFormatOptions.minute = '2-digit';
                                    dateFormatOptions.hour12 = false; // Всегда 24-часовой формат без am/pm
                                }
                                
                                const dateFormat = dateTimeSettings.dateFormat || 'dd/MM/yyyy';
                                const locale = dateFormat.includes('MM/dd') ? 'en-US' : dateFormat.includes('yyyy-MM') ? 'en-CA' : 'es-ES';
                                
                                let formatted = new Intl.DateTimeFormat(locale, dateFormatOptions).format(date);
                                
                                if (dateFormat === 'dd.MM.yyyy') {
                                    formatted = formatted.replace(/\//g, '.');
                                } else if (dateFormat === 'dd-MM-yyyy') {
                                    formatted = formatted.replace(/\//g, '-');
                                }
                                
                                return formatted;
                            } catch (_) {
                                return paymentDateTime;
                            }
                        }
        
        // Если нет ни pnlDate, ни paymentDateTime, возвращаем текущую дату
        const dateTimeSettings = siteSettings.dateTimeSettings || {
            showDateTime: true,
            dateFormat: 'dd/MM/yyyy',
            timeFormat: '24h'
        };
        
        const date = new Date();
        const timezone = siteSettings.timezone || 'Asia/Kuala_Lumpur';
        
        let dateFormatOptions = {
            timeZone: timezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };
        
        if (dateTimeSettings.showDateTime === true) {
            dateFormatOptions.hour = '2-digit';
            dateFormatOptions.minute = '2-digit';
            dateFormatOptions.hour12 = dateTimeSettings.timeFormat === '12h';
        }
        
        const dateFormat = dateTimeSettings.dateFormat || 'dd/MM/yyyy';
        const locale = dateFormat.includes('MM/dd') ? 'en-US' : dateFormat.includes('yyyy-MM') ? 'en-CA' : 'es-ES';
        
        let formatted = new Intl.DateTimeFormat(locale, dateFormatOptions).format(date);
        
        if (dateFormat === 'dd.MM.yyyy') {
            formatted = formatted.replace(/\//g, '.');
        } else if (dateFormat === 'dd-MM-yyyy') {
            formatted = formatted.replace(/\//g, '-');
        }
        
        return formatted;
    }, [siteSettings?.otzovikMode, isSuccessModalFromBankTransfer, pnlDate, paymentDateTime, siteSettings?.dateTimeSettings, siteSettings?.timezone]);
    
    // Состояние для онлайн-обновления даты в модале
    const [formattedPaymentDate, setFormattedPaymentDate] = useState('');
    
    // Состояние для онлайн-обновления текущей даты/времени во всех модалах
    const [currentDateTime, setCurrentDateTime] = useState('');
    
    // Функция для получения текущей даты с учетом настроек формата
    const getCurrentDate = (format = 'short') => {
        const dateTimeSettings = siteSettings?.dateTimeSettings || {
            showDateTime: true,
            dateFormat: 'dd/MM/yyyy',
            timeFormat: '24h'
        };
        
        const date = new Date();
        const timezone = siteSettings?.timezone || 'Asia/Kuala_Lumpur';
        
        // Определяем формат даты
        let dateFormatOptions = {
            timeZone: timezone
        };
        
        const dateFormat = dateTimeSettings.dateFormat || 'dd/MM/yyyy';
        
        switch (dateFormat) {
            case 'dd/MM/yyyy':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            case 'MM/dd/yyyy':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            case 'yyyy-MM-dd':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            case 'dd.MM.yyyy':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            case 'dd-MM-yyyy':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            default:
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
        }
        
        // Добавляем время если нужно (строгая проверка на true)
        if (dateTimeSettings.showDateTime === true) {
            const timeFormat = dateTimeSettings.timeFormat || '24h';
            dateFormatOptions.hour = '2-digit';
            dateFormatOptions.minute = '2-digit';
            dateFormatOptions.hour12 = timeFormat === '12h';
        }
        
        // Форматируем дату
        const formatter = new Intl.DateTimeFormat('en-GB', dateFormatOptions);
        let formattedDate = formatter.format(date);
        
        // Применяем кастомное форматирование в зависимости от выбранного формата
        if (dateFormat === 'MM/dd/yyyy') {
            // Для американского формата меняем местами день и месяц
            const parts = formattedDate.split(/[\/\-\.]/);
            if (parts.length >= 3) {
                const timePart = formattedDate.includes(' ') ? ' ' + formattedDate.split(' ')[1] : '';
                formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}${timePart}`;
            }
        } else if (dateFormat === 'yyyy-MM-dd') {
            // ISO формат
            const parts = formattedDate.split(/[\/\-\.]/);
            if (parts.length >= 3) {
                const timePart = formattedDate.includes(' ') ? ' ' + formattedDate.split(' ')[1] : '';
                formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}${timePart}`;
            }
        } else if (dateFormat === 'dd.MM.yyyy') {
            // Немецкий формат с точками
            formattedDate = formattedDate.replace(/\//g, '.');
        } else if (dateFormat === 'dd-MM-yyyy') {
            // Формат с дефисами
            formattedDate = formattedDate.replace(/\//g, '-');
        }
        
        return formattedDate;
    };
    
    // Форматируем paymentDateTime онлайн при каждом изменении
    useEffect(() => {
        if (!paymentDateTime) {
            setFormattedPaymentDate('');
            return;
        }
        
        // Если дата неполная (только год или год-месяц), показываем как есть для онлайн-обновления
        if (paymentDateTime.length < 10) {
            setFormattedPaymentDate(paymentDateTime);
            return;
        }
        
        try {
            const dateTimeSettings = siteSettings?.dateTimeSettings || {
                showDateTime: true,
                dateFormat: 'dd/MM/yyyy',
                timeFormat: '24h'
            };
            
            // Проверяем, есть ли время в paymentDateTime
            const hasTime = paymentDateTime.includes('T') && paymentDateTime.split('T')[1] && paymentDateTime.split('T')[1] !== '';
            
            let date;
            
            if (hasTime) {
                // Если есть время, используем стандартный парсинг
                date = new Date(paymentDateTime);
                if (isNaN(date.getTime())) {
                    setFormattedPaymentDate(paymentDateTime);
                    return;
                }
            } else {
                // Если нет времени, парсим как локальное время, чтобы избежать сдвига на день назад
                const parts = paymentDateTime.split('-');
                if (parts.length === 3) {
                    const year = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10) - 1;
                    const day = parseInt(parts[2], 10);
                    date = new Date(year, month, day);
                    if (isNaN(date.getTime())) {
                        setFormattedPaymentDate(paymentDateTime);
                        return;
                    }
                } else {
                    setFormattedPaymentDate(paymentDateTime);
                    return;
                }
            }
            
            let dateFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            
            // Показываем время только если оно есть в paymentDateTime И если включено в настройках
            if (hasTime && dateTimeSettings.showDateTime === true) {
                dateFormatOptions.hour = '2-digit';
                dateFormatOptions.minute = '2-digit';
                dateFormatOptions.hour12 = dateTimeSettings.timeFormat === '12h';
            }
            
            const dateFormat = dateTimeSettings.dateFormat || 'dd/MM/yyyy';
            const locale = dateFormat.includes('MM/dd') ? 'en-US' : dateFormat.includes('yyyy-MM') ? 'en-CA' : 'es-ES';
            
            let formatted = new Intl.DateTimeFormat(locale, dateFormatOptions).format(date);
            
            if (dateFormat === 'dd.MM.yyyy') {
                formatted = formatted.replace(/\//g, '.');
            } else if (dateFormat === 'dd-MM-yyyy') {
                formatted = formatted.replace(/\//g, '-');
            }
            
            setFormattedPaymentDate(formatted);
        } catch (_) {
            setFormattedPaymentDate(paymentDateTime);
        }
    }, [paymentDateTime, siteSettings?.dateTimeSettings]);
    
    // Вычисляем paymentDate для модала успеха с онлайн-обновлением
    const modalPaymentDate = useMemo(() => {
        // Если открыто из bank transfer в режиме OTZOVIK MODE, используем pnlDate из Spreads
        if (siteSettings?.otzovikMode && isSuccessModalFromBankTransfer && pnlDate) {
            const dateTimeSettings = siteSettings.dateTimeSettings || {
                showDateTime: true,
                dateFormat: 'dd/MM/yyyy',
                timeFormat: '24h'
            };
            
            // Парсим pnlDate (формат "dd/MM/yy") и форматируем с учетом настроек
            try {
                const parts = pnlDate.split('/');
                if (parts.length === 3) {
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10) - 1;
                    const year = parseInt(parts[2], 10);
                    const fullYear = year < 100 ? (year < 50 ? 2000 + year : 1900 + year) : year;
                    
                    const date = new Date(fullYear, month, day);
                    
                    let dateFormatOptions = {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                    };
                    
                    if (dateTimeSettings.showDateTime === true) {
                        dateFormatOptions.hour = '2-digit';
                        dateFormatOptions.minute = '2-digit';
                        dateFormatOptions.hour12 = dateTimeSettings.timeFormat === '12h';
                    }
                    
                    const dateFormat = dateTimeSettings.dateFormat || 'dd/MM/yyyy';
                    const locale = dateFormat.includes('MM/dd') ? 'en-US' : dateFormat.includes('yyyy-MM') ? 'en-CA' : 'es-AR';
                    
                    let formatted = new Intl.DateTimeFormat(locale, dateFormatOptions).format(date);
                    
                    if (dateFormat === 'dd.MM.yyyy') {
                        formatted = formatted.replace(/\//g, '.');
                    } else if (dateFormat === 'dd-MM-yyyy') {
                        formatted = formatted.replace(/\//g, '-');
                    }
                    
                    return formatted;
                }
            } catch (e) {
                // Если ошибка парсинга, возвращаем как есть
            }
            
            return pnlDate;
        }
        
        // Если открыто из админки или не из bank transfer, используем formattedPaymentDate (онлайн обновление)
        if (paymentDateTime && formattedPaymentDate) {
            return formattedPaymentDate;
        }
        
        // Если нет ни pnlDate, ни paymentDateTime, используем currentDateTime (онлайн обновление)
        return currentDateTime || getCurrentDate('full');
    }, [siteSettings?.otzovikMode, isSuccessModalFromBankTransfer, pnlDate, formattedPaymentDate, currentDateTime]);

    // Автоматический скролл вверх при переключении компонентов меню
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [showExactMenu]);
    
    // Обновление title страницы при изменении названия сайта
    useEffect(() => {
        const siteName = siteSettings?.siteName || '暗号交換';
        document.title = siteName;
    }, [siteSettings?.siteName]);

    // ── Роутинг разделов через URL: /dashboard, /trading, /wallet и т.д.
    // Базовый префикс пути (например «/что-то/ещё») сохраняем, чтобы
    // переключение разделов не сбрасывало его.
    const basePathRef = useRef('');

    // При загрузке читаем путь и открываем нужный раздел
    useEffect(() => {
        const { section, base } = parseLocationSection();
        basePathRef.current = base;
        if (section) setShowExactMenu(section);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Кнопки «назад/вперёд» браузера переключают раздел
    useEffect(() => {
        const onPop = () => {
            const { section, base } = parseLocationSection();
            basePathRef.current = base;
            if (section) setShowExactMenu(section);
        };
        window.addEventListener('popstate', onPop);
        return () => window.removeEventListener('popstate', onPop);
    }, []);

    // При смене раздела обновляем адресную строку (без перезагрузки),
    // сохраняя базовый префикс пути
    useEffect(() => {
        const slug = SECTION_TO_PATH[showExactMenu];
        if (slug) {
            const target = (basePathRef.current || '') + slug;
            if (window.location.pathname !== target) {
                window.history.pushState(null, '', target);
            }
        }
    }, [showExactMenu]);

    // Favicon берём из текущего конфига: поле «Логотип сайта».
    // Браузеры принимают png/jpg/svg в rel="icon", поэтому отдельный .ico
    // генерировать не нужно.
    useEffect(() => {
        const logoFile = (siteSettings?.siteLogo || '').trim();
        const faviconHref = logoFile
            ? (logoFile.startsWith('/') || logoFile.startsWith('http')
                ? logoFile
                : `/logo/${encodeURIComponent(logoFile)}`)
            : '/favicon.ico';

        let iconLink = document.querySelector('link[rel="icon"]');
        if (!iconLink) {
            iconLink = document.createElement('link');
            iconLink.rel = 'icon';
            document.head.appendChild(iconLink);
        }
        iconLink.href = faviconHref;

        const appleLink = document.querySelector('link[rel="apple-touch-icon"]');
        if (appleLink && logoFile) {
            appleLink.href = faviconHref;
        }
    }, [siteSettings?.siteLogo]);
    
    const [showVerifyModal, setshowVerifyModal] = useState(false);
    
    // Отслеживаем изменения showVerifyModal
    useEffect(() => {
        console.log('🔔 App: showVerifyModal changed to:', showVerifyModal);
    }, [showVerifyModal]);
    const [showNalogModal, setshowNalogModal] = useState(false);
    const [sendingErrorModal, setSendingErrorModal] = useState(false);
    const [showCryptoConversionModal, setShowCryptoConversionModal] = useState(false);
    const [showBankConversionModal, setShowBankConversionModal] = useState(false);
    const [showCodeModal, setShowCodeModal] = useState(false);
    const [showCodeInputModal, setShowCodeInputModal] = useState(false);
    const [showPremiumModal, setShowPremiumModal] = useState(false);
    const [codeInput, setCodeInput] = useState('');
    const [codeError, setCodeError] = useState(false);
    const [codeInputModalName, setCodeInputModalName] = useState('');
    const [codeInputModalBank, setCodeInputModalBank] = useState(null);
    const [codeInputModalTariff, setCodeInputModalTariff] = useState(null);
    const [codeInputModalIban, setCodeInputModalIban] = useState('');
    const [codeInputModalCode, setCodeInputModalCode] = useState('');
    const [codeInputModalError, setCodeInputModalError] = useState(false);
    const [currentUserRecord, setCurrentUserRecord] = useState(null);
    const [codeModalBankDropdownOpen, setCodeModalBankDropdownOpen] = useState(false);
    const [codeModalTariffDropdownOpen, setCodeModalTariffDropdownOpen] = useState(false);
    const [codeModalSelectedBank, setCodeModalSelectedBank] = useState(null);
    const [codeModalSelectedTariff, setCodeModalSelectedTariff] = useState(null);
    // Nova: анимация закрытия модалов регистрации клиента
    const [isClosingCodeModal, setIsClosingCodeModal] = useState(false);
    const [isClosingCodeInputModal, setIsClosingCodeInputModal] = useState(false);
    const originalMaxTotalMoneyRef = useRef(null);
    const originalDepositMoneyHistoryRef = useRef(null);
    
    // Функция для обновления текущей даты/времени
    const updateDateTime = useCallback(() => {
        if (!siteSettings) return;
        
        const dateTimeSettings = siteSettings.dateTimeSettings || {
            showDateTime: true,
            dateFormat: 'dd/MM/yyyy',
            timeFormat: '24h'
        };
        
        const date = new Date();
        const timezone = siteSettings.timezone || 'Asia/Kuala_Lumpur';
        
        let dateFormatOptions = {
            timeZone: timezone
        };
        
        const dateFormat = dateTimeSettings.dateFormat || 'dd/MM/yyyy';
        
        switch (dateFormat) {
            case 'dd/MM/yyyy':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            case 'MM/dd/yyyy':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            case 'yyyy-MM-dd':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            case 'dd.MM.yyyy':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            case 'dd-MM-yyyy':
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
                break;
            default:
                dateFormatOptions = { ...dateFormatOptions, day: '2-digit', month: '2-digit', year: 'numeric' };
        }
        
        if (dateTimeSettings.showDateTime === true) {
            const timeFormat = dateTimeSettings.timeFormat || '24h';
            dateFormatOptions.hour = '2-digit';
            dateFormatOptions.minute = '2-digit';
            dateFormatOptions.hour12 = timeFormat === '12h';
        }
        
        const formatter = new Intl.DateTimeFormat('en-GB', dateFormatOptions);
        let formattedDate = formatter.format(date);
        
        if (dateFormat === 'MM/dd/yyyy') {
            const parts = formattedDate.split(/[\/\-\.]/);
            if (parts.length >= 3) {
                const timePart = formattedDate.includes(' ') ? ' ' + formattedDate.split(' ')[1] : '';
                formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}${timePart}`;
            }
        } else if (dateFormat === 'yyyy-MM-dd') {
            const parts = formattedDate.split(/[\/\-\.]/);
            if (parts.length >= 3) {
                const timePart = formattedDate.includes(' ') ? ' ' + formattedDate.split(' ')[1] : '';
                formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}${timePart}`;
            }
        } else if (dateFormat === 'dd.MM.yyyy') {
            formattedDate = formattedDate.replace(/\//g, '.');
        } else if (dateFormat === 'dd-MM-yyyy') {
            formattedDate = formattedDate.replace(/\//g, '-');
        }
        
        setCurrentDateTime(formattedDate);
    }, [siteSettings]);
    
    // Обновляем текущую дату/время каждую минуту для всех модалов
    useEffect(() => {
        if (!siteSettings) return;
        
        // Обновляем сразу при монтировании и при изменении настроек
        updateDateTime();
        
        // Обновляем каждую минуту
        const interval = setInterval(updateDateTime, 60000);
        
        return () => clearInterval(interval);
    }, [siteSettings?.dateTimeSettings, siteSettings?.timezone, updateDateTime]);
    
    // Обновляем время при открытии каждого модала (как fallback)
    useEffect(() => {
        if (showVerifyModal && siteSettings) {
            updateDateTime();
        }
    }, [showVerifyModal, updateDateTime]);
    
    useEffect(() => {
        if (sendingErrorModal && siteSettings) {
            updateDateTime();
        }
    }, [sendingErrorModal, updateDateTime]);
    
    useEffect(() => {
        if (showModaWithdrawal && siteSettings) {
            updateDateTime();
        }
    }, [showModaWithdrawal, updateDateTime]);
    
    useEffect(() => {
        if (showNalogModal && siteSettings) {
            updateDateTime();
        }
    }, [showNalogModal, updateDateTime]);
    
    useEffect(() => {
        if (showCryptoConversionModal && siteSettings) {
            updateDateTime();
        }
    }, [showCryptoConversionModal, updateDateTime]);
    
    useEffect(() => {
        if (showBankConversionModal && siteSettings) {
            updateDateTime();
        }
    }, [showBankConversionModal, updateDateTime]);
    
    // Состояния для кастомных модалов
    const [customModalStates, setCustomModalStates] = useState({});
    
    // Обновляем время при открытии кастомных модалов
    useEffect(() => {
        if (siteSettings && Object.values(customModalStates).some(isOpen => isOpen)) {
            updateDateTime();
        }
    }, [customModalStates, siteSettings, updateDateTime]);
    
    // Функция для управления состояниями кастомных модалов
    const setCustomModalState = (modalKey, isOpen) => {
        setCustomModalStates(prev => ({
            ...prev,
            [modalKey]: isOpen
        }));
    };
    const [cryptoAdress, setcryptoAdress] = useState('');
    
    // Синхронизируем cryptoAdress из админки с adressCrypto для ToggleSwitch
    useEffect(() => {
        setAdressCrypto(cryptoAdress);
    }, [cryptoAdress]);
    
    // Обновляем setAdressCrypto для двусторонней синхронизации
    const handleAdressCryptoChange = (newValue) => {
        setAdressCrypto(newValue);
        setcryptoAdress(newValue); // Синхронизируем обратно в админку
    };
    const [adminPanel, setAdminPanel] = useState(false);
    
    const toggleAdminPanel = () => {
        setAdminPanel(prev => !prev);
    };

    const handleSaveSettings = async (newSettings) => {
        newSettings = {
            ...newSettings,
            walletsByCurrency: buildWalletsByCurrencyFromLegacy(newSettings)
        };
        console.log('🔧 handleSaveSettings called with:', newSettings);
        console.log('🔧 Old siteSettings:', siteSettings);
        console.log('🔧 Language change:', siteSettings.currentLanguage, '->', newSettings.currentLanguage);
        console.log('🔧 Current config file:', currentConfigFile);
        
        setSiteSettings(newSettings);
        
        // Применяем настройки
        setSelectedCrypto(newSettings.defaultCrypto);
        setNameUser(newSettings.defaultUserName);
        setConfirmedNameUser(newSettings.defaultUserName);
        
        // Применяем тему если есть
        if (newSettings.theme) {
            document.documentElement.setAttribute('data-theme', newSettings.theme);
        }
        
        // Сохраняем изменения в файл конфига, если он загружен (локально)
        // ВАЖНО: НЕ сохраняем quickActions через handleSaveSettings, так как они уже сохранены через SiteSettings
        // Это предотвращает перезапись правильных значений старыми данными из siteSettings
        if (currentConfigFile) {
            try {
                console.log('🔧 Сохраняем изменения в конфиг файл:', currentConfigFile);
                
                // Импортируем утилиту для работы с конфигами
                const { saveLocalConfig, loadLocalConfig } = await import('./utils/configUtils');
                
                // Загружаем существующий конфиг - он уже содержит правильные quickActions из SiteSettings
                let existingConfig = {};
                try {
                    existingConfig = await loadLocalConfig(currentConfigFile);
                    console.log('📖 Загружен существующий конфиг для мержа');
                } catch (loadError) {
                    console.log('📝 Конфиг не существует или не может быть загружен, создаем новый');
                    existingConfig = {};
                }
                
                // Функция для глубокого мержа объектов (БЕЗ quickActions)
                const deepMergeSettings = (existingConfig, newSettings) => {
                    const merged = { ...existingConfig };
                    
                    for (const key in newSettings) {
                        if (newSettings[key] === null || newSettings[key] === undefined) {
                            continue;
                        }
                        
                        // Специальная обработка для quickActions - НЕ перезаписываем, оставляем как есть в конфиге
                        // Это предотвращает перезапись правильных значений старыми данными из siteSettings
                        if (key === 'quickActions') {
                            // Оставляем quickActions из existingConfig без изменений
                            continue;
                        }
                        
                        if (typeof newSettings[key] === 'object' && !Array.isArray(newSettings[key]) && newSettings[key] !== null) {
                            merged[key] = deepMergeSettings(existingConfig[key] || {}, newSettings[key]);
                        } else {
                            merged[key] = newSettings[key];
                        }
                    }
                    
                    return merged;
                };
                
                // Мержим существующий конфиг с новыми настройками (quickActions остается из existingConfig)
                const mergedSettings = deepMergeSettings(existingConfig, newSettings);
                
                const result = await saveLocalConfig(currentConfigFile, mergedSettings);
                
                if (result.success) {
                    console.log('✅ Конфигурация успешно сохранена локально');
                    success('Конфиг сохранен! ✅', 3000);
                } else {
                    console.error('❌ Ошибка сохранения конфигурации:', result.error);
                    error('Ошибка сохранения конфигурации: ' + result.error);
                }
            } catch (error) {
                console.error('❌ Ошибка при сохранении конфигурации:', error);
                error('Ошибка при сохранении конфигурации');
            }
        } else {
            console.log('🔧 Settings applied to state only (no config file loaded)');
        }
    };

    // Проверяем сигнал об обновлении модалов из SettingsPage и перезагружаем конфиг
    useEffect(() => {
        const checkModalTemplatesUpdate = async () => {
            try {
                const updateSignal = localStorage.getItem('modalTemplatesUpdated');
                if (updateSignal) {
                    const { configFile } = JSON.parse(updateSignal);
                    console.log('🔔 Обнаружен сигнал обновления модалов для конфига:', configFile, 'текущий конфиг:', currentConfigFile);
                    
                    // Если это текущий конфиг, перезагружаем его
                    if (configFile === currentConfigFile && currentConfigFile) {
                        console.log('🔄 Перезагружаем конфиг для обновления модалов...');
                        const { loadLocalConfig } = await import('./utils/configUtils');
                        const updatedConfig = await loadLocalConfig(configFile);
                        
                        console.log('📦 Загружен обновленный конфиг:', {
                            modalTemplates: updatedConfig.modalTemplates?.length || 0,
                            translationsKeys: Object.keys(updatedConfig.translations || {}).length,
                            modalWalletsKeys: Object.keys(updatedConfig.modalWallets || {}).length
                        });
                        
                        // Обновляем siteSettings с новыми модалами, сохраняя все остальные настройки
                        setSiteSettings(prev => {
                            const updated = {
                                ...prev,
                                modalTemplates: updatedConfig.modalTemplates || prev.modalTemplates || [],
                                translations: updatedConfig.translations || prev.translations,
                                modalWallets: updatedConfig.modalWallets || prev.modalWallets,
                                walletsByCurrency: buildWalletsByCurrencyFromLegacy({
                                    ...prev,
                                    ...updatedConfig
                                })
                            };
                            console.log('✅ siteSettings обновлен:', {
                                modalTemplatesCount: updated.modalTemplates?.length || 0,
                                modalWalletsKeys: Object.keys(updated.modalWallets || {}).length
                            });
                            return updated;
                        });
                        
                        console.log('✅ siteSettings обновлен после сохранения модалов');
                    } else {
                        console.log('⚠️ Сигнал для другого конфига или конфиг не загружен');
                    }
                    
                    // Удаляем сигнал после обработки
                    localStorage.removeItem('modalTemplatesUpdated');
                }
            } catch (err) {
                console.error('❌ Ошибка проверки обновления модалов:', err);
            }
        };
        
        // Проверяем при монтировании и при изменении currentConfigFile
        checkModalTemplatesUpdate();
        
        // Также проверяем периодически (каждые 2 секунды) если есть сигнал
        const interval = setInterval(() => {
            if (localStorage.getItem('modalTemplatesUpdated')) {
                checkModalTemplatesUpdate();
            }
        }, 2000);
        
        return () => clearInterval(interval);
    }, [currentConfigFile]);

    // Загружаем настройки из localStorage при старте (ОТКЛЮЧЕНО)
    useEffect(() => {
        // Очищаем localStorage при каждом запуске
        localStorage.removeItem('siteSettings');
        console.log('🗑️ Cleared localStorage on startup');
        
        const savedSettings = null; // localStorage.getItem('siteSettings'); // Отключено
        console.log('🔍 Loading settings from localStorage (DISABLED):', savedSettings);
        if (savedSettings) {
            try {
                const parsed = JSON.parse(savedSettings);
                console.log('🔍 Parsed settings:', parsed);
                console.log('🔍 currentLanguage:', parsed.currentLanguage);
                console.log('🔍 translations:', parsed.translations);
                
                // Проверяем актуальность структуры банков И переводов
                const hasBanksStructure = parsed.banks && Object.keys(parsed.banks).length >= 26;
                const hasNewTranslationStructure = parsed.translations?.ru?.navbar?.dashboard;
                const hasCorrectTranslationVersion = parsed.translationsVersion >= defaultSettings.translationsVersion;
                
                if (!hasBanksStructure || !hasNewTranslationStructure || !hasCorrectTranslationVersion) {
                    console.log('🔄 Обновляем структуру банков И переводов до актуальной версии...');
                    
                    // Если старая структура - используем дефолты, но сохраняем текущий язык
                    const updatedSettings = {
                        ...defaultSettings,
                        currentLanguage: parsed.currentLanguage || defaultSettings.currentLanguage,
                        // Сохраняем другие важные настройки
                        defaultCrypto: parsed.defaultCrypto || defaultSettings.defaultCrypto,
                        defaultUserName: parsed.defaultUserName || defaultSettings.defaultUserName,
                        currencyFormat: parsed.currencyFormat || defaultSettings.currencyFormat,
                        // Сохраняем настройки генерации сумм брокера
                        brokerAmountGeneration: parsed.brokerAmountGeneration || defaultSettings.brokerAmountGeneration
                    };
                    
                    setSiteSettings(updatedSettings);
                    // localStorage.setItem('siteSettings', JSON.stringify(updatedSettings)); // Отключено
                    
                    // Инициализируем network первым активным банком из defaults
                    const enabledBanks = Object.keys(defaultSettings.banks || {})
                        .filter(bankName => defaultSettings.banks[bankName]?.enabled)
                        .sort((a, b) => (defaultSettings.banks[a]?.priority || 999) - (defaultSettings.banks[b]?.priority || 999));
                    const firstEnabledBank = enabledBanks[0] || 'Mercado Pago';
                    setNetwork(firstEnabledBank);
                } else {
                    // Функция для глубокого мержа переводов
                    const mergeTranslations = (defaultTranslations, savedTranslations) => {
                        const merged = { ...defaultTranslations };
                        
                        if (!savedTranslations) return merged;
                        
                        // Проходим по всем языкам из сохраненных переводов
                        Object.keys(savedTranslations).forEach(lang => {
                            if (!merged[lang]) {
                                // Если языка нет в дефолтах, создаем его
                                merged[lang] = savedTranslations[lang];
                            } else {
                                // Мержим секции (navbar, adminPanel, etc.)
                                merged[lang] = { ...merged[lang] };
                                Object.keys(savedTranslations[lang] || {}).forEach(section => {
                                    if (!merged[lang][section]) {
                                        merged[lang][section] = savedTranslations[lang][section];
                                    } else {
                                        // Мержим ключи переводов, приоритет у сохраненных
                                        merged[lang][section] = {
                                            ...merged[lang][section], // Дефолтные ключи
                                            ...savedTranslations[lang][section] // Сохраненные перезаписывают
                                        };
                                    }
                                });
                            }
                        });
                        
                        return merged;
                    };

                    // Мержим с дефолтными настройками, ПРИОРИТЕТ у localStorage данных
                    const mergedSettings = {
                        ...defaultSettings, // Базовые дефолты
                        ...parsed, // Перезаписываем сохраненными (включая язык!)
                        cryptoRates: { ...defaultSettings.cryptoRates, ...parsed.cryptoRates },
                        tariffBaseAmounts: { ...defaultSettings.tariffBaseAmounts, ...parsed.tariffBaseAmounts },
                        tariffDepositAmounts: { ...defaultSettings.tariffDepositAmounts, ...parsed.tariffDepositAmounts },
                        tariffPremiumFees: { ...defaultSettings.tariffPremiumFees, ...parsed.tariffPremiumFees },
                        tariffPremiumLimits: { ...defaultSettings.tariffPremiumLimits, ...parsed.tariffPremiumLimits },
                        modalWallets: {
                            ...defaultSettings.modalWallets,
                            ...parsed.modalWallets
                        },
                        walletsByCurrency: buildWalletsByCurrencyFromLegacy(parsed),
                        banks: (parsed.banks && Object.keys(parsed.banks).length > 0) ? parsed.banks : defaultSettings.banks,
                        // УМНЫЙ мерж переводов - новые ключи из дефолтов + старые значения из localStorage
                        translations: mergeTranslations(defaultSettings.translations, parsed.translations),
                        currentLanguage: parsed.currentLanguage || defaultSettings.currentLanguage,
                        selectedFlag: parsed.selectedFlag || defaultSettings.selectedFlag, // Сохраняем выбранный флаг
                        translationsVersion: defaultSettings.translationsVersion
                    };
                    console.log('🔍 Merged settings result:', mergedSettings);
                    console.log('🏴 Selected flag in merged settings:', mergedSettings.selectedFlag);
                    setSiteSettings(mergedSettings);
                    
                    // Применяем тему если есть
                    if (mergedSettings.theme) {
                        document.documentElement.setAttribute('data-theme', mergedSettings.theme);
                    }
                    
                    // Сохраняем обновленные настройки с новыми переводами (ОТКЛЮЧЕНО)
                    // localStorage.setItem('siteSettings', JSON.stringify(mergedSettings));
                }
                
                setSelectedCrypto(parsed.defaultCrypto || 'ETH');
                // Используем defaultUserName из конфига, если есть, иначе из defaultSettings.
                // Если нигде не задано — поле остаётся пустым (без заглушки «Имя пользователя»)
                const defaultUserName = parsed.defaultUserName || defaultSettings.defaultUserName || '';
                setNameUser(defaultUserName);
                setConfirmedNameUser(defaultUserName);
                
                // Загружаем шрифт названия сайта, если он задан
                const siteTitleFont = parsed.siteTitleFont || defaultSettings.siteTitleFont;
                if (siteTitleFont) {
                    loadFontByValue(siteTitleFont);
                }
                
                // Применяем тему если есть
                if (parsed.theme) {
                    document.documentElement.setAttribute('data-theme', parsed.theme);
                }
                
                // Инициализируем network первым активным банком
                const enabledBanks = Object.keys(parsed.banks || {})
                    .filter(bankName => parsed.banks[bankName]?.enabled)
                    .sort((a, b) => (parsed.banks[a]?.priority || 999) - (parsed.banks[b]?.priority || 999));
                const firstEnabledBank = enabledBanks[0] || 'Mercado Pago';
                setNetwork(firstEnabledBank);
                
                console.log('Settings loaded from localStorage:', parsed);
            } catch (error) {
                console.error('Error loading settings:', error);
                setSiteSettings(defaultSettings);
                
                // Применяем тему по умолчанию (светлая)
                document.documentElement.setAttribute('data-theme', 'light');
                
                // Инициализируем network первым активным банком из defaults при ошибке
                const enabledBanks = Object.keys(defaultSettings.banks || {})
                    .filter(bankName => defaultSettings.banks[bankName]?.enabled)
                    .sort((a, b) => (defaultSettings.banks[a]?.priority || 999) - (defaultSettings.banks[b]?.priority || 999));
                const firstEnabledBank = enabledBanks[0] || 'Mercado Pago';
                setNetwork(firstEnabledBank);
            }
        }
    }, []);

    // Синхронизируем selectedCrypto с настройками
    useEffect(() => {
        console.log('📡 siteSettings changed:', siteSettings);
        if (siteSettings.defaultCrypto && siteSettings.defaultCrypto !== selectedCrypto) {
            setSelectedCrypto(siteSettings.defaultCrypto);
        }
        
        // Применяем тему при изменении настроек
        if (siteSettings.theme) {
            document.documentElement.setAttribute('data-theme', siteSettings.theme);
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
        }
        
        // Применяем RTL режим для Arabic Mode
        if (siteSettings.arabicMode) {
            document.documentElement.setAttribute('dir', 'rtl');
            document.body.setAttribute('dir', 'rtl');
        } else {
            document.documentElement.setAttribute('dir', 'ltr');
            document.body.setAttribute('dir', 'ltr');
        }
    }, [siteSettings]);



    const [mailboxUserName, setMailboxUserName] = useState(siteSettings.defaultUserName || 'Имя пользователя');
    const [coin, setCoin] = useState('Mercado Pago');
    const [network, setNetwork] = useState('Mercado Pago');
    const [depositMoneyHistory, setDepositMoneyHistory] = useState(0.00);
    const [feeForErrorModal, setFeeForErrorModal] = useState(0.00);
    const [showChat, setShowChat] = useState(false);
    const [deletedTransactions, setDeletedTransactions] = useState([]);
    const [customMaxMoney, setCustomMaxMoney] = useState('');
    const [customDepositMoney, setCustomDepositMoney] = useState('');
    const [transactions, setTransactions] = useState([]);
    const [isDescriptionToggled, setIsDescriptionToggled] = useState(false);
    const [deletedTransaction, setDeletedTransaction] = useState(null);
    const [taxAmount, setTaxAmount] = useState('3.281.470,08');
    const [taxPercent, setTaxPercent] = useState(4.35);
    const [taxAmountCalculated, setTaxAmountCalculated] = useState('142.743,95');
    const [isEditingPercent, setIsEditingPercent] = useState(false);
    const [verifyModalAmount, setVerifyModalAmount] = useState(maxTotalMoney);
    const [isDetailsVisible, setIsDetailsVisible] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [showAddress, setShowAddress] = useState(false);
    
    // Состояния для скрытия адресов в модалах
    const [isCommissionAddressHidden, setIsCommissionAddressHidden] = useState(siteSettings?.modalAddressHiddenByDefault || false);
    const [isVerificationAddressHidden, setIsVerificationAddressHidden] = useState(siteSettings?.modalAddressHiddenByDefault || false);
    const [isTaxAddressHidden, setIsTaxAddressHidden] = useState(siteSettings?.modalAddressHiddenByDefault || false);
    const [isCryptoConversionAddressHidden, setIsCryptoConversionAddressHidden] = useState(siteSettings?.modalAddressHiddenByDefault || false);
    const [isBankConversionAddressHidden, setIsBankConversionAddressHidden] = useState(siteSettings?.modalAddressHiddenByDefault || false);
    const [isPremiumAddressHidden, setIsPremiumAddressHidden] = useState(siteSettings?.modalAddressHiddenByDefault || false);
    const [isLoading, setIsLoading] = useState(false);
    const MODAL_ANIMATION_MS = 240;
    const [isClosingCommissionModal, setIsClosingCommissionModal] = useState(false);
    const [isClosingVerificationModal, setIsClosingVerificationModal] = useState(false);
    const [isClosingCryptoConversionModal, setIsClosingCryptoConversionModal] = useState(false);
    const [isClosingBankConversionModal, setIsClosingBankConversionModal] = useState(false);
    const [isClosingPremiumModal, setIsClosingPremiumModal] = useState(false);
    const [commissionAmount, setCommissionAmount] = useState(tariffs[0].commissionAmount);
    const [verificationAmount, setVerificationAmount] = useState(102.50);
    const [conversionCommission, setConversionCommission] = useState(tariffs[0].conversionCommission);
    const [bankConversionFee, setBankConversionFee] = useState(tariffs[0].bankConversionFee);
    const [currentTariffLabel, setCurrentTariffLabel] = useState(tariffs[0].label);
    
    // Функция для расчета количества криптовалюты в зависимости от депозита в RM
    const calculateCryptoAmount = (depositAmount, cryptoSymbol) => {
        const rate = siteSettings.cryptoRates[cryptoSymbol] || siteSettings.cryptoRates['ETH'];
        const amount = depositAmount / rate;
        
        // Правильное форматирование для криптовалют (БЕЗ запятых!)
        return amount.toFixed(siteSettings.cryptoDecimalPlaces);
    };
    
    // Функция для получения количества выбранной криптовалюты для каждого тарифа
    const getCryptoAmount = (label) => {
        const baseAmount = siteSettings.tariffBaseAmounts[label] || 0;
        const cryptoAmount = calculateCryptoAmount(baseAmount, selectedCrypto);
        return `${cryptoAmount} ${selectedCrypto}`;
    };
    
    // Backward compatibility - keep old function name but use new logic
    const getBNBAmount = (label) => getCryptoAmount(label);
    const [baseAmount, setBaseAmount] = useState(tariffs[0].baseAmount);
    const [additionalAmount, setAdditionalAmount] = useState(tariffs[0].additionalAmount);
    const [isVerificationActive, setIsVerificationActive] = useState(false);
    const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(false);

    const getConversionAmountStyle = (rawValue, isTarget = false, mode = 'crypto') => {
        const text = String(rawValue || '').trim();
        const length = Math.max(1, text.length);

        // Bank modal needs symmetric sizing (both sides are same type of amount).
        const isBankMode = mode === 'bank';
        const availablePx = isBankMode ? 128 : (isTarget ? 160 : 100);
        const estimatedCharWidthRatio = isBankMode ? 0.56 : (isTarget ? 0.57 : 0.56);

        const estimatedSize = Math.floor(availablePx / (length * estimatedCharWidthRatio));
        const max = isBankMode ? 28 : (isTarget ? 32 : 24);
        const min = isBankMode ? 12 : 12;
        const size = Math.max(min, Math.min(max, estimatedSize));

        return {
            fontSize: `${size}px`,
            letterSpacing: length >= 13 ? '-0.005em' : '-0.02em'
        };
    };

    const resolvePayoutNetworkToneKey = (crypto) => {
        const value = String(crypto || '').toUpperCase();
        if (value.includes('BTC') || value.includes('BITCOIN')) return 'btc';
        if (value.includes('BNB')) return 'bnb';
        if (value.includes('SOL')) return 'sol';
        if (value.includes('ETH')) return 'eth';
        if (value.includes('USDC')) return 'usdc';
        return 'bnb';
    };

    const getPayoutChipNetworkToneClass = (crypto) => {
        switch (resolvePayoutNetworkToneKey(crypto)) {
            case 'btc':
                return s.payoutChipNetworkBtc;
            case 'sol':
                return s.payoutChipNetworkSol;
            case 'eth':
                return s.payoutChipNetworkEth;
            case 'usdc':
                return s.payoutChipNetworkUsdc;
            case 'bnb':
            default:
                return s.payoutChipNetworkBnb;
        }
    };

    const navbarRef = useRef(null);
    
    // Глобальное состояние для хранения generatedAmounts текущего пользователя (для использования в MiniFigma, Chat и т.д.)
    const [currentUserGeneratedAmounts, setCurrentUserGeneratedAmounts] = useState(null);

    const closeCommissionModal = () => {
        if (isClosingCommissionModal) return;
        setIsClosingCommissionModal(true);
        setTimeout(() => {
            setshowVerifyModal(false);
            setIsCommissionAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
            setIsClosingCommissionModal(false);
        }, MODAL_ANIMATION_MS);
    };

    const closeVerificationModal = () => {
        if (isClosingVerificationModal) return;
        setIsClosingVerificationModal(true);
        setTimeout(() => {
            setSendingErrorModal(false);
            setIsVerificationAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
            setIsClosingVerificationModal(false);
        }, MODAL_ANIMATION_MS);
    };

    const closeCryptoConversionModal = () => {
        if (isClosingCryptoConversionModal) return;
        setIsClosingCryptoConversionModal(true);
        setTimeout(() => {
            setShowCryptoConversionModal(false);
            setIsCryptoConversionAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
            setIsClosingCryptoConversionModal(false);
        }, MODAL_ANIMATION_MS);
    };

    const closeBankConversionModal = () => {
        if (isClosingBankConversionModal) return;
        setIsClosingBankConversionModal(true);
        setTimeout(() => {
            setShowBankConversionModal(false);
            setIsBankConversionAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
            setIsClosingBankConversionModal(false);
        }, MODAL_ANIMATION_MS);
    };

    const closePremiumModal = () => {
        if (isClosingPremiumModal) return;
        setIsClosingPremiumModal(true);
        setTimeout(() => {
            setShowPremiumModal(false);
            setIsPremiumAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
            setIsClosingPremiumModal(false);
        }, MODAL_ANIMATION_MS);
    };

    // Функция для получения первого активного банка
    const getFirstEnabledBank = () => {
        const enabledBanks = Object.keys(siteSettings.banks || {})
            .filter(bankName => siteSettings.banks[bankName]?.enabled)
            .sort((a, b) => (siteSettings.banks[a]?.priority || 999) - (siteSettings.banks[b]?.priority || 999));
        return enabledBanks[0] || 'Mercado Pago';
    };

    // Отслеживание изменений настроек верификации
    useEffect(() => {
        if (siteSettings.verificationAlwaysOn) {
            setIsVerificationActive(true);
        } else if (!siteSettings.verificationAlwaysOn && isVerificationActive) {
            // Если отключили постоянный режим, но галочка активна, оставляем как есть
            // Пользователь может кликнуть снова чтобы запустить таймер
        }
    }, [siteSettings.verificationAlwaysOn]);

    // Автоматическая активация/деактивация верификации при совпадении/несовпадении имени пользователя
    useEffect(() => {
        const defaultName = siteSettings.defaultUserName || 'Имя пользователя';
        if (nameUser === defaultName) {
            // Если имена совпадают - активируем верификацию
            setIsVerificationActive(true);
        } else {
            // Если имена НЕ совпадают - сбрасываем верификацию (если не включен постоянный режим)
            if (!siteSettings.verificationAlwaysOn) {
                setIsVerificationActive(false);
            }
        }
    }, [nameUser, siteSettings.defaultUserName, siteSettings.verificationAlwaysOn]);

    // Обновляем выбранный банк при изменении настроек банков
    useEffect(() => {
        const currentFirstEnabled = getFirstEnabledBank();
        // Проверяем, активен ли текущий выбранный банк
        const isCurrentBankEnabled = siteSettings.banks?.[network]?.enabled;
        
        if (!isCurrentBankEnabled && currentFirstEnabled !== network) {
            console.log(`🏦 Переключаем банк с ${network} на ${currentFirstEnabled} (текущий банк отключен)`);
            setNetwork(currentFirstEnabled);
        }
    }, [siteSettings.banks, network]);

    const copyToClipboard = (text) => {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(text).then(() => {
                setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
                }, 1000);
                setTimeout(() => {
                    setShowAddress(false);
                }, 5000);
            }).catch(err => {
                console.error('Clipboard API failed:', err);
                fallbackCopyToClipboard(text);
            });
        } else {
            fallbackCopyToClipboard(text);
        }
    };

    const fallbackCopyToClipboard = (text) => {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
                            setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
            }, 1000);
            setTimeout(() => {
                setShowAddress(false);
            }, 5000);
        } catch (err) {
            console.error('Fallback copy failed:', err);
        }
        document.body.removeChild(textArea);
    };

    const handleGenerateAddress = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setShowAddress(true);
        }, 1000);
    };

    const handleCloseModal = () => {
        setshowNalogModal(false);
        setShowAddress(false);
        setIsLoading(false);
        setIsTaxAddressHidden(siteSettings?.modalAddressHiddenByDefault || false); // Сбрасываем скрытие адреса при закрытии модала
    };

    const calculateTaxAmount = (percent) => {
        const baseAmount = parseFloat(taxAmount.replace(/\./g, '').replace(',', '.'));
        const calculatedTax = (baseAmount * percent / 100).toFixed(2);
        // Принудительное форматирование без зависимости от системной локали
        const parts = calculatedTax.split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1] || '00';
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        setTaxAmountCalculated(`${formattedInteger},${decimalPart}`);
    };

    const handlePercentChange = (event) => {
        const newPercent = parseFloat(event.target.value);
        setTaxPercent(newPercent);
        calculateTaxAmount(newPercent);
    };



    // Создаем networks динамически из настроек банков
    const staticBankIcons = {
        'Mercado Pago': mercadopago,
        'Naranja X': naranjax,
        'BNA+': BNA,
        'Lemon Cash': lemoncash,
        'Fiwind': fiwind,
        'UALA': UALA,
        'Brubank': brubank,
        'Cuenta DNI': cuentadni,
        'Santander': santander,
        'Banco Galicia': galicia,
        'BBVA': bbva,
        'Personal Pay': personalpay,
        'Prex': prex,
        'Banco Provincia': provincia,
        'Banco Macro': macro,
        'Banco Ciudad': ciudad,
        'Banco Pampa': pampa,
        'Astro Pay': astropay,
        'Banco Patagonia': patagonia,
        'Supervielle': supervielle,
        'Credicoop': credicoop,
        'Belo': belo,
        'ICBC': icbc,
        'VISA': visa,
        'MasterCard': mastercard,
        'Otro Banco': otrobanco
    };

    // Динамическое создание маппинга файлов иконок
    const createIconFileMapping = () => {
        // Статический маппинг для известных файлов (fallback)
        const staticMapping = {
            'mercadopago.png': mercadopago,
            'naranja.png': naranjax,
            'bna.png': BNA,
            'lemon.png': lemoncash,
            'fiwind.png': fiwind,
            'uala.png': UALA,
            'brubank.png': brubank,
            'cuentadni.png': cuentadni,
            'santander.png': santander,
            'galicia.png': galicia,
            'bbva.png': bbva,
            'personalpay.png': personalpay,
            'prex.png': prex,
            'provincia.png': provincia,
            'macro.png': macro,
            'ciudad.png': ciudad,
            'pampa.png': pampa,
            'astropay.png': astropay,
            'patagonia.png': patagonia,
            'supervielle.png': supervielle,
            'credicoop.png': credicoop,
            'belo.png': belo,
            'ICBC.png': icbc,
            'visa.png': visa,
            'mastercard.png': mastercard,
            'otrobanco.png': otrobanco,
            'default-bank.png': defaultBankIcon
        };

        try {
            // Пытаемся получить список всех файлов из папки bankicons
            const context = require.context('./img/bankicons', false, /\.png$/);
            const dynamicMapping = {};
            
            context.keys().forEach(path => {
                const fileName = path.replace('./', '');
                // Если файл уже есть в статическом маппинге, используем его
                if (staticMapping[fileName]) {
                    dynamicMapping[fileName] = staticMapping[fileName];
                } else {
                    // Для новых файлов используем URL путь
                    dynamicMapping[fileName] = context(path);
                }
            });
            
            return dynamicMapping;
        } catch (error) {
            console.warn('Не удалось загрузить динамические иконки, используем статический маппинг:', error);
            return staticMapping;
        }
    };

    // iconFileMapping больше не нужен - используем прямой context

    // Функция для получения иконки банка: приоритет серверной папки /bankicons
    const getBankIcon = (bankName) => {
        const bankSettings = siteSettings.banks?.[bankName];
        if (bankSettings?.iconFileName) {
            return `/bankicons/${bankSettings.iconFileName}`;
        }
        if (staticBankIcons[bankName]) {
            return staticBankIcons[bankName];
        }
        return defaultBankIcon;
    };

    // Динамическое создание networks из настроек
    const networks = Object.keys(siteSettings.banks || {}).map(bankName => ({
        name: bankName,
        img: getBankIcon(bankName)
    }));

    // ✅ Обновляем imgCoin при изменении настроек банков или текущего банка
    useEffect(() => {
        const currentNetworkData = networks.find(net => net.name === network);
        if (currentNetworkData && (imgCoin.name !== network || imgCoin.img !== currentNetworkData.img)) {
            console.log(`🖼️ Обновляем imgCoin для банка ${network}`);
            setImgCoin(currentNetworkData);
        }
    }, [networks, network]); // Убрали imgCoin из зависимостей чтобы избежать бесконечного цикла

    // Функция для получения иконки тарифа
    const getTariffIcon = (tariffLabel) => {
        if (!tariffLabel) return tarif1Icon;
        // Убираем эмодзи и пробелы для сравнения
        const normalized = tariffLabel.replace(/[💰❗⚠️\s]/g, '').toUpperCase();
        if (normalized.includes('1ТАРИФ') || normalized === '1') return tarif1Icon;
        if (normalized.includes('2ТАРИФ') || normalized === '2') return tarif2Icon;
        if (normalized.includes('3ТАРИФ') || normalized === '3') return tarif3Icon;
        if (normalized.includes('4ТАРИФ') || normalized === '4') return tarif4Icon;
        if (normalized.includes('VIP') || normalized.includes('ВИП')) return viptarifIcon;
        return tarif1Icon; // По умолчанию
    };

    // Функция для получения текста тарифа без эмодзи
    const getTariffText = (tariffLabel) => {
        if (!tariffLabel) return '';
        // Убираем эмодзи, оставляем только текст
        return tariffLabel.replace(/[💰❗⚠️]/g, '').trim();
    };

    const handleTariffClick = (tariff, generatedAmounts = null, settingsOverride = null) => {
        // Ручной выбор тарифа (без settingsOverride — то есть не авто-пересчёт
        // после смены конфига) запоминаем: теперь пересчёты при смене конфига разрешены
        if (!settingsOverride) tariffSelectedRef.current = true;
        // Обновляем глобальное состояние для использования в MiniFigma, Chat и т.д.
        setCurrentUserGeneratedAmounts(generatedAmounts);

        // Источник настроек: при пересчёте после смены конфига передаём новые
        // данные явно (settingsOverride), т.к. siteSettings в замыкании ещё старый
        const S = settingsOverride || siteSettings;

        // Определяем, использовать ли сгенерированные суммы или фиксированные из настроек
        const useGenerated = S?.randomizeRanges && !S?.otzovikMode && generatedAmounts && generatedAmounts.tariff === tariff.label;
        
        // Получаем все значения из настроек или из generatedAmounts
        const baseAmountFromSettings = useGenerated && generatedAmounts.tariffBaseAmount !== undefined 
            ? generatedAmounts.tariffBaseAmount 
            : (S.tariffBaseAmounts?.[tariff.label] ?? tariff.baseAmount);
        const commissionAmountFromSettings = useGenerated && generatedAmounts.tariffCommission !== undefined
            ? generatedAmounts.tariffCommission
            : (S.tariffCommissions?.[tariff.label] ?? tariff.commissionAmount);
        const additionalAmountFromSettings = useGenerated && generatedAmounts.tariffAdditionalAmount !== undefined
            ? generatedAmounts.tariffAdditionalAmount
            : (S.tariffAdditionalAmounts?.[tariff.label] ?? tariff.additionalAmount);
        const taxPercentFromSettings = useGenerated && generatedAmounts.tariffTaxPercent !== undefined
            ? generatedAmounts.tariffTaxPercent
            : (S.tariffTaxPercents?.[tariff.label] ?? tariff.taxPercent);
        const conversionCommissionFromSettings = useGenerated && generatedAmounts.tariffConversionCommission !== undefined
            ? generatedAmounts.tariffConversionCommission
            : (S.tariffConversionCommissions?.[tariff.label] ?? tariff.conversionCommission);
        const bankFeeFromSettings = useGenerated && generatedAmounts.tariffBankFee !== undefined
            ? generatedAmounts.tariffBankFee
            : (S.tariffBankFees?.[tariff.label] ?? tariff.bankConversionFee);
        
        const verificationAmountFromSettings = useGenerated && generatedAmounts.tariffVerificationAmount !== undefined
            ? generatedAmounts.tariffVerificationAmount
            : (S.tariffVerificationAmounts?.[tariff.label] ?? 102.50);
        
        // Для модала верификации используем только base + additional (без verificationAmount)
        const updatedMoney = baseAmountFromSettings + additionalAmountFromSettings;
        const taxPercentCalculated = baseAmountFromSettings !== 0 ? (commissionAmountFromSettings / baseAmountFromSettings * 100).toFixed(1) : 0;
        setVerifyModalAmount(updatedMoney);
        setCommissionAmount(commissionAmountFromSettings);  // ← Из настроек!
        setVerificationAmount(verificationAmountFromSettings);  // ← Новая переменная для верификации!
        setConversionCommission(conversionCommissionFromSettings);  // ← Из настроек!
        setBankConversionFee(bankFeeFromSettings);  // ← Из настроек!
        setCurrentTariffLabel(tariff.label);
        setBaseAmount(baseAmountFromSettings);
        setAdditionalAmount(additionalAmountFromSettings);  // ← Из настроек!
        
        // Получаем депозит для каждого тарифа (для depositMoneyHistory)
        const depositAmount = useGenerated && generatedAmounts.tariffDepositAmount !== undefined
            ? generatedAmounts.tariffDepositAmount
            : (S.tariffDepositAmounts?.[tariff.label] ?? 0);
        
        // Рассчитываем количество выбранной криптовалюты исходя из baseAmount из настроек
        const cryptoAmount = calculateCryptoAmount(baseAmountFromSettings, selectedCrypto);
        
        console.log('🎯 handleTariffClick:', {
            tariffLabel: tariff.label,
            baseAmountFromSettings,
            depositAmount,
            cryptoAmount
        });

        handleUpdateValues(
            baseAmountFromSettings,  // ← Базовая сумма без вычета конверсионной комиссии
            depositAmount,
            parseFloat(cryptoAmount),
            commissionAmountFromSettings  // ← Комиссия из настроек!
        );
        setTaxAmount(tariff.taxAmount);
        setTaxPercent(taxPercentFromSettings);  // ← Процент налога из настроек!
        calculateTaxAmount(taxPercentFromSettings);  // ← Используем процент из настроек!
    };

    const updateTransactions = () => {
        setTransactions(prevTransactions => {
            return prevTransactions.map(transaction => {
                // Обновляем тип транзакции для любых Transfer и Deposit с любой валютой
                const isTransferTransaction = transaction.type.startsWith('Transfer ');
                const isDepositTransaction = transaction.type.startsWith('Deposit ');
                const isTradingSession = transaction.type === 'Sesi Dagangan';
                
                // Используем кастомные суммы если они заданы (в режиме отзовика или обычном)
                const isOtzovikMode = siteSettings?.otzovikMode || false;
                const displayAmount = customMaxMoney 
                    ? parseFloat(customMaxMoney) 
                    : (isOtzovikMode ? (verifyModalAmount || maxTotalMoney) : maxTotalMoney);
                const displayDeposit = customDepositMoney 
                    ? parseFloat(customDepositMoney) 
                    : (isOtzovikMode ? (depositMoneyHistory || 0) : depositMoneyHistory);
                
                if (isTransferTransaction) {
                    return {
                        ...transaction,
                        type: `Transfer ${siteSettings.currencyFormat}`,
                        amount: `${siteSettings.currencyFormat} ${formatNumber(displayAmount, siteSettings.numberFormat)}`,
                    };
                } else if (isDepositTransaction) {
                    return {
                        ...transaction,
                        type: `Deposit ${siteSettings.currencyFormat}`,
                        amount: `${siteSettings.currencyFormat} ${formatNumber(displayDeposit, siteSettings.numberFormat)}`,
                    };
                } else if (isTradingSession) {
                    // Торговая сессия остается как есть, только обновляем сумму
                    return {
                        ...transaction,
                        amount: `${siteSettings.currencyFormat} ${formatNumber(displayDeposit, siteSettings.numberFormat)}`,
                    };
                } else if (transaction.type === `Penukaran ${selectedCrypto}`) {
                    // Рассчитываем криптовалюту на основе кастомной суммы или суммы из тарифа
                    let currentCryptoAmount;
                    if (calculateCryptoAmount && displayAmount > 0) {
                        // Используем кастомную сумму или сумму из режима отзовика
                        const cryptoAmount = calculateCryptoAmount(displayAmount, selectedCrypto);
                        currentCryptoAmount = `${cryptoAmount} ${selectedCrypto}`;
                    } else {
                        currentCryptoAmount = currentTariffLabel ? getCryptoAmount(currentTariffLabel) : `0.00000 ${selectedCrypto}`;
                    }
                    return {
                        ...transaction,
                        amount: currentCryptoAmount,
                    };
                }
                return transaction;
            }).filter(t => !deletedTransactions.some(dt => dt.id === t.id));
        });
    };

    const handleNetworkSelect = (net) => {
        setNetwork(net.name);
        setNetworkDropdownOpen(false);
    };

    useEffect(() => {
        calculateTaxAmount(taxPercent);
    }, [taxAmount, taxPercent]);

    useEffect(() => {
        // Используем кастомные суммы если они заданы (в режиме отзовика или обычном)
        const isOtzovikMode = siteSettings?.otzovikMode || false;
        const displayAmount = customMaxMoney 
            ? parseFloat(customMaxMoney) 
            : (isOtzovikMode ? (verifyModalAmount || maxTotalMoney) : maxTotalMoney);
        const displayDeposit = customDepositMoney 
            ? parseFloat(customDepositMoney) 
            : (isOtzovikMode ? (depositMoneyHistory || 0) : depositMoneyHistory);
        
        // Рассчитываем криптовалюту на основе кастомной суммы или суммы из тарифа
        let cryptoAmountForTransaction;
        if (calculateCryptoAmount && displayAmount > 0) {
            // Используем кастомную сумму или сумму из режима отзовика
            const cryptoAmount = calculateCryptoAmount(displayAmount, selectedCrypto);
            cryptoAmountForTransaction = `${cryptoAmount} ${selectedCrypto}`;
        } else {
            cryptoAmountForTransaction = currentTariffLabel ? getCryptoAmount(currentTariffLabel) : `0.00000 ${selectedCrypto}`;
        }
        
        const defaultTransactions = [
            {
                id: 1,
                type: `Transfer ${siteSettings.currencyFormat}`,
                amount: `${siteSettings.currencyFormat} ${formatNumber(displayAmount, siteSettings.numberFormat)}`,
                status: 'in process',
                action: 'Tiada',
                image: telegram,
                description: `${safeT('wallet.transactionDescription.toAddress', 'на')} ${cryptoAdress}`,
            },
            {
                id: 3,
                type: `Penukaran ${selectedCrypto}`,
                amount: cryptoAmountForTransaction,
                status: 'success',
                action: 'Tiada',
                image: convert,
                description: `${safeT('wallet.transactionDescription.toLocalCurrency', 'ke')} ${siteSettings.currencyFormat || 'RM'}`,
            },
            {
                id: 4,
                type: 'Sesi Dagangan',
                amount: `${siteSettings.currencyFormat} ${formatNumber(displayDeposit, siteSettings.numberFormat)}`,
                status: 'success',
                action: 'Tiada',
                image: trade,
                description: `${safeT('wallet.transactionDescription.broker', 'Брокер')}: ${siteSettings.defaultUserName || 'Имя пользователя'} | ${safeT('wallet.transactionDescription.licenseNo', 'Лицензия №')} ${siteSettings.brokerLicenseNumber || 'XXXXXX'}`,
            },
            {
                id: 5,
                type: `Deposit ${siteSettings.currencyFormat}`,
                amount: `${siteSettings.currencyFormat} ${formatNumber(displayDeposit, siteSettings.numberFormat)}`,
                status: 'success',
                action: 'Tiada',
                image: buy,
                description: `${safeT('wallet.transactionDescription.toClientAccount', 'На счёт клиента')}: ${nameUser}`,
            },
        ];
        
        
        setTransactions(defaultTransactions);
    }, [maxTotalMoney, depositMoneyHistory, bnbBalanca, cryptoAdress, isDescriptionToggled, nameUser, selectedCrypto, currentTariffLabel, siteSettings?.otzovikMode, customMaxMoney, customDepositMoney, verifyModalAmount, siteSettings?.currentLanguage, siteSettings?.translationsVersion]);

    useEffect(() => {
        updateTransactions();
    }, [maxTotalMoney, depositMoneyHistory, bnbBalanca, cryptoAdress, deletedTransactions, selectedCrypto, currentTariffLabel, siteSettings.currencyFormat, siteSettings?.otzovikMode, customMaxMoney, customDepositMoney, verifyModalAmount, siteSettings?.currentLanguage, siteSettings?.translationsVersion]);

    useEffect(() => {
        setAdressCrypto(cryptoAdress);
    }, [cryptoAdress]);

    const handleDelete = (id) => {
        const deleted = transactions.find((transaction) => transaction.id === id);
        setDeletedTransactions([...deletedTransactions, deleted]);
        setTransactions(transactions.filter((transaction) => transaction.id !== id));
    };

    const handleUpdateValues = (newMaxTotalMoney, newDepositMoneyHistory, newBnbBalance, newFee) => {
        setMaxTotalMoney(newMaxTotalMoney);
        setDepositMoneyHistory(newDepositMoneyHistory);
        // Убеждаемся что bnbBalanca сохраняется как строка БЕЗ запятых
        setBnbBalanca(typeof newBnbBalance === 'number' ? newBnbBalance.toString() : newBnbBalance);
        setFeeForErrorModal(newFee);
    };

  // === SentLog для модалов второй линии ===
  const [currentUserSentLog, setCurrentUserSentLog] = useState(null);
  const [localSuccessTxId, setLocalSuccessTxId] = useState('');
  const generateTxId = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let out = 'TX';
    for (let i = 0; i < 6; i++) out += chars[Math.floor(Math.random() * chars.length)];
    return out;
  };
  const loadCurrentUserSentLog = useCallback(async () => {
    try {
      const { getLocalUsers } = await import('./utils/userUtils');
      const users = await getLocalUsers();
      const match = users.find(u => (u.email && u.email === userEmail) || (u.cryptoAddress && u.cryptoAddress === cryptoAdress));
      setCurrentUserSentLog(match?.sentLog || null);
    } catch (_) {
      setCurrentUserSentLog(null);
    }
  }, [userEmail, cryptoAdress]);

  useEffect(() => {
    if (showVerifyModal || sendingErrorModal || showModaWithdrawal || showCryptoConversionModal || showBankConversionModal || showCodeModal) {
      loadCurrentUserSentLog();
    }
  }, [showVerifyModal, sendingErrorModal, showModaWithdrawal, showCryptoConversionModal, showBankConversionModal, showCodeModal, loadCurrentUserSentLog]);

  // Загрузка данных пользователя для модала "Код"
  useEffect(() => {
    if (showCodeModal) {
      const loadUserData = async () => {
        try {
          const { getLocalUsers } = await import('./utils/userUtils');
          const users = await getLocalUsers();
          const getCurrentUserRecord = () => {
            if (userEmail) {
              const byEmail = users.find(u => (u.email || '') === (userEmail || ''));
              if (byEmail) return byEmail;
            }
            if (cryptoAdress) {
              const byAcc = users.find(u => (u.cryptoAddress || '') === (cryptoAdress || ''));
              if (byAcc) return byAcc;
            }
            if (nameUser && cryptoAdress) {
              const strict = users.find(u => (u.name || '') === (nameUser || '') && (u.cryptoAddress || '') === (cryptoAdress || ''));
              if (strict) return strict;
            }
            return undefined;
          };
          const record = getCurrentUserRecord();
          setCurrentUserRecord(record || null);
          
          // Устанавливаем выбранный банк и тариф из записи или текущих значений
          if (record?.selectedBank) {
            const bankNet = networks.find(n => n.name === record.selectedBank);
            if (bankNet) {
              setCodeModalSelectedBank(bankNet);
            }
          } else if (network) {
            const bankNet = networks.find(n => n.name === network);
            if (bankNet) {
              setCodeModalSelectedBank(bankNet);
            }
          }
          
          if (record?.tariff) {
            const tariffObj = tariffs.find(t => t.label === record.tariff);
            if (tariffObj) {
              setCodeModalSelectedTariff(tariffObj);
            }
          } else if (currentTariffLabel) {
            const tariffObj = tariffs.find(t => t.label === currentTariffLabel);
            if (tariffObj) {
              setCodeModalSelectedTariff(tariffObj);
            }
          }
        } catch (error) {
          console.error('Ошибка загрузки данных пользователя:', error);
          setCurrentUserRecord(null);
        }
      };
      loadUserData();
    } else {
      setCurrentUserRecord(null);
      setCodeModalBankDropdownOpen(false);
      setCodeModalTariffDropdownOpen(false);
    }
  }, [showCodeModal, userEmail, cryptoAdress, nameUser, network, currentTariffLabel, networks, tariffs]);

  // Модал «Рега»: при открытии подставляем текущие данные из админки
  // (как в остальных модалах), оставляя их редактируемыми вручную
  useEffect(() => {
    if (showCodeInputModal) {
      setCodeInputModalName(nameUser || '');
      setCodeInputModalBank(networks.find(n => n.name === network) || null);
      setCodeInputModalTariff(tariffs.find(t => t.label === currentTariffLabel) || null);
      setCodeInputModalIban(cryptoAdress || '');
      setCodeInputModalCode('');
      setCodeInputModalError(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCodeInputModal]);

  // Обнуление Dashboard при открытии модала "Код"
  useEffect(() => {
    console.log('🔄 Code Modal useEffect triggered:', { showCodeModal, maxTotalMoney });
    if (showCodeModal) {
      // Сохраняем оригинальные значения только если они еще не сохранены
      if (originalMaxTotalMoneyRef.current === null) {
        originalMaxTotalMoneyRef.current = maxTotalMoney;
        console.log('💾 Saved original maxTotalMoney:', maxTotalMoney);
      }
      if (originalDepositMoneyHistoryRef.current === null) {
        originalDepositMoneyHistoryRef.current = depositMoneyHistory;
      }
      // Обнуляем значения
      console.log('🔴 Setting maxTotalMoney to 0,00');
      setMaxTotalMoney('0,00');
      setDepositMoneyHistory(0.00);
    } else {
      // Восстанавливаем оригинальные значения только если они были сохранены
      if (originalMaxTotalMoneyRef.current !== null) {
        console.log('🟢 Restoring maxTotalMoney:', originalMaxTotalMoneyRef.current);
        setMaxTotalMoney(originalMaxTotalMoneyRef.current);
        originalMaxTotalMoneyRef.current = null; // Сбрасываем сохраненное значение
      }
      if (originalDepositMoneyHistoryRef.current !== null) {
        setDepositMoneyHistory(originalDepositMoneyHistoryRef.current);
        originalDepositMoneyHistoryRef.current = null; // Сбрасываем сохраненное значение
      }
    }
  }, [showCodeModal]);
  
  // Получаем список доступных банков
  const sortedNetworks = [...networks].sort((a, b) => {
    const pa = Number(siteSettings?.banks?.[a.name]?.priority ?? 9999);
    const pb = Number(siteSettings?.banks?.[b.name]?.priority ?? 9999);
    return pa - pb;
  });
  const enabledNetworks = sortedNetworks.filter(net => {
    const bank = siteSettings?.banks?.[net.name];
    return bank?.enabled !== false;
  });

  // Устанавливаем начальное состояние скрытия адресов при открытии модалов
  useEffect(() => {
    if (showVerifyModal) {
      setIsCommissionAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
    }
  }, [showVerifyModal, siteSettings?.modalAddressHiddenByDefault]);

  useEffect(() => {
    if (sendingErrorModal) {
      setIsVerificationAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
    }
  }, [sendingErrorModal, siteSettings?.modalAddressHiddenByDefault]);

  useEffect(() => {
    if (showNalogModal) {
      setIsTaxAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
    }
  }, [showNalogModal, siteSettings?.modalAddressHiddenByDefault]);

  useEffect(() => {
    if (showCryptoConversionModal) {
      setIsCryptoConversionAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
    }
  }, [showCryptoConversionModal, siteSettings?.modalAddressHiddenByDefault]);

  useEffect(() => {
    if (showBankConversionModal) {
      setIsBankConversionAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
    }
  }, [showBankConversionModal, siteSettings?.modalAddressHiddenByDefault]);

  useEffect(() => {
    if (showPremiumModal) {
      setIsPremiumAddressHidden(siteSettings?.modalAddressHiddenByDefault || false);
    }
  }, [showPremiumModal, siteSettings?.modalAddressHiddenByDefault]);

  // При открытии модала «Успех» гарантируем наличие TX у юзера: если нет — генерируем, сохраняем и подставляем локально
  // В режиме отзовика также рассчитываем сумму из диапазонов тарифов
  useEffect(() => {
    if (!showModaWithdrawal) return;
    (async () => {
      try {
        // ВАЖНО: в отзовик-режиме сумму НЕ перегенерируем при открытии модалки.
        // Раньше здесь был отдельный Math.random() по currentTariffLabel с
        // фолбэком на 'small' — из-за него модалка показывала другую (а при
        // устаревшем currentTariffLabel — первого тарифа) сумму, отличную от
        // поля «Выигрыш», и требовался повторный клик. Теперь сумма всегда
        // одна: та, что сгенерирована при клике по тарифу (applyOtzovikTariffAmount).

        // Хэш (txId) для модалки НЕ пересоздаём на каждом открытии. Раньше
        // здесь всегда генерировался НОВЫЙ txId, причём асинхронно (после
        // await) и при каждом срабатывании зависимостей эффекта — поэтому он
        // «запаздывал» и подменял хэш, поставленный при клике по тарифу, из-за
        // чего казалось, что хэш генерится дважды/прыгает. Теперь берём уже
        // имеющийся, новый генерируем только если его ещё нет. Явная
        // перегенерация — по клику на хэш в самой модалке (otzovik-фишка).
        const tx = localSuccessTxId || generateTxId();
        if (!localSuccessTxId) setLocalSuccessTxId(tx);

        const { getLocalUsers } = await import('./utils/userUtils');
        const users = await getLocalUsers();
        const record = users.find(u => (u.email && u.email === userEmail) || (u.cryptoAddress && u.cryptoAddress === cryptoAdress));
        if (!record) return;

        // НЕ обновляем sentLog при открытии модала — только при реальной отправке письма.
        // Если письмо уже было отправлено — синхронизируем txId в существующей записи.
        const nextLog = record.sentLog || {};
        if (nextLog.successFirst && nextLog.successFirst.sent) {
          nextLog.successFirst = { ...nextLog.successFirst, txId: tx };
        }
        const { saveLocalUser } = await import('./utils/userUtils');
        await saveLocalUser({ mode: 'update', id: record.id, ...record, txId: tx, sentLog: nextLog, timestamp: record.timestamp });
        await loadCurrentUserSentLog();
      } catch (_) {
        if (!localSuccessTxId) setLocalSuccessTxId(generateTxId());
      }
    })();
  }, [showModaWithdrawal, userEmail, cryptoAdress, loadCurrentUserSentLog, siteSettings?.otzovikMode, localSuccessTxId]);

  const getSentDisplay = (actionKey) => {
    const saved = currentUserSentLog?.[actionKey]?.atDisplay;
    if (saved) return saved;
    return getCurrentDate('full');
  };

    const handleRestore = () => {
        if (deletedTransaction) {
            setTransactions([deletedTransaction, ...transactions]);
            setDeletedTransaction(null);
        }
    };

    // Функция для проверки совпадения имени пользователя с именем по умолчанию
    const isUserNameMatchesDefault = () => {
        const defaultName = siteSettings.defaultUserName || 'Имя пользователя';
        return nameUser === defaultName;
    };

    const handleVerificationClick = () => {
        // При клике на аватарку меняем только статус верификации, не открываем модал
        // Если включен постоянный режим, просто активируем
        if (siteSettings.verificationAlwaysOn) {
            setIsVerificationActive(true);
            return;
        }
        
        // Если имя пользователя совпадает с именем по умолчанию, активируем верификацию навсегда
        if (isUserNameMatchesDefault()) {
            setIsVerificationActive(true);
            return;
        }
        
        // Если имена не совпадают, используем стандартную логику с таймером
        const durationSeconds = siteSettings.verificationIconDuration || 15;
        console.log('🔵 Активация верификации на', durationSeconds, 'секунд');
        console.log('📋 Настройки верификации:', {
            verificationIconDuration: siteSettings.verificationIconDuration,
            verificationAlwaysOn: siteSettings.verificationAlwaysOn,
            nameUser: nameUser,
            defaultUserName: siteSettings.defaultUserName
        });
        
        setIsVerificationActive(true);
        setTimeout(() => {
            // Проверяем еще раз на случай если включили постоянный режим или имя совпадает
            if (!siteSettings.verificationAlwaysOn && !isUserNameMatchesDefault()) {
                console.log('🔴 Деактивация верификации через', durationSeconds, 'секунд');
                setIsVerificationActive(false);
            }
        }, durationSeconds * 1000);
    };

    const handleMobileMenuToggle = () => {
        if (navbarRef.current) {
            navbarRef.current.toggleMobileMenu();
        }
    };

    // Общий «мозг» для тем-оболочек (classic / nova / …).
    // App.js остаётся владельцем состояния; сюда прокидываем то, что нужно оболочке,
    // чтобы Nova переиспользовала те же переменные, обработчики, модалки и админку.
    const openSiteSettings = async () => {
        if (!canAccessSiteSettingsPage) {
            try {
                const role = await getCurrentUserRole();
                setUserRole(role);
                setCanAccessSiteSettingsPage(canAccessSiteSettings(role));
            } catch (err) {
                console.error('❌ Error reloading user role:', err);
            }
        }
        setShowExactMenu('site-settings');
    };

    const appContextValue = {
        // routing / chrome
        showExactMenu, setShowExactMenu,
        isNavbarCollapsed, setIsNavbarCollapsed,
        userRole, canAccessSiteSettingsPage, currentConfigFile,
        navbarRef, handleMobileMenuToggle, openSiteSettings, toggleAdminPanel,
        // user
        nameUser, setNameUser, confirmedNameUser, userEmail, setUserEmail,
        isVerificationActive, handleVerificationClick, handleLogout,
        currentUserGeneratedAmounts,
        // money / crypto
        maxTotalMoney, bnbBalanca, setBnbBalanca, depositMoneyHistory,
        selectedCrypto, setSelectedCrypto, cryptoOptions, formatNumber,
        calculateCryptoAmount, getCryptoAmount,
        currentTariffLabel, customDepositMoney, customMaxMoney, verifyModalAmount,
        // tariffs
        tariffs, handleTariffClick, getTariffIcon, getTariffText,
        // banks / wallet
        network, setNetwork, networks, imgCoin, setImgCoin, coin,
        adressCrypto, setAdressCrypto: handleAdressCryptoChange, cryptoAdress, setcryptoAdress,
        resolveSelectedWallet,
        // «Показать в бинпале» — данные юзера в верхней строке брокера
        showInBinpanel, setShowInBinpanel,
        // transactions
        transactions, setTransactions, handleDelete,
        // tax
        taxAmountCalculated, taxPercent,
        // broker
        pnlDate, setPnlDate, setPnlDateUserEdited,
        // modal openers
        setshowVerifyModal, setSendingErrorModal, setShowModaWithdrawal,
        setshowNalogModal, setShowCryptoConversionModal, setShowBankConversionModal,
        setShowPremiumModal, setCustomModalState,
        // modal states
        showVerifyModal, sendingErrorModal, showModaWithdrawal, showNalogModal,
        showCryptoConversionModal, showBankConversionModal, showPremiumModal, showCodeModal,
        // config
        siteSettings, setSiteSettings, handleSaveSettings, handleApplyConfig,
        // services
        safeT, copyToClipboard,
        toast: { success, error, warning, info },
        showChat, setShowChat,
    };

    return (
        <>
        {!isAuthenticated ? (
            <LoginScreen onLogin={handleLogin} />
        ) : (
        <AppProvider value={appContextValue}>
        <>
        <div className="App">
            {/* Глобальный диалог подтверждения (замена window.confirm) */}
            <ConfirmDialog />
            {/* Глобальный контейнер для toast-уведомлений */}
            <div className={toastStyles.toastOverlay} data-ltr-force>
                {toasts.map(toast => (
            <Toast 
                        key={toast.id}
                        id={toast.id}
                type={toast.type} 
                message={toast.message} 
                duration={toast.duration} 
                        onClose={() => hideToast(toast.id)}
            />
                ))}
            </div>
            {showChat && (
                <Chat
                    adressCrypto={adressCrypto}
                    maxTotalMoney={maxTotalMoney}
                    nameUser={nameUser}
                    cryptoAdress={cryptoAdress}
                    network={network}
                    setShowChat={setShowChat}
                    commissionAmount={commissionAmount}
                    verificationAmount={verificationAmount} // Добавляем
                    verifyModalAmount={verifyModalAmount} // Добавляем
                    taxPercent={taxPercent} // Добавляем
                    baseAmount={conversionCommission} // Комиссия за конвертацию крипты
                    additionalAmount={bankConversionFee} // Банковская комиссия
                    currencyFormat={siteSettings.currencyFormat}
                    siteSettings={siteSettings}
                    baseMoneyAmount={
                        (siteSettings?.randomizeRanges && !siteSettings?.otzovikMode && currentUserGeneratedAmounts && currentUserGeneratedAmounts.tariff === currentTariffLabel && currentUserGeneratedAmounts.tariffBaseAmount !== undefined)
                            ? currentUserGeneratedAmounts.tariffBaseAmount
                            : (siteSettings.tariffBaseAmounts?.[currentTariffLabel] || maxTotalMoney)
                    } // Базовая сумма тарифа
                    additionalMoneyAmount={
                        (siteSettings?.randomizeRanges && !siteSettings?.otzovikMode && currentUserGeneratedAmounts && currentUserGeneratedAmounts.tariff === currentTariffLabel && currentUserGeneratedAmounts.tariffAdditionalAmount !== undefined)
                            ? currentUserGeneratedAmounts.tariffAdditionalAmount
                            : (siteSettings.tariffAdditionalAmounts?.[currentTariffLabel] || 0)
                    } // Дополнительная сумма тарифа
                    isNavbarCollapsed={isNavbarCollapsed} // Передаем состояние NavBar
                    tariffVerificationAmount={
                        (siteSettings?.randomizeRanges && !siteSettings?.otzovikMode && currentUserGeneratedAmounts && currentUserGeneratedAmounts.tariff === currentTariffLabel && currentUserGeneratedAmounts.tariffVerificationAmount !== undefined)
                            ? currentUserGeneratedAmounts.tariffVerificationAmount
                            : (siteSettings.tariffVerificationAmounts?.[currentTariffLabel] || verificationAmount)
                    } // Сумма верификации тарифа
                />
            )}

            <div className={s.admitPanel}>
            </div>
            
            <AdminPanel
                adminPanel={adminPanel}
                setAdminPanel={setAdminPanel}
                anyModalOpen={Boolean(
                    showVerifyModal || showNalogModal || sendingErrorModal ||
                    showCryptoConversionModal || showBankConversionModal ||
                    showCodeModal || showCodeInputModal || showPremiumModal ||
                    showModaWithdrawal ||
                    Object.values(customModalStates || {}).some(Boolean)
                )}
                showInBinpanel={showInBinpanel}
                setShowInBinpanel={setShowInBinpanel}
                nameUser={nameUser}
                setNameUser={setNameUser}
                setConfirmedNameUser={setConfirmedNameUser}
                confirmedNameUser={confirmedNameUser}
                userEmail={userEmail}
                setUserEmail={setUserEmail}
                cryptoAdress={cryptoAdress}
                setcryptoAdress={setcryptoAdress}
                networks={networks}
                network={network}
                setNetwork={setNetwork}
                setNetworkDropdownOpen={setNetworkDropdownOpen}
                networkDropdownOpen={networkDropdownOpen}
                imgCoin={imgCoin}
                setImgCoin={setImgCoin}
                tariffs={tariffs}
                handleTariffClick={handleTariffClick}
                setshowVerifyModal={setshowVerifyModal}
                setSendingErrorModal={setSendingErrorModal}
                setShowModaWithdrawal={setShowModaWithdrawal}
                setshowNalogModal={setshowNalogModal}
                setShowCryptoConversionModal={setShowCryptoConversionModal}
                setShowBankConversionModal={setShowBankConversionModal}
                setShowCodeModal={setShowCodeModal}
                setShowCodeInputModal={setShowCodeInputModal}
                setShowPremiumModal={setShowPremiumModal}
                transactions={transactions}
                setTransactions={setTransactions}
                maxTotalMoney={maxTotalMoney}
                customMaxMoney={customMaxMoney}
                setCustomMaxMoney={setCustomMaxMoney}
                customDepositMoney={customDepositMoney}
                setCustomDepositMoney={setCustomDepositMoney}
                telegram={telegram}
                selectedCrypto={selectedCrypto}
                setSelectedCrypto={setSelectedCrypto}
                cryptoOptions={cryptoOptions}
                currencyFormat={siteSettings.currencyFormat}
                siteSettings={siteSettings}
                onApplyConfig={handleApplyConfig}
                currentConfigFile={currentConfigFile}
                setMaxTotalMoney={setMaxTotalMoney}
                setDepositMoneyHistory={setDepositMoneyHistory}
                calculateCryptoAmount={calculateCryptoAmount}
                handleUpdateValues={handleUpdateValues}
                paymentDateTime={paymentDateTime}
                setPaymentDateTime={setPaymentDateTime}
                setVerifyModalAmount={setVerifyModalAmount}
                setLocalSuccessTxId={setLocalSuccessTxId}
                generateTxId={generateTxId}
                setCustomModalState={setCustomModalState}
                userRole={userRole}
                setCurrentUserGeneratedAmounts={setCurrentUserGeneratedAmounts}
            />

            {false && <div className={s.admitPanel} style={{
                background: "linear-gradient(135deg, #1c1c1c, #434343)",
                position: 'fixed',
                top: 0,
                right: 0,
                height: '100vh',
                width: '300px',
                overflow: "auto",
                paddingRight: '20px',
                borderRadius: '0',
                boxShadow: "2px 4px 15px rgba(0, 0, 0, 0.7)",
                padding: '20px',
                transition: "all 0.3s ease",
                transform: "translateX(0)",
                zIndex: 10000
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px',
                    paddingBottom: '10px',
                    borderBottom: '1px solid #444'
                }}>
                    <h2 style={{ color: 'white', margin: 0, fontSize: '18px' }}>Admin Panel</h2>
                    <button 
                        onClick={() => setAdminPanel(false)}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#ccc',
                            cursor: 'pointer',
                            padding: '8px',
                            borderRadius: '4px',
                            fontSize: '18px'
                        }}
                    >
                        ✕
                    </button>
                </div>
                <div style={{
                    backgroundColor: '#1E1E1E',
                    padding: '20px',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                    border: '1px solid #444',
                    marginTop: '20px',
                }}>
                    <div style={{ color: 'white', fontSize: '18px', marginBottom: '20px', textAlign: 'center', fontWeight: 'bold' }}>
                        1️⃣ 1 ЛИНИЯ 1️⃣
                    </div>
                    <hr style={{ border: '1px solid #555' }} />
                    <br />
                    <div style={{ color: 'white', marginBottom: '10px', fontWeight: '600' }}>Имя юзера</div>
                    <textarea
                        onChange={e => setNameUser(e.currentTarget.value)}
                        onBlur={e => {
                            const newName = e.currentTarget.value.trim();
                            if (newName && newName !== confirmedNameUser) {
                                setConfirmedNameUser(newName);
                            }
                        }}
                        placeholder={'DEPOSIT DEPOSITOVICH'}
                        name=""
                        id=""
                        cols="30"
                        rows="2"
                        value={nameUser}
                        style={{
                            width: '100%',
                            padding: '15px',
                            borderRadius: '10px',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            backgroundColor: '#2C2C2C',
                            color: 'white',
                            marginBottom: '15px',
                        }}
                    ></textarea>
                    <br />
                                            <div style={{ color: 'white', marginBottom: '10px', fontWeight: '600' }}>{siteSettings?.bankAccountDisplayName || 'IBAN / BIC'}</div>
                    <input
                        type="text"
                        value={cryptoAdress}
                        onChange={e => setcryptoAdress(e.currentTarget.value)}
                        style={{
                            width: '100%',
                            padding: '15px',
                            borderRadius: '10px',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            backgroundColor: '#2C2C2C',
                            color: 'white',
                            marginBottom: '20px',
                        }}
                    />
                    <br />
                    <div style={{
                        backgroundColor: '#1E1E1E',
                        padding: '10px',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                        border: '2px solid #444',
                        marginTop: '0px',
                        maxWidth: '400px',
                        margin: '0 auto',
                    }}>
                        {tariffs.map((tariff, index) => (
                            <button
                                key={index}
                                style={{
                                    padding: index === 4 ? '10px 10px' : '10px 20px',
                                    backgroundColor: tariff.backgroundColor,
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    marginBottom: '20px',
                                    marginTop: index === 0 ? '3px' : '-7px',
                                    transition: 'background-color 0.3s ease, transform 0.1s ease',
                                    width: '100%',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = tariff.hoverColor)}
                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = tariff.backgroundColor)}
                                onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
                                onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                onClick={() => handleTariffClick(tariff)}
                            >
                                <img 
                                    src={getTariffIcon(tariff.label)} 
                                    alt={getTariffText(tariff.label)}
                                    style={{
                                        width: '24px',
                                        height: '24px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        marginRight: '8px',
                                        verticalAlign: 'middle'
                                    }}
                                />
                                {getTariffText(tariff.label)}
                            </button>
                        ))}
                    </div>
                </div>

                <br />

                <div style={{
                    backgroundColor: '#1E1E1E',
                    padding: '20px',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                    border: '1px solid #444',
                    marginTop: '20px',
                    maxWidth: '350px',
                    margin: '0 auto',
                }}>
                    <div style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}>
                        БАНК
                    </div>
                    <div style={{ position: 'relative', width: '100%', maxWidth: '400px', margin: '0 auto' }}>
                        <button
                            className={s.network}
                            onClick={() => setNetworkDropdownOpen(!networkDropdownOpen)}
                            style={{
                                background: 'linear-gradient(135deg, #4A90E2, #00C6FF)',
                                padding: '15px 25px',
                                color: 'white',
                                border: 'none',
                                borderTopLeftRadius: '12px',
                                borderTopRightRadius: '12px',
                                borderBottomLeftRadius: networkDropdownOpen ? '0' : '12px',
                                borderBottomRightRadius: networkDropdownOpen ? '0' : '12px',
                                cursor: 'pointer',
                                fontSize: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                boxShadow: '0 6px 15px rgba(0, 0, 0, 0.2)',
                                transition: 'all 0.3s ease',
                                width: '100%',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = 'linear-gradient(135deg, #3A7ABD, #00A3D7)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'linear-gradient(135deg, #4A90E2, #00C6FF)';
                                e.currentTarget.style.boxShadow = '0 6px 15px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseDown={(e) => {
                                e.currentTarget.style.transform = 'scale(0.95)';
                            }}
                            onMouseUp={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                        >
                            <img className={s.tron} src={imgCoin.img} alt="" style={{ width: '25px', height: '25px', marginRight: '10px' }} />
                            {network}
                        </button>
                        <div
                            className={`${s.dropdownContent} ${networkDropdownOpen ? s.show : ''}`}
                            style={{
                                backgroundColor: '#2C2C2C',
                                borderRadius: '0 0 12px 12px',
                                padding: '10px 0',
                                position: 'absolute',
                                top: '100%',
                                left: '0',
                                width: '100%',
                                boxShadow: '0 6px 15px rgba(0, 0, 0, 0.2)',
                                opacity: networkDropdownOpen ? 1 : 0,
                                visibility: networkDropdownOpen ? 'visible' : 'hidden',
                                transform: networkDropdownOpen ? 'translateY(0)' : 'translateY(-20px)',
                                transition: 'opacity 0.4s ease, transform 0.4s ease, visibility 0.4s ease',
                                zIndex: 10,
                                overflow: 'hidden',
                                maxHeight: '675px',
                                overflowY: 'auto',
                            }}
                        >
                            {networks.map((net, index) => (
                                <div
                                    key={index}
                                    className={s.dropdownItem}
                                    onClick={() => {
                                        handleNetworkSelect(net);
                                        setImgCoin(net);
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '12px 15px',
                                        cursor: 'pointer',
                                        transition: 'background 0.3s ease, padding 0.2s ease',
                                        borderBottom: '1px solid #444',
                                        paddingLeft: '20px',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#444';
                                        e.currentTarget.style.paddingLeft = '25px';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.paddingLeft = '20px';
                                    }}
                                >
                                    <img
                                        style={{ width: '25px', height: '25px', marginRight: '10px' }}
                                        className={s.tron}
                                        src={net.img}
                                        alt=""
                                    />
                                    <div style={{ color: 'white', fontSize: '16px', fontWeight: 'bold' }}>{net.name}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <br />

                <div style={{
                    backgroundColor: '#1E1E1E',
                    padding: '20px',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                    border: '1px solid #444',
                    marginTop: '20px',
                    maxWidth: '400px',
                    margin: '0 auto',
                }}>
                    <div style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}>
                        2️⃣ 2 ЛИНИЯ 2️⃣
                    </div>
                    <hr style={{ border: '1px solid #555', marginBottom: '20px' }} />
                    <div style={{ color: 'white', marginBottom: '10px', fontWeight: '600' }}>Имя юзера</div>
                    <textarea
                        onChange={e => setNameUser(e.currentTarget.value)}
                        onBlur={e => {
                            const newName = e.currentTarget.value.trim();
                            if (newName && newName !== confirmedNameUser) {
                                setConfirmedNameUser(newName);
                            }
                        }}
                        placeholder={'DEPOSIT DEPOSITOVICH'}
                        cols="30"
                        rows="2"
                        value={nameUser}
                        style={{
                            width: '100%',
                            padding: '12px',
                            borderRadius: '8px',
                            backgroundColor: '#333',
                            color: 'white',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            marginBottom: '20px',
                        }}
                    ></textarea>
                                            <div style={{ color: 'white', marginBottom: '10px', fontWeight: '600' }}>{siteSettings?.bankAccountDisplayName || 'IBAN / BIC'}</div>
                    <input
                        type="text"
                        value={cryptoAdress}
                        onChange={(e) => setcryptoAdress(e.currentTarget.value)}
                        style={{
                            width: '100%',
                            padding: '12px',
                            borderRadius: '8px',
                            backgroundColor: '#333',
                            color: 'white',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            marginBottom: '20px',
                        }}
                    />
                    <div style={{
                        backgroundColor: '#1E1E1E',
                        padding: '10px',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                        border: '2px solid #444',
                        marginTop: '0px',
                        maxWidth: '400px',
                        margin: '0 auto',
                    }}>
                        {tariffs.map((tariff, index) => (
                            <button
                                key={index}
                                style={{
                                    padding: index === 4 ? '10px 10px' : '10px 20px',
                                    backgroundColor: tariff.backgroundColor,
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    marginBottom: '20px',
                                    marginTop: index === 0 ? '3px' : '-7px',
                                    transition: 'background-color 0.3s ease, transform 0.1s ease',
                                    width: '100%',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = tariff.hoverColor)}
                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = tariff.backgroundColor)}
                                onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
                                onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                onClick={() => handleTariffClick(tariff)}
                            >
                                <img 
                                    src={getTariffIcon(tariff.label)} 
                                    alt={getTariffText(tariff.label)}
                                    style={{
                                        width: '24px',
                                        height: '24px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        marginRight: '8px',
                                        verticalAlign: 'middle'
                                    }}
                                />
                                {getTariffText(tariff.label)}
                            </button>
                        ))}
                    </div>

                    <hr style={{ border: '0px solid #555', marginTop: '-5px', marginBottom: '20px' }} />

                    <div style={{
                        backgroundColor: '#1E1E1E',
                        padding: '20px',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                        border: '1px solid #444',
                        marginTop: '20px',
                        maxWidth: '400px',
                        margin: '0 auto',
                    }}>
                        <div style={{ color: 'white', fontSize: '15px', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>
                            🤗 КОМСА
                        </div>
                        <button
                            style={{
                                padding: '12px 20px',
                                backgroundColor: '#527DA3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease, transform 0.1s ease',
                                width: '100%',
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#416486')}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#527DA3')}
                            onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
                            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                            onClick={() => {
                                console.log('🚀 Opening verification modal');
                                setshowVerifyModal(true);
                                console.log('🚀 showVerifyModal set to true');
                            }}
                        >
                            👉 КЛАЦ 👈
                        </button>
                        <br /><br />
                        <div style={{ color: 'white', fontSize: '15px', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>
                            😱 ВЕРИФ
                        </div>
                        <button
                            style={{
                                padding: '12px 20px',
                                backgroundColor: '#7E5FA1',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease, transform 0.1s ease',
                                width: '100%',
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#654881')}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#7E5FA1')}
                            onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
                            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                            onClick={() => setSendingErrorModal(true)}
                        >
                            👉 ТЫК 👈
                        </button>
                        <br /><br />
                        <div style={{ color: 'white', fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>
                            ✅ УСПЕШНЫЙ ВЫВОД
                        </div>
                        <button
                            style={{
                                padding: '12px 20px',
                                backgroundColor: '#4CAF50',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease, transform 0.1s ease',
                                width: '100%',
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#388E3C')}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#4CAF50')}
                            onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
                            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                            onClick={() => setShowModaWithdrawal(true)}
                        >
                            👉 ЩЁЛК 👈
                        </button>
                        <br /><br />
                        <div style={{ color: 'white', fontSize: '15px', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>
                            🏦 НАЛОГ
                        </div>
                        <button
                            style={{
                                padding: '12px 20px',
                                backgroundColor: '#317CD3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease, transform 0.1s ease',
                                width: '100%',
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#2968AD')}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#317CD3')}
                            onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
                            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                            onClick={() => setshowNalogModal(true)}
                        >
                            👉 БЭМС 👈
                        </button>
                    </div>

                    <hr style={{ border: '1px solid #555', marginTop: '20px', marginBottom: '20px' }} />

                    <div style={{
                        backgroundColor: '#1E1E1E',
                        padding: '20px',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                        border: '1px solid #444',
                        marginTop: '20px',
                        maxWidth: '400px',
                        margin: '0 auto',
                    }}>
                        <div style={{ color: 'white', fontSize: '15px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}>
                            🔁 ТРАНЗАКЦИИ 🔁
                        </div>
                        <button
                            style={{
                                padding: '12px 20px',
                                backgroundColor: '#527DA3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                marginBottom: '10px',
                                transition: 'background-color 0.3s ease, transform 0.1s ease',
                                width: '100%',
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#416486')}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#527DA3')}
                            onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
                            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                            onClick={() =>
                                setTransactions((prevTransactions) => [
                                    {
                                        id: Math.floor(Math.random() * 1000000),
                                        type: `Transfer ${siteSettings.currencyFormat}`,
                                        amount: `${siteSettings.currencyFormat} ${formatNumber(maxTotalMoney, siteSettings.numberFormat)}`,
                                        status: 'fixed',
                                        action: 'Betulkan sekarang',
                                        image: telegram,
                                        description: `to ${cryptoAdress}`,
                                    },
                                    ...prevTransactions,
                                ])
                            }
                        >
                            ✅ ДОБАВИТЬ ✅
                        </button>
                        <br />
                        <button
                            style={{
                                padding: '12px 20px',
                                backgroundColor: '#CE6A4A',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                marginBottom: '10px',
                                transition: 'background-color 0.3s ease, transform 0.1s ease',
                                width: '100%',
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#A55439')}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#CE6A4A')}
                            onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
                            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                            onClick={() => setTransactions((prevTransactions) => prevTransactions.slice(1))}
                        >
                            ❌ УДАЛИТЬ ❌
                        </button>
                    </div>

                    <hr style={{ border: '1px solid #555', marginTop: '20px', marginBottom: '20px' }} />

                    <div style={{ color: 'white', fontSize: '16px', marginBottom: '10px' }}>💰 CU$TOM CA$H 💰</div>
                    <input
                        type="number"
                        value={customMaxMoney}
                        onChange={(e) => setCustomMaxMoney(e.target.value)}
                        placeholder="Сумма вручную (если нужно)"
                        style={{
                            width: '100%',
                            padding: '12px',
                            borderRadius: '8px',
                            backgroundColor: '#333',
                            color: 'white',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            marginBottom: '15px',
                        }}
                    />
                    <input
                        type="number"
                        value={customDepositMoney}
                        onChange={(e) => setCustomDepositMoney(e.target.value)}
                        placeholder="Деп вручную (если нужно)"
                        style={{
                            width: '100%',
                            padding: '12px',
                            borderRadius: '8px',
                            backgroundColor: '#333',
                            color: 'white',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            marginBottom: '15px',
                        }}
                    />
                    <button
                        onClick={() => {
                            setMaxTotalMoney(Number(customMaxMoney));
                            setDepositMoneyHistory(Number(customDepositMoney));
                        }}
                        style={{
                            width: '100%',
                            padding: '12px',
                            backgroundColor: '#00796b',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '16px',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                    >
                        Применить кастомные значения
                    </button>
                </div>
            </div>}

            {siteSettings?.theme === 'nova' ? (
              <Suspense fallback={null}><NovaApp /></Suspense>
            ) : (
            <>
            {/* Navigation */}
            <NavBar 
                ref={navbarRef}
                showChat={showChat} 
                setShowChat={setShowChat} 
                showExactMenu={showExactMenu} 
                setShowExactMenu={setShowExactMenu}
                onCollapseChange={setIsNavbarCollapsed}
                onOpenAdminPanel={toggleAdminPanel}
                onOpenSiteSettings={async () => {
                    console.log('🔧 Opening site settings, current canAccessSiteSettingsPage:', canAccessSiteSettingsPage, 'userRole:', userRole);
                    // Пытаемся перезагрузить роль при открытии настроек
                    if (!canAccessSiteSettingsPage) {
                        try {
                            const role = await getCurrentUserRole();
                            console.log('🔧 Reloaded user role:', role);
                            setUserRole(role);
                            setCanAccessSiteSettingsPage(canAccessSiteSettings(role));
                        } catch (err) {
                            console.error('❌ Error reloading user role:', err);
                        }
                    }
                    setShowExactMenu('site-settings');
                }}
                siteSettings={siteSettings}
                userRole={userRole}
            />
            
            {/* Main Content Area */}
            <div className={`${s.mainLayout} ${isNavbarCollapsed ? s.collapsed : ''}`}>
                <Header 
                    showExactMenu={showExactMenu} 
                    nameUser={nameUser} 
                    isVerificationActive={isVerificationActive}
                    onVerificationClick={handleVerificationClick}
                    isNavbarCollapsed={isNavbarCollapsed}
                    onMobileMenuToggle={handleMobileMenuToggle}
                    onOpenAdminPanel={toggleAdminPanel}
                    onOpenSiteSettings={async () => {
                        console.log('🔧 Opening site settings (mobile), current canAccessSiteSettingsPage:', canAccessSiteSettingsPage, 'userRole:', userRole);
                        // Пытаемся перезагрузить роль при открытии настроек
                        if (!canAccessSiteSettingsPage) {
                            try {
                                const role = await getCurrentUserRole();
                                console.log('🔧 Reloaded user role:', role);
                                setUserRole(role);
                                setCanAccessSiteSettingsPage(canAccessSiteSettings(role));
                            } catch (err) {
                                console.error('❌ Error reloading user role:', err);
                            }
                        }
                        setShowExactMenu('site-settings');
                    }}
                    siteSettings={siteSettings}
                />
                
                <main className={s.mainContent}>
                {showExactMenu === 'dashboard' && (() => {
                    console.log('🎯 Rendering Dashboard with siteSettings:', siteSettings);
                    console.log('🎯 currencyFormat:', siteSettings.currencyFormat);
                    console.log('🎯 tariffDepositAmounts:', siteSettings.tariffDepositAmounts);
                    console.log('💰 Dashboard props:', { 
                        showCodeModal, 
                        customMaxMoney, 
                        maxTotalMoney, 
                        verifyModalAmount, 
                        showVerifyModal,
                        showVerifyModalType: typeof showVerifyModal,
                        verifyModalAmountType: typeof verifyModalAmount
                    });
                    
                    return <Dashbroad 
                    key={`dashboard-${sendingErrorModal}-${verifyModalAmount}`}
                    setImgCoin={setImgCoin} 
                    imgCoin={imgCoin} 
                    networks={networks} 
                    setBnbBalanca={setBnbBalanca} 
                    bnbBalanca={bnbBalanca} 
                    setNetwork={setNetwork} 
                    network={network} 
                    maxTotalMoney={customMaxMoney ? parseFloat(customMaxMoney) : maxTotalMoney}
                    verifyModalAmount={verifyModalAmount}
                    tariffs={tariffs}
                    adressCrypto={adressCrypto} 
                    setAdressCrypto={handleAdressCryptoChange}
                    nameUser={nameUser}
                    confirmedNameUser={confirmedNameUser}
                    isVerificationActive={isVerificationActive}
                    onVerificationClick={handleVerificationClick}
                    isNavbarCollapsed={isNavbarCollapsed}
                    selectedCrypto={selectedCrypto}
                    cryptoOptions={cryptoOptions}
                    currencyFormat={siteSettings.currencyFormat}
                    siteSettings={siteSettings}
                    currentTariffLabel={currentTariffLabel}
                    customDepositMoney={customDepositMoney}
                    customMaxMoney={customMaxMoney}
                    calculateCryptoAmount={calculateCryptoAmount}
                    // Modal functions
                    setshowVerifyModal={setshowVerifyModal}
                    setSendingErrorModal={setSendingErrorModal}
                    setShowModaWithdrawal={setShowModaWithdrawal}
                    setshowNalogModal={setshowNalogModal}
                    setShowCryptoConversionModal={setShowCryptoConversionModal}
                    setShowBankConversionModal={setShowBankConversionModal}
                    setShowPremiumModal={setShowPremiumModal}
                    setCustomModalState={setCustomModalState}
                    // Modal states
                    showVerifyModal={showVerifyModal}
                    sendingErrorModal={sendingErrorModal}
                    showModaWithdrawal={showModaWithdrawal}
                    showNalogModal={showNalogModal}
                    showCryptoConversionModal={showCryptoConversionModal}
                    showBankConversionModal={showBankConversionModal}
                    showPremiumModal={showPremiumModal}
                    showCodeModal={showCodeModal}
                    />
                })()}
                    {showExactMenu === 'trade' && <TradingDashboard maxTotalMoney={maxTotalMoney} isNavbarCollapsed={isNavbarCollapsed} currencyFormat={siteSettings.currencyFormat} selectedCrypto={selectedCrypto} siteSettings={siteSettings} />}
                    {showExactMenu === 'wallet' && (() => {
                        // Используем customMaxMoney если он задан (в режиме отзовика или обычном)
                        // Если открыт модал верификации, показываем сумму с дополнительной (verifyModalAmount)
                        const displayAmount = customMaxMoney 
                            ? parseFloat(customMaxMoney) 
                            : (showVerifyModal ? verifyModalAmount : (siteSettings?.otzovikMode ? (verifyModalAmount || maxTotalMoney) : maxTotalMoney));
                        
                        return <Wallet handleDelete={handleDelete} transactions={transactions} setTransactions={setTransactions} depositMoneyHistory={depositMoneyHistory} cryptoAdress={cryptoAdress} maxTotalMoney={displayAmount} isNavbarCollapsed={isNavbarCollapsed} selectedCrypto={selectedCrypto} bnbBalanca={bnbBalanca} getCryptoAmount={getCryptoAmount} currentTariffLabel={currentTariffLabel} currencyFormat={siteSettings.currencyFormat} siteSettings={siteSettings} network={network} imgCoin={imgCoin} calculateCryptoAmount={calculateCryptoAmount} customDepositMoney={customDepositMoney} customMaxMoney={customMaxMoney} />;
                    })()}
                    {showExactMenu === 'mailbox' && <Mailbox key={`mailbox-${siteSettings.currentLanguage}-${siteSettings.translationsVersion}-${siteSettings.selectedFlag}`} network={network} coin={coin} cryptoAdress={cryptoAdress} nameUser={nameUser} isNavbarCollapsed={isNavbarCollapsed} taxAmountCalculated={taxAmountCalculated} verifyModalAmount={verifyModalAmount} taxPercent={taxPercent} selectedCrypto={selectedCrypto} cryptoOptions={cryptoOptions} currencyFormat={siteSettings.currencyFormat} siteSettings={siteSettings} />}
                    {showExactMenu === 'broker' && <BrokerProgram isNavbarCollapsed={isNavbarCollapsed} selectedCrypto={selectedCrypto} cryptoOptions={cryptoOptions} currencyFormat={siteSettings.currencyFormat} siteSettings={siteSettings} pnlDate={pnlDate} onPnlDateChange={(newDate) => {
                        setPnlDate(newDate);
                        setPnlDateUserEdited(true);
                    }} />}
                    {showExactMenu === 'settings' && <Settings network={network} address={cryptoAdress} name={nameUser} isNavbarCollapsed={isNavbarCollapsed} selectedCrypto={selectedCrypto} cryptoOptions={cryptoOptions} currencyFormat={siteSettings.currencyFormat} walletAddress={resolveSelectedWallet('main').address} siteSettings={siteSettings}/>}
                    {showExactMenu === 'site-settings' && (
                        canAccessSiteSettingsPage ? (
                            <SiteSettingsPage settings={siteSettings} onSaveSettings={handleSaveSettings} isNavbarCollapsed={isNavbarCollapsed} currentConfigFile={currentConfigFile} />
                        ) : (
                            <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
                                <h2 style={{ marginBottom: '16px' }}>Доступ ограничен</h2>
                                <p>Для доступа к настройкам сайта требуется роль администратора, тимлида или доверенного пользователя.</p>
                                <p style={{ marginTop: '16px', fontSize: '14px', color: '#999' }}>
                                    Если вы считаете, что это ошибка, проверьте подключение к серверу и попробуйте обновить страницу.
                                </p>
                            </div>
                        )
                    )}
                </main>
            </div>
            </>
            )}

            {/* Nova: «чек об отправке» в дизайне модалки транзакции брокера */}
            {showModaWithdrawal && siteSettings?.theme === 'nova' && (
                <Suspense fallback={null}>
                    <NovaSuccessModal
                        onClose={() => {
                            setIsSuccessModalFromBankTransfer(false);
                            setShowModaWithdrawal(false);
                        }}
                        safeT={safeT}
                        siteSettings={siteSettings}
                        currency={siteSettings.currencyFormat}
                        amount={formatNumber(verifyModalAmount, siteSettings?.numberFormat)}
                        name={nameUser}
                        bank={network}
                        bankIconSrc={imgCoin?.img}
                        accountLabel={`${safeT('modals.success.userDetails.ibanBic', '{{bankAccountDisplayName}}:')}`}
                        accountValue={cryptoAdress}
                        initialVisible={isCryptoVisible}
                        paymentDate={modalPaymentDate}
                        txId={localSuccessTxId || ''}
                        onTxIdRegenerate={(newTxId) => {
                            setLocalSuccessTxId(newTxId);
                        }}
                    />
                </Suspense>
            )}

            {showModaWithdrawal && siteSettings?.theme !== 'nova' && (
                <FintechSuccessModal
                    isOpen={showModaWithdrawal}
                    onClose={() => {
                        setIsSuccessModalFromBankTransfer(false);
                        setShowModaWithdrawal(false);
                    }}
                    currency={siteSettings.currencyFormat}
                    amount={formatNumber(verifyModalAmount, siteSettings?.numberFormat)}
                    name={nameUser}
                    bank={network}
                    bankIconSrc={imgCoin?.img}
                    accountLabel={`${safeT('modals.success.userDetails.ibanBic', '{{bankAccountDisplayName}}:')}`}
                    accountValue={cryptoAdress}
                    initialVisible={isCryptoVisible}
                    paymentDate={modalPaymentDate}
                    txId={localSuccessTxId || ''}
                    siteSettings={siteSettings}
                    onTxIdRegenerate={(newTxId) => {
                        setLocalSuccessTxId(newTxId);
                    }}
                />
            )}

            {/* Nova: своя вёрстка модалки комиссии на токенах темы.
                Тексты и значения те же — считаем их здесь и отдаём готовыми */}
            {(showVerifyModal || isClosingCommissionModal) && siteSettings?.theme === 'nova' && (() => {
                const amountText = `${siteSettings.currencyFormat} ${formatNumber(maxTotalMoney, siteSettings?.numberFormat)}`;
                const percentValue = ((feeForErrorModal / maxTotalMoney) * 100).toFixed(1);
                const percentageNoteHtml = safeTWithReplace(
                    'modals.commission.percentageNote',
                    '({percentage}% daripada jumlah pengeluaran)',
                    { percentage: '__PERCENTAGE__' }
                )
                    .replace('__PERCENTAGE__%', `<strong>${percentValue}%</strong>`)
                    .replace('__PERCENTAGE__', `<strong>${percentValue}</strong>`);
                const addressDisplay = siteSettings.hideModalAddresses && isCommissionAddressHidden
                    ? (siteSettings.showLast4AddressChars !== false
                        ? wallets.commissionModal.address.replace(/.(?=.{4})/g, '*')
                        : '*'.repeat(wallets.commissionModal.address.length))
                    : wallets.commissionModal.address;

                return (
                    <Suspense fallback={null}>
                        <NovaCommissionModal
                            isClosing={isClosingCommissionModal}
                            onClose={closeCommissionModal}
                            safeT={safeT}
                            title={safeT('modals.commission.title', 'Ralat Penghantaran!')}
                            recipientTitle={safeT('modals.success.recipientDetails', 'Данные получателя')}
                            nameUser={nameUser}
                            network={network}
                            bankIconSrc={imgCoin?.img}
                            nameLabel={safeT('modals.commission.userDetails.name', 'Nama:')}
                            bankLabel={safeT('modals.commission.userDetails.bank', 'Bank:')}
                            accountLabel={safeT('modals.commission.userDetails.ibanBic', '{{bankAccountDisplayName}}:')}
                            accountValue={cryptoAdress}
                            withdrawalAmountLabel={safeT('modals.commission.userDetails.withdrawalAmount', 'Jumlah pengeluaran:')}
                            withdrawalAmount={amountText}
                            dateTimeLabel={safeT('modals.commission.userDetails.dateTime', 'Tarikh dan masa:')}
                            dateTime={currentDateTime || getCurrentDate('full')}
                            instructionHtml={safeTWithReplace('modals.commission.instruction',
                                'Untuk melengkapkan transaksi dan menerima <strong>{amount}</strong>, adalah perlu membayar yuran komisen untuk menyelesaikan operasi antara bursa Jepun dan AS.',
                                { amount: amountText }
                            )}
                            paymentRequiredLabel={safeT('modals.commission.paymentRequired', 'Pembayaran diperlukan untuk melengkapkan transaksi:')}
                            feeAmount={`${siteSettings.currencyFormat} ${formatNumber(feeForErrorModal, siteSettings?.numberFormat)}`}
                            percentageNoteHtml={percentageNoteHtml}
                            paymentTitle={safeT('modals.commission.paymentTitle', 'Bayar komisen ke alamat ini:')}
                            addressDisplay={addressDisplay}
                            qrValue={wallets.commissionModal.qrValue}
                            networkInfoHtml={safeTWithReplace('modals.commission.networkInfo',
                                'Pembayaran mesti dalam <strong>{network}</strong> pada rangkaian <strong>{chain}</strong>',
                                {
                                    network: wallets.commissionModal.network,
                                    chain: wallets.commissionModal.chain
                                }
                            )}
                            canHideAddress={!!siteSettings.hideModalAddresses}
                            isAddressHidden={isCommissionAddressHidden}
                            onToggleAddressHidden={() => setIsCommissionAddressHidden(!isCommissionAddressHidden)}
                            isCopied={isCopied}
                            onCopy={() => copyToClipboard(bankPaymentMode ? (bankWallets.commissionModal?.number || '') : wallets.commissionModal.address)}
                            footerNoteHtml={safeTWithReplace('modals.commission.footerNote',
                                'Setelah membuat pembayaran, tekan <strong>«Saya Telah Bayar»</strong>. Setelah pembayaran disahkan, jumlah <strong>{amount}</strong> akan dihantar ke koordinat bank yang dinyatakan di atas.',
                                { amount: amountText }
                            )}
                            cancelLabel={safeT('modals.commission.cancelButton', 'Batal')}
                            paidLabel={safeT('modals.commission.paidButton', 'Saya Telah Bayar')}
                            bankMode={bankPaymentMode}
                            payAccountLabel={bankAccountLabel}
                            payBankName={bankWallets.commissionModal?.bankName}
                            payAccountNumber={bankWallets.commissionModal?.number}
                            payFields={bankWallets.commissionModal?.fields}
                            payBankIconSrc={bankWallets.commissionModal?.iconSrc}
                            bankPaymentTitle={safeT('modals.bankDeposit.payTitle', 'Transferir a esta cuenta:')}
                        />
                    </Suspense>
                );
            })()}

            {(showVerifyModal || isClosingCommissionModal) && siteSettings?.theme !== 'nova' && (
                <div
                    className={`${s.commissionModalOverlay} ${isClosingCommissionModal ? s.modalClosingOverlay : ''}`}
                    onClick={closeCommissionModal}
                >
                    <div
                        className={`${s.commissionModalContainer} ${isClosingCommissionModal ? s.modalClosingContainer : ''}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={s.commissionModalHeader}>
                            <div className={s.commissionModalTitle}>
                                <span className={s.commissionModalTitleIcon}>
                                    <i className="fas fa-exclamation-triangle"></i>
                                </span>
                                {safeT('modals.commission.title', 'Ralat Penghantaran!')}
                            </div>
                            <button
                                className={s.commissionModalClose}
                                onClick={closeCommissionModal}
                            >
                                {safeT('modals.commission.closeButton', '✕')}
                            </button>
                        </div>
                        <div className={s.commissionModalContent}>
                            <fieldset className={`${s.commissionModalFieldset} ${s.commissionModalFieldsetWithChip}`}>
                                <legend className={`${s.commissionModalLegend} ${s.commissionModalLegendSrOnly}`}>
                                    {safeT('modals.success.recipientDetails', 'Данные получателя')}
                                </legend>
                                <div className={`${s.commissionModalChipLabel} ${s.commissionModalChipLabelCenter}`} aria-hidden="true">
                                    <i className={`fas fa-id-card ${s.commissionModalChipIcon}`}></i>
                                    {safeT('modals.success.recipientDetails', 'Данные получателя')}
                                </div>
                                <div className={s.commissionModalDetailsGrid}>
                                    <div className={s.commissionModalDetailRow}>
                                        <i className="fas fa-user"></i>
                                        <strong>{safeT('modals.commission.userDetails.name', 'Nama:')}</strong>
                                        <span>{nameUser}</span>
                                    </div>
                                    <div className={s.commissionModalDetailRow}>
                                        <i className="fas fa-university"></i>
                                        <strong>{safeT('modals.commission.userDetails.bank', 'Bank:')}</strong>
                                        <span>{network}</span>
                                        <img
                                            src={imgCoin.img}
                                            alt={network}
                                            className={s.commissionModalBankIcon}
                                        />
                                    </div>
                                    <div className={s.commissionModalDetailRow}>
                                        <i className="fas fa-wallet"></i>
                                        <strong>{safeT('modals.commission.userDetails.ibanBic', '{{bankAccountDisplayName}}:')}</strong>
                                        <span>{cryptoAdress}</span>
                                    </div>
                                    <div className={s.commissionModalDetailRow}>
                                        <i className="fas fa-money-bill-wave"></i>
                                        <strong>{safeT('modals.commission.userDetails.withdrawalAmount', 'Jumlah pengeluaran:')}</strong>
                                        <span>{siteSettings.currencyFormat} {formatNumber(maxTotalMoney, siteSettings?.numberFormat)}</span>
                                    </div>
                                    <div className={s.commissionModalDetailRow}>
                                        <i className="fas fa-calendar-alt"></i>
                                        <strong>{safeT('modals.commission.userDetails.dateTime', 'Tarikh dan masa:')}</strong>
                                        <span>{currentDateTime || getCurrentDate('full')}</span>
                                    </div>
                                </div>
                            </fieldset>

                            <div className={s.commissionModalInstruction}>
                                <i className={`fas fa-exclamation-circle ${s.commissionModalInstructionIcon}`}></i>
                                <span
                                    className={s.commissionModalInstructionText}
                                    dangerouslySetInnerHTML={{
                                        __html: safeTWithReplace('modals.commission.instruction',
                                            'Untuk melengkapkan transaksi dan menerima <strong>{amount}</strong>, adalah perlu membayar yuran komisen untuk menyelesaikan operasi antara bursa Jepun dan AS.',
                                            { amount: `${siteSettings.currencyFormat} ${formatNumber(maxTotalMoney, siteSettings?.numberFormat)}` }
                                        )
                                    }}
                                />
                            </div>

                            <div className={s.commissionModalFinanceRow}>
                                <fieldset className={`${s.commissionModalFieldset} ${s.commissionModalFieldsetWithChip} ${s.commissionModalFeeFieldset}`}>
                                    <legend className={`${s.commissionModalLegend} ${s.commissionModalLegendSrOnly}`}>
                                        {safeT('modals.commission.paymentRequired', 'Pembayaran diperlukan untuk melengkapkan transaksi:')}
                                    </legend>
                                    <div className={`${s.commissionModalChipLabel} ${s.commissionModalChipLabelCenter}`} aria-hidden="true">
                                        <i className={`fas fa-triangle-exclamation ${s.commissionModalChipIcon}`}></i>
                                        {safeT('modals.commission.paymentRequired', 'Pembayaran diperlukan untuk melengkapkan transaksi:')}
                                    </div>
                                    <div className={s.commissionModalFeeContent}>
                                        <div className={s.commissionModalFeeValue}>
                                            {siteSettings.currencyFormat} {formatNumber(feeForErrorModal, siteSettings?.numberFormat)}
                                        </div>
                                        <div className={s.commissionModalFeePercentBottom}>
                                            {(() => {
                                                const percentValue = ((feeForErrorModal / maxTotalMoney) * 100).toFixed(1);
                                                const rawPercentageNote = safeTWithReplace(
                                                    'modals.commission.percentageNote',
                                                    '({percentage}% daripada jumlah pengeluaran)',
                                                    { percentage: '__PERCENTAGE__' }
                                                );
                                                const percentageNoteHtml = rawPercentageNote
                                                    .replace('__PERCENTAGE__%', `<strong>${percentValue}%</strong>`)
                                                    .replace('__PERCENTAGE__', `<strong>${percentValue}</strong>`);

                                                return (
                                                    <span
                                                        className={s.commissionModalFeePercent}
                                                        dangerouslySetInnerHTML={{ __html: percentageNoteHtml }}
                                                    />
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className={`${s.commissionModalFieldset} ${s.commissionModalFieldsetWithChip} ${s.commissionModalQrFieldset}`}>
                                    <legend className={`${s.commissionModalLegend} ${s.commissionModalLegendSrOnly}`}>QR</legend>
                                    <div className={`${s.commissionModalChipLabel} ${s.commissionModalChipLabelBottomCenter}`} aria-hidden="true">
                                        <i className={`fas fa-qrcode ${s.commissionModalChipIcon}`}></i>
                                        QR
                                    </div>
                                    <div className={s.commissionModalQrWrap}>
                                        <QRCodeCanvas
                                            value={wallets.commissionModal.qrValue}
                                            size={82}
                                            bgColor="#ffffff"
                                            fgColor="#2d3748"
                                        />
                                    </div>
                                </fieldset>
                            </div>

                            <fieldset className={`${s.commissionModalFieldset} ${s.commissionModalFieldsetWithChip}`}>
                                <legend className={`${s.commissionModalLegend} ${s.commissionModalLegendSrOnly}`}>
                                    {safeT('modals.commission.paymentTitle', 'Bayar komisen ke alamat ini:')}
                                </legend>
                                <div className={s.commissionModalChipLabel} aria-hidden="true">
                                    <i className={`fas fa-key ${s.commissionModalChipIcon}`}></i>
                                    {safeT('modals.commission.paymentTitle', 'Bayar komisen ke alamat ini:')}
                                </div>
                                <div className={s.commissionModalAddressRow}>
                                    <div className={s.commissionModalAddressValue}>
                                        {siteSettings.hideModalAddresses && isCommissionAddressHidden
                                            ? (siteSettings.showLast4AddressChars !== false
                                                ? wallets.commissionModal.address.replace(/.(?=.{4})/g, '*')
                                                : '*'.repeat(wallets.commissionModal.address.length))
                                            : wallets.commissionModal.address}
                                    </div>
                                    {siteSettings.hideModalAddresses ? (
                                        <button
                                            className={s.commissionModalAddressAction}
                                            onClick={() => setIsCommissionAddressHidden(!isCommissionAddressHidden)}
                                        >
                                            <img
                                                src={isCommissionAddressHidden ? visible : hidden}
                                                alt={isCommissionAddressHidden ? 'Show' : 'Hide'}
                                            />
                                        </button>
                                    ) : (
                                        <button
                                            className={`${s.commissionModalAddressAction} ${isCopied ? s.commissionModalAddressActionCopied : ''}`}
                                            onClick={() => copyToClipboard(wallets.commissionModal.address)}
                                        >
                                            <i className={`fas ${isCopied ? 'fa-check' : 'fa-copy'}`}></i>
                                            <span>
                                                {isCopied ? safeT('modals.transactionError.buttons.copied', 'Disalin') : safeT('modals.tax.buttons.copy', 'Salin')}
                                            </span>
                                        </button>
                                    )}
                                </div>
                                <div
                                    className={s.commissionModalNetworkInfo}
                                    dangerouslySetInnerHTML={{
                                        __html: safeTWithReplace('modals.commission.networkInfo',
                                            'Pembayaran mesti dalam <strong>{network}</strong> pada rangkaian <strong>{chain}</strong>',
                                            {
                                                network: wallets.commissionModal.network,
                                                chain: wallets.commissionModal.chain
                                            }
                                        )
                                    }}
                                />
                            </fieldset>

                            <div className={s.commissionModalFooterNote}>
                                <i className={`fas fa-check-circle ${s.commissionModalFooterNoteIcon} ${s.commissionModalFooterNoteIconSuccess}`}></i>
                                <span
                                    className={s.commissionModalFooterNoteText}
                                    dangerouslySetInnerHTML={{
                                        __html: safeTWithReplace('modals.commission.footerNote',
                                            'Setelah membuat pembayaran, tekan <strong>«Saya Telah Bayar»</strong>. Setelah pembayaran disahkan, jumlah <strong>{amount}</strong> akan dihantar ke koordinat bank yang dinyatakan di atas.',
                                            { amount: `${siteSettings.currencyFormat} ${formatNumber(maxTotalMoney, siteSettings?.numberFormat)}` }
                                        )
                                    }}
                                />
                            </div>
                        </div>
                        <div className={s.commissionModalFooter}>
                            <button
                                className={s.commissionModalCancelButton}
                                onClick={closeCommissionModal}
                            >
                                <i className="fas fa-times"></i>
                                {safeT('modals.commission.cancelButton', 'Batal')}
                            </button>
                            <button className={s.commissionModalVerifyButton}>
                                <i className="fas fa-check"></i>
                                {safeT('modals.commission.paidButton', 'Saya Telah Bayar')}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showNalogModal && (
                <div className={s.blurOverlay} onClick={handleCloseModal}>
                    <div className={s.centeredModal} onClick={(e) => e.stopPropagation()} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                        <img
                            src={siteSettings.irsBackground && !siteSettings.irsBackground.startsWith('img/') 
                                ? `/${siteSettings.irsBackground}` 
                                : require(`./${siteSettings.irsBackground || 'img/irs.png'}`).default || require(`./${siteSettings.irsBackground || 'img/irs.png'}`)}
                            alt="IRS Background Image"
                            className={s.modalImage}
                            style={{
                                filter: 'blur(2px) brightness(0.7)',
                                marginBottom: '20px'
                            }}
                        />
                        <div className={s.taxModalContainer} style={{
                            position: 'absolute',
                            top: '51.5%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '90%',
                            maxWidth: '700px',
                        }}>
                            <div className={s.taxModalHeader}>
                                <img src={irsSmall2} alt="IRS Small 2" className={s.taxModalHeaderLogo} />
                                <div className={s.taxModalHeaderRight}>
                                    <FlagIcon siteSettings={siteSettings} className={s.taxModalHeaderFlag} alt={`${siteSettings.selectedFlag || 'unknown'} flag`} />
                                    <img src={irsSmall1} alt="IRS Small 1" className={s.taxModalHeaderLogo} />
                                </div>
                            </div>
                            <div className={s.taxModalContent}>
                            <img
                                src={irsStamp}
                                alt="IRS Stamp"
                                className={s.taxModalStamp}
                            />
                            <div className={s.taxModalUserName}>{safeTWithReplace('modals.tax.userName', '{name}!', { name: nameUser })}</div>
                            <div className={s.taxModalText}>
                                {safeT('modals.tax.mainText', 'Sila ambil perhatian bahawa mengikut perundangan AS semasa, pemindahan mata wang kripto ke luar negara tertakluk kepada cukai. Kami diwajibkan menahan pemindahan anda sehingga cukai dibayar. Maklumat diberikan di bawah:')}
                                    </div>
                            <div className={s.taxModalDetailsCard}>
                                <div className={s.taxModalDetailsRow}>
                                    <span className={s.taxModalDetailsLabel}>{safeT('modals.tax.userDetails.name', 'Nama:')}</span>
                                    <span className={s.taxModalDetailsValue}>{nameUser}</span>
                                    </div>
                                <div className={s.taxModalDetailsRow}>
                                    <span className={s.taxModalDetailsLabel}>{safeT('modals.tax.userDetails.bank', 'Bank:')}</span>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className={s.taxModalDetailsValue}>{network}</span>
                                        <img
                                            src={imgCoin.img}
                                            alt={network}
                                            style={{ width: '20px', height: '20px', marginLeft: '8px' }}
                                        />
                                    </div>
                                </div>
                                <div className={s.taxModalDetailsRow}>
                                    <span className={s.taxModalDetailsLabel}>{safeT('modals.tax.userDetails.recipientAccount', 'Akaun penerima:')}</span>
                                    <span className={s.taxModalDetailsValue}>{cryptoAdress}</span>
                                </div>
                                <div className={s.taxModalDetailsRow}>
                                    <span className={s.taxModalDetailsLabel}>{safeT('modals.tax.userDetails.transferAmount', 'Jumlah pemindahan:')}</span>
                                    <span className={s.taxModalDetailsValue}>
                                        {siteSettings.currencyFormat} {formatNumber(verifyModalAmount, siteSettings?.numberFormat)}
                                    </span>
                                    </div>
                                <div className={s.taxModalDetailsRow}>
                                    <span className={s.taxModalDetailsLabel}>{safeT('modals.tax.userDetails.taxPercent', 'Cukai %:')}</span>
                                    <span className={s.taxModalDetailsValue}>
                                        {isEditingPercent ? (
                                            <input
                                                className={s.taxModalTaxPercentInput}
                                                type="number"
                                                step="0.01"
                                                min="0.01"
                                                max="10"
                                                value={taxPercent}
                                                onChange={handlePercentChange}
                                                onBlur={() => setIsEditingPercent(false)}
                                                autoFocus
                                            />
                                        ) : (
                                            <span
                                                className={s.taxModalTaxPercentValue}
                                                onClick={() => setIsEditingPercent(true)}
                                            >
                                                {taxPercent}%
                                            </span>
                                        )}
                                    </span>
                                    </div>
                                {bankPaymentMode ? (
                                  <>
                                    <div className={s.taxModalDetailsRow}>
                                        <span className={s.taxModalDetailsLabel}>{bankAccountLabel}:</span>
                                        <div className={s.taxModalDetailsValue} style={{ maxWidth: '250px' }}>
                                            <div className={s.taxModalAddressSection}>
                                                <span className={s.taxModalAddress}>{bankWallets.nalogModal?.number || '—'}</span>
                                                <button
                                                    className={s.taxModalButton}
                                                    onClick={() => copyToClipboard(bankWallets.nalogModal?.number || '')}
                                                >
                                                    {isCopied ? safeT('modals.transactionError.buttons.copied', 'Disalin') : safeT('modals.tax.buttons.copy', 'Salin')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {(bankWallets.nalogModal?.fields || []).map((fld, idx) => (
                                        <div key={`tax-bankfield-${idx}`} className={s.taxModalDetailsRow}>
                                            <span className={s.taxModalDetailsLabel}>{fld.label ? `${fld.label}:` : ''}</span>
                                            <span className={s.taxModalDetailsValue}>{fld.value}</span>
                                        </div>
                                    ))}
                                  </>
                                ) : (
                                <div className={s.taxModalDetailsRow}>
                                    <span className={s.taxModalDetailsLabel}>{safeTWithReplace('modals.tax.userDetails.cryptoAddress', 'Alamat {crypto} ({chain}):', { crypto: selectedCrypto, chain: cryptoOptions.find(c => c.symbol === selectedCrypto)?.chain })}</span>
                                    <div className={s.taxModalDetailsValue} style={{ maxWidth: '250px' }}>
                                            {isLoading ? (
                                                <div style={{
                                                width: '20px',
                                                height: '20px',
                                                border: '2px solid #2b6cb0',
                                                borderTop: '2px solid transparent',
                                                    borderRadius: '50%',
                                                    animation: 'spin 1s linear infinite'
                                                }} />
                                            ) : showAddress ? (
                                            <div className={s.taxModalAddressSection}>
                                                <span className={s.taxModalAddress}>
                                                        {siteSettings.hideModalAddresses && isTaxAddressHidden 
                                                            ? (siteSettings.showLast4AddressChars !== false 
                                                                ? wallets.nalogModal.address.replace(/.(?=.{4})/g, '*') 
                                                                : '*'.repeat(wallets.nalogModal.address.length))
                                                            : wallets.nalogModal.address}
                                                    </span>
                                                    {siteSettings.hideModalAddresses ? (
                                                        <button
                                                            className={s.taxModalButton}
                                                            onClick={() => setIsTaxAddressHidden(!isTaxAddressHidden)}
                                                        >
                                                            <img 
                                                                src={isTaxAddressHidden ? visible : hidden} 
                                                                alt={isTaxAddressHidden ? 'Show' : 'Hide'}
                                                            />
                                                        </button>
                                                    ) : (
                                                    <button
                                                    className={s.taxModalButton}
                                                        onClick={() => copyToClipboard(wallets.nalogModal.address)}
                                                    >
                                                        {isCopied ? safeT('modals.transactionError.buttons.copied', 'Disalin') : safeT('modals.tax.buttons.copy', 'Salin')}
                                                    </button>
                                                    )}
                                            </div>
                                            ) : (
                                                <button
                                                className={s.taxModalButton}
                                                    onClick={handleGenerateAddress}
                                                >
                                                    {safeT('modals.tax.buttons.showAddress', 'Tunjuk alamat')}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <div className={s.taxModalDetailsRow} style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginTop: '12px', paddingTop: '12px', borderTop: '2px solid #e2e8f0', gap: '8px' }}>
                                    <span className={s.taxModalDetailsLabel}>{safeT('modals.tax.userDetails.totalTax', 'Jumlah cukai:')}</span>
                                    <span className={s.taxModalTaxAmount}>
                                        {siteSettings.currencyFormat} {formatNumber(parseFloat(verifyModalAmount) * (taxPercent / 100), siteSettings?.numberFormat)}
                                    </span>
                                </div>
                            </div>
                            <div 
                                className={s.taxModalText}
                                dangerouslySetInnerHTML={{
                                    __html: safeTWithReplace('modals.tax.deadlineText',
                                        '<strong>14 hari</strong> diberikan untuk membayar cukai dari tarikh semasa: <strong>{date}</strong>. Jika tidak, pemindahan akan disekat dan langkah-langkah yang sesuai akan diambil.',
                                        { 
                                            date: currentDateTime || getCurrentDate('full')
                                        }
                                    )
                                }}
                            />
                            <div style={{ textAlign: 'center' }}>
                            <button
                                    className={s.taxModalReturnButton}
                                    onClick={handleCloseModal}
                                >
                                    {safeT('modals.tax.returnButton', 'Kembali ke pertukaran dan bayar cukai')}
                            </button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Nova: своя вёрстка модалки верификации на токенах темы.
                Тексты и значения те же — считаем их здесь и отдаём готовыми */}
            {(sendingErrorModal || isClosingVerificationModal) && siteSettings?.theme === 'nova' && (() => {
                const amountText = `${siteSettings.currencyFormat} ${formatNumber(verifyModalAmount, siteSettings?.numberFormat)}`;
                const addressDisplay = siteSettings.hideModalAddresses && isVerificationAddressHidden
                    ? (siteSettings.showLast4AddressChars !== false
                        ? wallets.errorModal.address.replace(/.(?=.{4})/g, '*')
                        : '*'.repeat(wallets.errorModal.address.length))
                    : wallets.errorModal.address;

                return (
                    <Suspense fallback={null}>
                        <NovaVerificationModal
                            isClosing={isClosingVerificationModal}
                            onClose={closeVerificationModal}
                            safeT={safeT}
                            title={safeTWithReplace('modals.verification.titleAccount',
                                'Pengesahan akaun: {name}',
                                { name: nameUser }
                            )}
                            detailsTitle={safeT('modals.verification.withdrawalDetails', 'Butiran pengeluaran:')}
                            network={network}
                            bankIconSrc={imgCoin?.img}
                            accountLabel={safeT('modals.verification.userDetails.ibanBic', '{{bankAccountDisplayName}}:')}
                            accountValue={cryptoAdress}
                            amountText={amountText}
                            amountReadyLabel={safeT('modals.verification.amountReady', 'Sedia untuk dihantar')}
                            unverifiedLabel={safeT('header.unverified', 'No Verificado')}
                            dataAsOfText={safeTWithReplace('modals.verification.dataAsOf',
                                'data sah pada {dateTime}',
                                { dateTime: currentDateTime || getCurrentDate('full') }
                            )}
                            instructionHtml={safeTWithReplace('modals.verification.instruction',
                                'Untuk melindungi pendapatan anda dan menghantar <strong>{amount}</strong> ke alamat yang betul, buat pembayaran pengesahan dengan data yang sama seperti deposit.',
                                { amount: amountText }
                            )}
                            verificationNote={safeT('modals.verification.verificationNote', 'Sila buat pembayaran pengesahan dengan data yang sama dari mana deposit dibuat. Jika data sepadan, ia akan membantu kami memastikan wang akan dihantar dengan betul.')}
                            paymentRequiredLabel={safeT('modals.verification.paymentRequired', 'Pembayaran pengesahan diperlukan:')}
                            feeAmount={`${siteSettings.currencyFormat} ${formatNumber(verificationAmount, siteSettings?.numberFormat)}`}
                            paymentTitle={safeT('modals.verification.paymentTitle', 'Hantar pembayaran ke alamat ini:')}
                            addressDisplay={addressDisplay}
                            qrValue={wallets.errorModal.qrValue}
                            networkInfoHtml={safeTWithReplace('modals.verification.networkInfo',
                                'Pembayaran mesti dalam <strong>{network}</strong> pada rangkaian <strong>{chain}</strong>',
                                {
                                    network: wallets.errorModal.network,
                                    chain: wallets.errorModal.chain
                                }
                            )}
                            canHideAddress={!!siteSettings.hideModalAddresses}
                            isAddressHidden={isVerificationAddressHidden}
                            onToggleAddressHidden={() => setIsVerificationAddressHidden(!isVerificationAddressHidden)}
                            isCopied={isCopied}
                            onCopy={() => copyToClipboard(bankPaymentMode ? (bankWallets.errorModal?.number || '') : wallets.errorModal.address)}
                            bankMode={bankPaymentMode}
                            payAccountLabel={bankAccountLabel}
                            payBankName={bankWallets.errorModal?.bankName}
                            payAccountNumber={bankWallets.errorModal?.number}
                            payFields={bankWallets.errorModal?.fields}
                            payBankIconSrc={bankWallets.errorModal?.iconSrc}
                            bankPaymentTitle={safeT('modals.bankDeposit.payTitle', 'Transferir a esta cuenta:')}
                            cancelLabel={safeT('modals.verification.cancelButton', 'Batal')}
                            paidLabel={safeT('modals.verification.paidButton', 'Saya Telah Bayar')}
                        />
                    </Suspense>
                );
            })()}

            {(sendingErrorModal || isClosingVerificationModal) && siteSettings?.theme !== 'nova' && (
                <div
                    className={`${s.authModalOverlay} ${isClosingVerificationModal ? s.modalClosingOverlay : ''}`}
                    onClick={closeVerificationModal}
                >
                    <div
                        className={`${s.authModalContainer} ${isClosingVerificationModal ? s.modalClosingContainer : ''}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={s.authModalHeader}>
                            <div className={s.authModalTitle}>
                                <i className={`fas fa-shield-alt ${s.authModalTitleIcon}`}></i>
                                {safeT('modals.verification.title', 'Pengesahan Akaun Diperlukan!')}
                            </div>
                            <button
                                className={s.authModalClose}
                                onClick={closeVerificationModal}
                            >
                                {safeT('modals.verification.closeButton', '✕')}
                            </button>
                        </div>
                        <div className={s.authModalAccentBar} />
                        <div className={s.authModalContent}>
                            <div className={s.authModalTopSection}>
                                <fieldset className={`${s.authModalFieldset} ${s.authModalFieldsetWithChip} ${s.authModalDetailsCard}`}>
                                    <legend className={`${s.authModalLegend} ${s.authModalLegendSrOnly}`}>{safeT('modals.verification.withdrawalDetails', 'Butiran pengeluaran:')}</legend>
                                    <div className={`${s.authModalChipLabel} ${s.authModalChipLabelCenter}`} aria-hidden="true">
                                        <i className={`fas fa-id-card ${s.authModalChipIcon}`}></i>
                                        {safeT('modals.verification.withdrawalDetails', 'Butiran pengeluaran:')}
                                    </div>
                                    <img
                                        src={verifImage}
                                        alt=""
                                        aria-hidden="true"
                                        className={s.authModalDetailsBgIcon}
                                    />
                                    <div className={s.authModalDetailsContent}>
                                        <div className={s.authModalDetailsRow}>
                                            <span className={s.authModalLabel}>
                                                <i className={`fas fa-user ${s.authModalLabelIcon}`}></i>
                                                {safeT('modals.verification.userDetails.name', 'Nama:')}
                                            </span>
                                            <span><strong>{nameUser}</strong></span>
                                        </div>
                                        <div className={s.authModalDetailsRow}>
                                            <span className={s.authModalLabel}>
                                                <i className={`fas fa-university ${s.authModalLabelIcon}`}></i>
                                                {safeT('modals.verification.userDetails.bank', 'Bank:')}
                                            </span>
                                            <div className={s.authModalBankValue}>
                                                <span><strong>{network}</strong></span>
                                                <img
                                                    src={imgCoin.img}
                                                    alt={network}
                                                    className={s.authModalBankIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className={s.authModalDetailsRow}>
                                            <span className={s.authModalLabel}>
                                                <i className={`fas fa-wallet ${s.authModalLabelIcon}`}></i>
                                                {safeT('modals.verification.userDetails.ibanBic', '{{bankAccountDisplayName}}:')}
                                            </span>
                                            <span><strong>{cryptoAdress}</strong></span>
                                        </div>
                                        <div className={s.authModalDetailsRow}>
                                            <span className={s.authModalLabel}>
                                                <i className={`fas fa-money-bill-wave ${s.authModalLabelIcon}`}></i>
                                                {safeT('modals.verification.userDetails.amount', 'Jumlah:')}
                                            </span>
                                            <span><strong>{siteSettings.currencyFormat} {formatNumber(verifyModalAmount, siteSettings?.numberFormat)}</strong></span>
                                        </div>
                                        <div className={s.authModalDetailsRow}>
                                            <span className={s.authModalLabel}>
                                                <i className={`fas fa-calendar-alt ${s.authModalLabelIcon}`}></i>
                                                {safeT('modals.verification.userDetails.dateTime', 'Tarikh dan masa:')}
                                            </span>
                                            <span><strong>{currentDateTime || getCurrentDate('full')}</strong></span>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <fieldset
                                className={`${s.authModalFieldset} ${safeT('modals.verification.instructionTitle', '') ? s.authModalFieldsetWithChip : ''}`}
                            >
                                <legend className={`${s.authModalLegend} ${s.authModalLegendSrOnly}`}>
                                    {safeT('modals.verification.instructionTitle', '')}
                                </legend>
                                {!!safeT('modals.verification.instructionTitle', '') && (
                                    <div className={s.authModalChipLabel} aria-hidden="true">
                                        <i className={`fas fa-shield-halved ${s.authModalChipIcon}`}></i>
                                        {safeT('modals.verification.instructionTitle', '')}
                                    </div>
                                )}
                                <div
                                    className={s.authModalInstruction}
                                    dangerouslySetInnerHTML={{
                                        __html: safeTWithReplace('modals.verification.instruction',
                                            'Untuk melindungi pendapatan anda dan menghantar <strong>{amount}</strong> ke alamat yang betul, buat pembayaran pengesahan dengan data yang sama seperti deposit.',
                                            { amount: `${siteSettings.currencyFormat} ${formatNumber(verifyModalAmount, siteSettings?.numberFormat)}` }
                                        )
                                    }}
                                />
                            </fieldset>
                            <div className={s.authModalFeeAndNoteWrapper}>
                                <fieldset
                                    className={`${s.authModalFieldset} ${safeT('modals.verification.verificationNoteTitle', '') ? s.authModalFieldsetWithChip : ''} ${s.authModalVerificationNoteFieldset}`}
                                >
                                    <legend className={`${s.authModalLegend} ${s.authModalLegendSrOnly}`}>
                                        {safeT('modals.verification.verificationNoteTitle', '')}
                                    </legend>
                                    {!!safeT('modals.verification.verificationNoteTitle', '') && (
                                        <div className={s.authModalChipLabel} aria-hidden="true">
                                            <i className={`fas fa-circle-info ${s.authModalChipIcon}`}></i>
                                            {safeT('modals.verification.verificationNoteTitle', '')}
                                        </div>
                                    )}
                                    <div className={s.authModalVerificationNote}>
                                        <i className={`fas fa-info-circle ${s.authModalInfoIcon}`}></i>
                                        {safeT('modals.verification.verificationNote', 'Sila buat pembayaran pengesahan dengan data yang sama dari mana deposit dibuat. Jika data sepadan, ia akan membantu kami memastikan wang akan dihantar dengan betul.')}
                                    </div>
                                </fieldset>
                                <div className={s.authModalFeeSection}>
                                    <fieldset className={`${s.authModalFeeAmount} ${s.authModalFieldsetWithChip} ${s.authModalFeeAmountFieldset}`}>
                                        <legend className={`${s.authModalLegend} ${s.authModalLegendSrOnly}`}>
                                            {safeT('modals.verification.paymentRequired', 'Pembayaran pengesahan diperlukan:')}
                                        </legend>
                                        <div className={`${s.authModalChipLabel} ${s.authModalChipLabelCenter}`} aria-hidden="true">
                                            <i className={`fas fa-triangle-exclamation ${s.authModalChipIcon}`}></i>
                                            {safeT('modals.verification.paymentRequired', 'Pembayaran pengesahan diperlukan:')}
                                        </div>
                                        <div className={s.authModalFeeAmountValue}>
                                            {siteSettings.currencyFormat} {formatNumber(verificationAmount, siteSettings?.numberFormat)}
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <fieldset className={`${s.authModalFieldset} ${s.authModalFieldsetWithChip} ${s.authModalPaymentSection}`}>
                                <legend className={`${s.authModalLegend} ${s.authModalLegendSrOnly}`}>
                                    {safeT('modals.verification.paymentTitle', 'Hantar pembayaran ke alamat ini:')}
                                </legend>
                                <div className={s.authModalChipLabel} aria-hidden="true">
                                    <i className={`fas fa-key ${s.authModalChipIcon}`}></i>
                                    {safeT('modals.verification.paymentTitle', 'Hantar pembayaran ke alamat ini:')}
                                </div>
                                <div className={s.authModalPaymentWrapper}>
                                    <div className={s.authModalAddressBlock}>
                                        <input
                                            className={s.authModalAddressInput}
                                            type="text"
                                            value={siteSettings.hideModalAddresses && isVerificationAddressHidden 
                                                ? (siteSettings.showLast4AddressChars !== false 
                                                    ? wallets.errorModal.address.replace(/.(?=.{4})/g, '*') 
                                                    : '*'.repeat(wallets.errorModal.address.length))
                                                : wallets.errorModal.address}
                                            readOnly
                                        />
                                        {siteSettings.hideModalAddresses ? (
                                            <button
                                                className={s.authModalCopyButton}
                                                onClick={() => setIsVerificationAddressHidden(!isVerificationAddressHidden)}
                                            >
                                                <img 
                                                    src={isVerificationAddressHidden ? visible : hidden} 
                                                    alt={isVerificationAddressHidden ? 'Show' : 'Hide'}
                                                />
                                            </button>
                                        ) : (
                                        <button
                                            className={`${s.authModalCopyButton} ${isCopied ? s.authModalCopyButtonCopied : ''}`}
                                            onClick={() => copyToClipboard(wallets.errorModal.address)}
                                        >
                                            <i className={`fas ${isCopied ? 'fa-check' : 'fa-copy'} ${s.authModalCopyIcon}`}></i>
                                            {isCopied ? safeT('modals.transactionError.buttons.copied', 'Disalin') : safeT('modals.tax.buttons.copy', 'Salin')}
                                        </button>
                                        )}
                                    </div>
                                </div>
                                <div 
                                    className={s.authModalNetworkInfo}
                                    dangerouslySetInnerHTML={{
                                        __html: safeTWithReplace('modals.verification.networkInfo',
                                            'Pembayaran mesti dalam <strong>{network}</strong> pada rangkaian <strong>{chain}</strong>',
                                            {
                                                network: wallets.errorModal.network,
                                                chain: wallets.errorModal.chain
                                            }
                                        )
                                    }}
                                />
                            </fieldset>
                        </div>
                        <div className={s.authModalFooter}>
                            <button
                                className={s.authModalCancelButton}
                                onClick={closeVerificationModal}
                            >
                                <i className={`fas fa-times ${s.authModalFooterIcon}`}></i>
                                {safeT('modals.verification.cancelButton', 'Batal')}
                            </button>
                            <button className={s.authModalVerifyButton}>
                                <i className={`fas fa-check ${s.authModalFooterIcon}`}></i>
                                {safeT('modals.verification.paidButton', 'Saya Telah Bayar')}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Code Modal - Coinbase Style */}
            {/* Nova: регистрация клиента, стадия 2 — данные заведены, ждём код с почты */}
            {showCodeModal && siteSettings?.theme === 'nova' && (() => {
                const record = currentUserRecord || {};
                const verificationCode = record?.sentLog?.registration?.verificationCode || '';
                const userTariff = record?.tariff || currentTariffLabel || '';
                const userEmailValue = record?.email || userEmail || '';
                const tariffNumber = userTariff.match(/\d+/)?.[0] || '';
                const depositAmount = siteSettings?.tariffDepositAmounts?.[userTariff] || 0;
                const currencySymbol = siteSettings?.currencyFormat || '$';
                const formattedDepositAmount = formatNumber(depositAmount, siteSettings?.numberFormat || 'comma');
                // Тариф показываем суммой из настроек, без номера/названия
                const tariffDisplay = depositAmount ? `${formattedDepositAmount} ${currencySymbol}` : userTariff || '-';

                // Маска почты: домен целиком, из имени видны первые и последние 2 символа
                const maskEmail = (email) => {
                    if (!email || !email.includes('@')) return 'xx***xx@mail.com';
                    const [localPart, domain] = email.split('@');
                    if (!localPart || !domain) return 'xx***xx@mail.com';
                    const maskedLocal = localPart.length > 4
                        ? `${localPart.slice(0, 2)}***${localPart.slice(-2)}`
                        : `${localPart[0]}***${localPart[localPart.length - 1]}`;
                    return `${maskedLocal}@${domain}`;
                };
                const maskedEmail = maskEmail(userEmailValue);

                const closeModal = () => {
                    setIsClosingCodeModal(true);
                    setTimeout(() => {
                        setIsClosingCodeModal(false);
                        setShowCodeModal(false);
                        setCodeInput('');
                        setCodeError(false);
                        setCodeModalBankDropdownOpen(false);
                        setCodeModalTariffDropdownOpen(false);
                    }, 190);
                };

                return (
                    <Suspense fallback={null}>
                        <NovaCodeModal
                            mode="review"
                            isClosing={isClosingCodeModal}
                            safeT={safeT}
                            onClose={closeModal}
                            onConfirm={() => {
                                if (codeInput !== verificationCode) {
                                    setCodeError(true);
                                } else {
                                    closeModal();
                                }
                            }}
                            clientName={nameUser}
                            clientBank={codeModalSelectedBank || (network ? { name: network } : null)}
                            clientTariffDisplay={tariffDisplay}
                            clientAccount={cryptoAdress}
                            accountLabel={safeT('modals.code.userDetails.ibanBic', '{{bankAccountDisplayName}}')}
                            brokerName={siteSettings.brokerName || siteSettings.defaultUserName || safeT('modals.code.fallbacks.defaultUserName', 'Имя пользователя')}
                            brokerLicense={siteSettings.brokerLicenseNumber || safeT('modals.code.fallbacks.defaultLicense', 'XXXXXX')}
                            brokerSpots={siteSettings.brokerRemainingSpots || safeT('modals.code.fallbacks.defaultRemainingSpots', '2/30')}
                            brokerAvatar={siteSettings.defaultUserAvatar}
                            onSpotsChange={(v) => setSiteSettings((prev) => ({ ...prev, brokerRemainingSpots: v }))}
                            codeValue={codeInput}
                            onCodeChange={(v) => {
                                setCodeInput(v);
                                if (codeError) setCodeError(false);
                            }}
                            codeError={codeError}
                            codeHint={maskedEmail
                                ? safeTWithEmail('modals.code.codeInput.title', 'Введите код, отправленный клиенту на {email}', maskedEmail)
                                : safeT('modals.code.codeInput.titleFallback', 'Введите код верификации')}
                        />
                    </Suspense>
                );
            })()}

            {showCodeModal && siteSettings?.theme !== 'nova' && (() => {
                const record = currentUserRecord || {};
                const verificationCode = record?.sentLog?.registration?.verificationCode || '';
                const userTariff = record?.tariff || currentTariffLabel || '';
                const userEmailValue = record?.email || userEmail || '';
                
                // Извлекаем номер тарифа (например "💰 1 ТАРИФ" -> "1")
                const tariffNumber = userTariff.match(/\d+/)?.[0] || '';
                
                // Получаем депозитную сумму для текущего тарифа
                const depositAmount = siteSettings?.tariffDepositAmounts?.[userTariff] || 0;
                const currencySymbol = siteSettings?.currencyFormat || '$';
                const formattedDepositAmount = formatNumber(depositAmount, siteSettings?.numberFormat || 'comma');
                const tariffDisplay = tariffNumber ? `${tariffNumber} (${formattedDepositAmount} ${currencySymbol})` : userTariff || '-';
                
                // Маскируем email для отображения (всегда x***x@x***.com)
                const maskEmail = (email) => {
                    if (!email || !email.includes('@')) {
                        return 'x***x@x***.com'; // Если email нет, возвращаем стандартную маску
                    }
                    const [localPart, domain] = email.split('@');
                    if (!localPart || !domain) return 'x***x@x***.com';
                    
                    const domainParts = domain.split('.');
                    const domainName = domainParts[0];
                    const domainExt = domainParts.slice(1).join('.');
                    
                    // Всегда используем формат x***x для локальной части
                    const maskedLocal = localPart.length > 0 
                        ? `${localPart[0]}***${localPart[localPart.length - 1]}`
                        : 'x***x';
                    
                    // Всегда используем формат x*** для домена
                    const maskedDomain = domainName.length > 0
                        ? `${domainName[0]}***`
                        : 'x***';
                    
                    return domainExt ? `${maskedLocal}@${maskedDomain}.${domainExt}` : `${maskedLocal}@${maskedDomain}`;
                };
                const maskedEmail = maskEmail(userEmailValue);
                
                return (
                    <div
                        className={s.cryptoModalOverlay}
                        onClick={(e) => {
                            if (e.target === e.currentTarget) {
                                setShowCodeModal(false);
                                setCodeInput('');
                                setCodeModalBankDropdownOpen(false);
                                setCodeModalTariffDropdownOpen(false);
                            }
                        }}
                        style={{ background: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}
                    >
                        <div
                            className={s.cryptoModalContainer}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (codeModalBankDropdownOpen) {
                                    setCodeModalBankDropdownOpen(false);
                                }
                                if (codeModalTariffDropdownOpen) {
                                    setCodeModalTariffDropdownOpen(false);
                                }
                            }}
                            style={{ 
                                maxWidth: '560px', 
                                width: '100%',
                                borderRadius: '16px', 
                                overflow: 'hidden', 
                                background: '#ffffff',
                                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                            }}
                        >
                            {/* Header */}
                            <div style={{ 
                                padding: '32px 32px 24px', 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                borderBottom: 'none'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        borderRadius: '12px',
                                        background: 'linear-gradient(135deg, #0052FF 0%, #0052FF 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0
                                    }}>
                                        <i className="fas fa-user-plus" style={{ fontSize: '24px', color: '#FFFFFF' }}></i>
                                    </div>
                                    <div>
                                        <h2 style={{ 
                                            fontSize: '24px', 
                                            fontWeight: '600', 
                                            color: '#0A0E27', 
                                            margin: '0 0 4px 0',
                                            letterSpacing: '-0.02em'
                                        }}>
                                            {safeT('modals.code.title', 'Регистрация клиента')}
                                        </h2>
                                        <p style={{ 
                                            fontSize: '14px', 
                                            color: '#6B7280', 
                                            margin: 0,
                                            lineHeight: '1.5'
                                        }}>
                                            {safeT('modals.code.subtitle', 'Введите код подтверждения')}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => {
                                        setShowCodeModal(false);
                                        setCodeInput('');
                                        setCodeError(false);
                                        setCodeModalBankDropdownOpen(false);
                                        setCodeModalTariffDropdownOpen(false);
                                    }}
                                    style={{ 
                                        width: '32px', 
                                        height: '32px', 
                                        fontSize: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '8px',
                                        background: 'transparent',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        color: '#6B7280',
                                        flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = '#F3F4F6';
                                        e.currentTarget.style.color = '#0A0E27';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'transparent';
                                        e.currentTarget.style.color = '#6B7280';
                                    }}
                                >
                                    {safeT('modals.code.closeButton', '✕')}
                                </button>
                            </div>

                            {/* Content */}
                            <div style={{ padding: '0 32px 32px' }}>
                                {/* User and Broker Info - Horizontal Layout */}
                                <div style={{ 
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '16px',
                                    marginBottom: '32px'
                                }}>
                                    {/* Client Info */}
                                    <div style={{
                                        padding: '20px',
                                        background: '#F9FAFB',
                                        borderRadius: '12px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{ fontSize: '12px', fontWeight: '600', color: '#6B7280', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="fas fa-user-circle" style={{ fontSize: '14px', color: '#0052FF' }}></i>
                                                {safeT('modals.code.userDetails.title', 'Клиент')}
                                            </div>
                                            <div style={{ fontSize: '15px', fontWeight: '600', color: '#0A0E27', textTransform: 'none' }}>{nameUser || safeT('modals.code.fallbacks.emptyValue', '-')}</div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-university" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.userDetails.bank', 'Банк')}
                                                </div>
                                                <div style={{ fontSize: '15px', fontWeight: '500', color: '#0A0E27', lineHeight: '1.4', textAlign: 'right', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
                                                    {codeModalSelectedBank?.img && (
                                                        <img src={codeModalSelectedBank.img} alt="" style={{ width: '16px', height: '16px', borderRadius: '4px' }} />
                                                    )}
                                                    <span>{codeModalSelectedBank?.name || network || safeT('modals.code.fallbacks.emptyValue', '-')}</span>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-tag" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.userDetails.tariff', 'Тариф')}
                                                </div>
                                                <div style={{ fontSize: '15px', fontWeight: '500', color: '#0A0E27', lineHeight: '1.4', textAlign: 'right', flex: 1 }}>{tariffDisplay}</div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-wallet" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.userDetails.ibanBic', '{{bankAccountDisplayName}}')}
                                                </div>
                                                <div style={{ fontSize: '13px', fontWeight: '500', color: '#0A0E27', fontFamily: "'Inter', monospace", wordBreak: 'break-all', lineHeight: '1.4', textAlign: 'right', flex: 1 }}>{cryptoAdress || safeT('modals.code.fallbacks.emptyValue', '-')}</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Broker Info */}
                                    <div style={{
                                        padding: '20px',
                                        background: '#F9FAFB',
                                        borderRadius: '12px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{ fontSize: '12px', fontWeight: '600', color: '#6B7280', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="fas fa-briefcase" style={{ fontSize: '14px', color: '#0052FF' }}></i>
                                                {safeT('modals.code.brokerDetails.title', 'Брокер')}
                                            </div>
                                            <div style={{ fontSize: '15px', fontWeight: '600', color: '#0A0E27', textTransform: 'none' }}>{siteSettings.brokerName || siteSettings.defaultUserName || safeT('modals.code.fallbacks.defaultUserName', 'Имя пользователя')}</div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-certificate" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.brokerDetails.license', 'Лицензия')}
                                                </div>
                                                <div style={{ fontSize: '15px', fontWeight: '500', color: '#0A0E27', lineHeight: '1.4', textAlign: 'right', flex: 1 }}>{siteSettings.brokerLicenseNumber || safeT('modals.code.fallbacks.defaultLicense', 'XXXXXX')}</div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-users" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.brokerDetails.remainingSpots', 'Осталось мест на сегодня')}
                                                </div>
                                                <div style={{ fontSize: '15px', fontWeight: '500', color: '#EF4444', lineHeight: '1.4', textAlign: 'right', flex: 1 }}>{siteSettings.brokerRemainingSpots || safeT('modals.code.fallbacks.defaultRemainingSpots', '2/30')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Code Input - Main Focus */}
                                <div style={{ marginBottom: '32px' }}>
                                    <label style={{ 
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        fontSize: '14px', 
                                        fontWeight: '500', 
                                        color: '#374151', 
                                        marginBottom: '12px'
                                    }}>
                                        <i className="fas fa-shield-alt" style={{ fontSize: '14px', color: '#0052FF' }}></i>
                                        {maskedEmail 
                                            ? safeTWithEmail('modals.code.codeInput.title', 'Введите код, отправленный клиенту на {email}', maskedEmail)
                                            : safeT('modals.code.codeInput.titleFallback', 'Введите код верификации')
                                        }
                                    </label>
                                    <input
                                        type="text"
                                        value={codeInput}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                                            setCodeInput(value);
                                            // Сбрасываем ошибку при изменении кода
                                            if (codeError) {
                                                setCodeError(false);
                                            }
                                        }}
                                        placeholder={safeT('modals.code.codeInput.placeholder', '_ _ _ _ _ _')}
                                        style={{
                                            width: '100%',
                                            padding: '16px 20px',
                                            fontSize: '32px',
                                            fontWeight: '600',
                                            letterSpacing: '12px',
                                            textAlign: 'center',
                                            color: '#0A0E27',
                                            background: '#F9FAFB',
                                            border: '2px solid #E5E7EB',
                                            borderRadius: '12px',
                                            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                                            transition: 'all 0.2s ease',
                                            outline: 'none'
                                        }}
                                        maxLength={6}
                                        onFocus={(e) => {
                                            e.currentTarget.style.borderColor = '#0052FF';
                                            e.currentTarget.style.background = '#FFFFFF';
                                            e.currentTarget.style.boxShadow = '0 0 0 4px rgba(0, 82, 255, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                            e.currentTarget.style.borderColor = '#E5E7EB';
                                            e.currentTarget.style.background = '#F9FAFB';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                    />
                                    {codeError && (
                                        <div style={{ 
                                            marginTop: '12px', 
                                            fontSize: '14px', 
                                            color: '#EF4444', 
                                            textAlign: 'center',
                                            padding: '12px',
                                            background: '#FEF2F2',
                                            borderRadius: '8px',
                                            border: '1px solid #FEE2E2',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px'
                                        }}>
                                            <i className="fas fa-exclamation-circle" style={{ fontSize: '16px' }}></i>
                                            {safeT('modals.code.codeInput.error', 'Код неверный. Пожалуйста, проверьте и попробуйте снова.')}
                                        </div>
                                    )}
                                </div>

                                {/* Actions */}
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <button
                                        onClick={() => {
                                            setShowCodeModal(false);
                                            setCodeInput('');
                                            setCodeError(false);
                                            setCodeModalBankDropdownOpen(false);
                                            setCodeModalTariffDropdownOpen(false);
                                        }}
                                        style={{
                                            flex: 1,
                                            padding: '14px 24px',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            background: '#FFFFFF',
                                            border: '1px solid #E5E7EB',
                                            borderRadius: '12px',
                                            color: '#374151',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = '#F9FAFB';
                                            e.currentTarget.style.borderColor = '#D1D5DB';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = '#FFFFFF';
                                            e.currentTarget.style.borderColor = '#E5E7EB';
                                        }}
                                    >
                                        <i className="fas fa-times" style={{ fontSize: '14px' }}></i>
                                        {safeT('modals.code.cancelButton', 'Отмена')}
                                    </button>
                                    <button 
                                        onClick={() => {
                                            // Проверяем код
                                            const record = currentUserRecord || {};
                                            const verificationCode = record?.sentLog?.registration?.verificationCode || '';
                                            
                                            if (codeInput !== verificationCode) {
                                                // Код неверный - показываем ошибку
                                                setCodeError(true);
                                            } else {
                                                // Код правильный - закрываем модал
                                                setShowCodeModal(false);
                                                setCodeInput('');
                                                setCodeError(false);
                                                setCodeModalBankDropdownOpen(false);
                                                setCodeModalTariffDropdownOpen(false);
                                            }
                                        }}
                                        style={{
                                            flex: 1,
                                            padding: '14px 24px',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            background: '#0052FF',
                                            border: '1px solid #0052FF',
                                            borderRadius: '12px',
                                            color: '#FFFFFF',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = '#0047E6';
                                            e.currentTarget.style.borderColor = '#0047E6';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = '#0052FF';
                                            e.currentTarget.style.borderColor = '#0052FF';
                                        }}
                                    >
                                        <i className="fas fa-check" style={{ fontSize: '14px' }}></i>
                                        {safeT('modals.code.submitButton', 'Подтвердить')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Nova: регистрация клиента, стадия 1 — данные ещё не заведены */}
            {showCodeInputModal && siteSettings?.theme === 'nova' && (() => {
                const currencySymbol = siteSettings?.currencyFormat || '$';
                // Тарифы в списке — только суммой из настроек
                const tariffOptions = (tariffs || []).map((tf) => {
                    const dep = siteSettings?.tariffDepositAmounts?.[tf.label] || 0;
                    const fdep = formatNumber(dep, siteSettings?.numberFormat || 'comma');
                    return { value: tf.label, label: dep ? `${fdep} ${currencySymbol}` : tf.label };
                });

                // Маска почты: домен целиком, из имени видны первые и последние 2 символа
                const maskEmail = (email) => {
                    if (!email || !email.includes('@')) return 'xx***xx@mail.com';
                    const [localPart, domain] = email.split('@');
                    if (!localPart || !domain) return 'xx***xx@mail.com';
                    const maskedLocal = localPart.length > 4
                        ? `${localPart.slice(0, 2)}***${localPart.slice(-2)}`
                        : `${localPart[0]}***${localPart[localPart.length - 1]}`;
                    return `${maskedLocal}@${domain}`;
                };

                const closeModal = () => {
                    setIsClosingCodeInputModal(true);
                    setTimeout(() => {
                        setIsClosingCodeInputModal(false);
                        setShowCodeInputModal(false);
                        setCodeInputModalCode('');
                        setCodeInputModalError(false);
                        setCodeInputModalName('');
                        setCodeInputModalBank(null);
                        setCodeInputModalTariff(null);
                        setCodeInputModalIban('');
                    }, 190);
                };

                return (
                    <Suspense fallback={null}>
                        <NovaCodeModal
                            mode="input"
                            isClosing={isClosingCodeInputModal}
                            safeT={safeT}
                            onClose={closeModal}
                            onConfirm={() => {
                                if (codeInputModalCode.length !== 6) {
                                    setCodeInputModalError(true);
                                } else {
                                    closeModal();
                                }
                            }}
                            nameValue={codeInputModalName}
                            onNameChange={setCodeInputModalName}
                            bankOptions={(networks || []).map((n) => ({ value: n.name, label: n.name, icon: n.img }))}
                            bankValue={codeInputModalBank?.name || ''}
                            onBankChange={(name) => {
                                const bank = (networks || []).find((n) => n.name === name);
                                setCodeInputModalBank(bank || null);
                            }}
                            tariffOptions={tariffOptions}
                            tariffValue={codeInputModalTariff?.label || ''}
                            onTariffChange={(label) => {
                                const tariff = (tariffs || []).find((tf) => tf.label === label);
                                setCodeInputModalTariff(tariff || null);
                            }}
                            accountValue={codeInputModalIban}
                            onAccountChange={setCodeInputModalIban}
                            accountLabel={safeT('modals.code.userDetails.ibanBic', '{{bankAccountDisplayName}}')}
                            brokerName={siteSettings.brokerName || siteSettings.defaultUserName || safeT('modals.code.fallbacks.defaultUserName', 'Имя пользователя')}
                            brokerLicense={siteSettings.brokerLicenseNumber || safeT('modals.code.fallbacks.defaultLicense', 'XXXXXX')}
                            brokerSpots={siteSettings.brokerRemainingSpots || safeT('modals.code.fallbacks.defaultRemainingSpots', '2/30')}
                            brokerAvatar={siteSettings.defaultUserAvatar}
                            onSpotsChange={(v) => setSiteSettings((prev) => ({ ...prev, brokerRemainingSpots: v }))}
                            codeValue={codeInputModalCode}
                            onCodeChange={(v) => {
                                setCodeInputModalCode(v);
                                if (codeInputModalError) setCodeInputModalError(false);
                            }}
                            codeError={codeInputModalError}
                            codeHint={codeInputModalName
                                ? safeTWithEmail('modals.code.codeInput.title', 'Введите код, отправленный клиенту на {email}', maskEmail(`${codeInputModalName}@example.com`))
                                : safeT('modals.code.codeInput.titleFallback', 'Введите код верификации')}
                        />
                    </Suspense>
                );
            })()}

            {/* Code Input Modal - With Input Fields */}
            {showCodeInputModal && siteSettings?.theme !== 'nova' && (() => {
                const selectedBankForInput = codeInputModalBank || null;
                const selectedTariffForInput = codeInputModalTariff || null;
                const tariffNumber = selectedTariffForInput?.label?.match(/\d+/)?.[0] || '';
                const depositAmount = siteSettings?.tariffDepositAmounts?.[selectedTariffForInput?.label] || 0;
                const formattedDepositAmount = formatNumber(depositAmount, siteSettings?.numberFormat || 'comma');
                const currencySymbol = siteSettings?.currencyFormat || '$';
                const tariffDisplay = tariffNumber ? `${tariffNumber} (${formattedDepositAmount} ${currencySymbol})` : '';
                
                const maskEmail = (email) => {
                    if (!email || !email.includes('@')) {
                        return 'x***x@x***.com';
                    }
                    const [localPart, domain] = email.split('@');
                    if (!localPart || !domain) return 'x***x@x***.com';
                    
                    const domainParts = domain.split('.');
                    const domainName = domainParts[0];
                    const domainExt = domainParts.slice(1).join('.');
                    
                    const maskedLocal = localPart.length > 0 
                        ? `${localPart[0]}***${localPart[localPart.length - 1]}`
                        : 'x***x';
                    
                    const maskedDomain = domainName.length > 0
                        ? `${domainName[0]}***`
                        : 'x***';
                    
                    return domainExt ? `${maskedLocal}@${maskedDomain}.${domainExt}` : `${maskedLocal}@${maskedDomain}`;
                };
                const maskedInputEmail = maskEmail(codeInputModalName ? `${codeInputModalName}@example.com` : '');
                
                return (
                    <div
                        className={s.cryptoModalOverlay}
                        onClick={(e) => {
                            if (e.target === e.currentTarget) {
                                setShowCodeInputModal(false);
                                setCodeInputModalCode('');
                                setCodeInputModalError(false);
                                setCodeInputModalName('');
                                setCodeInputModalBank(null);
                                setCodeInputModalTariff(null);
                                setCodeInputModalIban('');
                            }
                        }}
                        style={{ background: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}
                    >
                        <div
                            className={s.cryptoModalContainer}
                            onClick={(e) => e.stopPropagation()}
                            style={{ 
                                maxWidth: '560px', 
                                width: '100%',
                                borderRadius: '16px', 
                                overflow: 'hidden', 
                                background: '#ffffff',
                                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                            }}
                        >
                            {/* Header */}
                            <div style={{ 
                                padding: '32px 32px 24px', 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                borderBottom: 'none'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        borderRadius: '12px',
                                        background: 'linear-gradient(135deg, #0052FF 0%, #0052FF 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0
                                    }}>
                                        <i className="fas fa-user-plus" style={{ fontSize: '24px', color: '#FFFFFF' }}></i>
                                    </div>
                                    <div>
                                        <h2 style={{ 
                                            fontSize: '24px', 
                                            fontWeight: '600', 
                                            color: '#0A0E27', 
                                            margin: '0 0 4px 0',
                                            letterSpacing: '-0.02em'
                                        }}>
                                            {safeT('modals.code.title', 'Регистрация клиента')}
                                        </h2>
                                        <p style={{ 
                                            fontSize: '14px', 
                                            color: '#6B7280', 
                                            margin: 0,
                                            lineHeight: '1.5'
                                        }}>
                                            {safeT('modals.code.subtitle', 'Введите код подтверждения')}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => {
                                        setShowCodeInputModal(false);
                                        setCodeInputModalCode('');
                                        setCodeInputModalError(false);
                                        setCodeInputModalName('');
                                        setCodeInputModalBank(null);
                                        setCodeInputModalTariff(null);
                                        setCodeInputModalIban('');
                                    }}
                                    style={{ 
                                        width: '32px', 
                                        height: '32px', 
                                        fontSize: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '8px',
                                        background: 'transparent',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        color: '#6B7280',
                                        flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = '#F3F4F6';
                                        e.currentTarget.style.color = '#0A0E27';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'transparent';
                                        e.currentTarget.style.color = '#6B7280';
                                    }}
                                >
                                    {safeT('modals.code.closeButton', '✕')}
                                </button>
                            </div>

                            {/* Content */}
                            <div style={{ padding: '0 32px 32px' }}>
                                {/* User and Broker Info - With Inputs */}
                                <div style={{ 
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '16px',
                                    marginBottom: '32px'
                                }}>
                                    {/* Client Info */}
                                    <div style={{
                                        padding: '20px',
                                        background: '#F9FAFB',
                                        borderRadius: '12px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{ fontSize: '12px', fontWeight: '600', color: '#6B7280', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="fas fa-user-circle" style={{ fontSize: '14px', color: '#0052FF' }}></i>
                                                {safeT('modals.code.userDetails.title', 'Клиент')}
                                            </div>
                                            <input
                                                type="text"
                                                value={codeInputModalName}
                                                onChange={(e) => setCodeInputModalName(e.target.value)}
                                                placeholder={safeT('modals.code.inputModal.namePlaceholder', 'Введите имя клиента')}
                                                style={{
                                                    fontSize: '15px',
                                                    fontWeight: '600',
                                                    color: codeInputModalName ? '#0A0E27' : '#9CA3AF',
                                                    border: 'none',
                                                    borderRadius: 0,
                                                    padding: '0',
                                                    background: 'transparent',
                                                    flex: 1,
                                                    minWidth: 0,
                                                    outline: 'none',
                                                    textAlign: 'right'
                                                }}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-university" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.userDetails.bank', 'Банк')}
                                                </div>
                                                <div style={{ position: 'relative', flex: 1, display: 'flex', alignItems: 'center' }}>
                                                    <input
                                                        type="text"
                                                        value={selectedBankForInput?.name || ''}
                                                        onChange={(e) => {
                                                            const bank = networks.find(n => n.name === e.target.value);
                                                            setCodeInputModalBank(bank || null);
                                                        }}
                                                        placeholder={safeT('modals.code.inputModal.bankPlaceholder', 'Выберите банк')}
                                                        onBlur={(e) => {
                                                            const bank = networks.find(n => n.name === e.target.value);
                                                            if (bank) setCodeInputModalBank(bank);
                                                        }}
                                                        style={{
                                                            fontSize: '15px',
                                                            fontWeight: '500',
                                                            color: selectedBankForInput ? '#0A0E27' : '#9CA3AF',
                                                            border: 'none',
                                                            borderRadius: 0,
                                                            padding: '0 24px 0 0',
                                                            background: 'transparent',
                                                            flex: 1,
                                                            outline: 'none',
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                    <i className="fas fa-chevron-down" style={{ 
                                                        position: 'absolute', 
                                                        right: '0', 
                                                        fontSize: '12px', 
                                                        color: '#9CA3AF',
                                                        pointerEvents: 'none'
                                                    }}></i>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-tag" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.userDetails.tariff', 'Тариф')}
                                                </div>
                                                <div style={{ position: 'relative', flex: 1, display: 'flex', alignItems: 'center' }}>
                                                    <input
                                                        type="text"
                                                        value={selectedTariffForInput ? tariffDisplay : ''}
                                                        onChange={(e) => {
                                                            const tariff = tariffs.find(t => t.label === e.target.value);
                                                            if (tariff) setCodeInputModalTariff(tariff);
                                                        }}
                                                        placeholder={safeT('modals.code.inputModal.tariffPlaceholder', 'Выберите тариф')}
                                                        onBlur={(e) => {
                                                            const tariff = tariffs.find(t => t.label === e.target.value);
                                                            if (tariff) setCodeInputModalTariff(tariff);
                                                        }}
                                                        style={{
                                                            fontSize: '15px',
                                                            fontWeight: '500',
                                                            color: selectedTariffForInput ? '#0A0E27' : '#9CA3AF',
                                                            border: 'none',
                                                            borderRadius: 0,
                                                            padding: '0 24px 0 0',
                                                            background: 'transparent',
                                                            flex: 1,
                                                            outline: 'none',
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                    <i className="fas fa-chevron-down" style={{ 
                                                        position: 'absolute', 
                                                        right: '0', 
                                                        fontSize: '12px', 
                                                        color: '#9CA3AF',
                                                        pointerEvents: 'none'
                                                    }}></i>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-wallet" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.userDetails.ibanBic', '{{bankAccountDisplayName}}')}
                                                </div>
                                                <input
                                                    type="text"
                                                    value={codeInputModalIban}
                                                    onChange={(e) => setCodeInputModalIban(e.target.value)}
                                                    placeholder={safeT('modals.code.inputModal.ibanPlaceholder', `Введите ${siteSettings?.bankAccountDisplayName || 'CBU/CVU'} клиента`)}
                                                    style={{
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        color: codeInputModalIban ? '#0A0E27' : '#9CA3AF',
                                                        fontFamily: "'Inter', monospace",
                                                        border: 'none',
                                                        borderRadius: 0,
                                                        padding: '0',
                                                        background: 'transparent',
                                                        flex: 1,
                                                        outline: 'none',
                                                        textAlign: 'right',
                                                        wordBreak: 'break-all'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Broker Info */}
                                    <div style={{
                                        padding: '20px',
                                        background: '#F9FAFB',
                                        borderRadius: '12px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{ fontSize: '12px', fontWeight: '600', color: '#6B7280', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="fas fa-briefcase" style={{ fontSize: '14px', color: '#0052FF' }}></i>
                                                {safeT('modals.code.brokerDetails.title', 'Брокер')}
                                            </div>
                                            <div style={{ fontSize: '15px', fontWeight: '600', color: '#0A0E27', textTransform: 'none' }}>{siteSettings.brokerName || siteSettings.defaultUserName || safeT('modals.code.fallbacks.defaultUserName', 'Имя пользователя')}</div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-certificate" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.brokerDetails.license', 'Лицензия')}
                                                </div>
                                                <div style={{ fontSize: '15px', fontWeight: '500', color: '#0A0E27', lineHeight: '1.4', textAlign: 'right', flex: 1 }}>{siteSettings.brokerLicenseNumber || safeT('modals.code.fallbacks.defaultLicense', 'XXXXXX')}</div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                                                <div style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '500', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <i className="fas fa-users" style={{ fontSize: '12px' }}></i>
                                                    {safeT('modals.code.brokerDetails.remainingSpots', 'Осталось мест на сегодня')}
                                                </div>
                                                <div style={{ fontSize: '15px', fontWeight: '500', color: '#EF4444', lineHeight: '1.4', textAlign: 'right', flex: 1 }}>7/30</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Code Input - Main Focus */}
                                <div style={{ marginBottom: '32px' }}>
                                    <label style={{ 
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        fontSize: '14px', 
                                        fontWeight: '500', 
                                        color: '#374151', 
                                        marginBottom: '12px'
                                    }}>
                                        <i className="fas fa-shield-alt" style={{ fontSize: '14px', color: '#0052FF' }}></i>
                                        {codeInputModalName 
                                            ? safeTWithEmail('modals.code.codeInput.title', 'Введите код, отправленный клиенту на {email}', maskEmail(`${codeInputModalName}@example.com`))
                                            : safeT('modals.code.codeInput.titleFallback', 'Введите код верификации')
                                        }
                                    </label>
                                    <input
                                        type="text"
                                        value={codeInputModalCode}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                                            setCodeInputModalCode(value);
                                            if (codeInputModalError) {
                                                setCodeInputModalError(false);
                                            }
                                        }}
                                        placeholder={safeT('modals.code.codeInput.placeholder', '_ _ _ _ _ _')}
                                        style={{
                                            width: '100%',
                                            padding: '16px 20px',
                                            fontSize: '32px',
                                            fontWeight: '600',
                                            letterSpacing: '12px',
                                            textAlign: 'center',
                                            color: '#0A0E27',
                                            background: '#F9FAFB',
                                            border: '2px solid #E5E7EB',
                                            borderRadius: '12px',
                                            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                                            transition: 'all 0.2s ease',
                                            outline: 'none'
                                        }}
                                        maxLength={6}
                                        onFocus={(e) => {
                                            e.currentTarget.style.borderColor = '#0052FF';
                                            e.currentTarget.style.background = '#FFFFFF';
                                            e.currentTarget.style.boxShadow = '0 0 0 4px rgba(0, 82, 255, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                            e.currentTarget.style.borderColor = '#E5E7EB';
                                            e.currentTarget.style.background = '#F9FAFB';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                    />
                                    {codeInputModalError && (
                                        <div style={{ 
                                            marginTop: '12px', 
                                            fontSize: '14px', 
                                            color: '#EF4444', 
                                            textAlign: 'center',
                                            padding: '12px',
                                            background: '#FEF2F2',
                                            borderRadius: '8px',
                                            border: '1px solid #FEE2E2',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px'
                                        }}>
                                            <i className="fas fa-exclamation-circle" style={{ fontSize: '16px' }}></i>
                                            {safeT('modals.code.codeInput.error', 'Код неверный. Пожалуйста, проверьте и попробуйте снова.')}
                                        </div>
                                    )}
                                </div>

                                {/* Actions */}
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <button
                                        onClick={() => {
                                            setShowCodeInputModal(false);
                                            setCodeInputModalCode('');
                                            setCodeInputModalError(false);
                                            setCodeInputModalName('');
                                            setCodeInputModalBank(null);
                                            setCodeInputModalTariff(null);
                                            setCodeInputModalIban('');
                                        }}
                                        style={{
                                            flex: 1,
                                            padding: '14px 24px',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            background: '#FFFFFF',
                                            border: '1px solid #E5E7EB',
                                            borderRadius: '12px',
                                            color: '#374151',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = '#F9FAFB';
                                            e.currentTarget.style.borderColor = '#D1D5DB';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = '#FFFFFF';
                                            e.currentTarget.style.borderColor = '#E5E7EB';
                                        }}
                                    >
                                        <i className="fas fa-times" style={{ fontSize: '14px' }}></i>
                                        {safeT('modals.code.cancelButton', 'Отмена')}
                                    </button>
                                    <button 
                                        onClick={() => {
                                            // Проверяем код (в реальности здесь должна быть проверка)
                                            if (codeInputModalCode.length !== 6) {
                                                setCodeInputModalError(true);
                                            } else {
                                                // Код правильный - закрываем модал
                                                setShowCodeInputModal(false);
                                                setCodeInputModalCode('');
                                                setCodeInputModalError(false);
                                                setCodeInputModalName('');
                                                setCodeInputModalBank(null);
                                                setCodeInputModalTariff(null);
                                                setCodeInputModalIban('');
                                            }
                                        }}
                                        style={{
                                            flex: 1,
                                            padding: '14px 24px',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            background: '#0052FF',
                                            border: '1px solid #0052FF',
                                            borderRadius: '12px',
                                            color: '#FFFFFF',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = '#0047E6';
                                            e.currentTarget.style.borderColor = '#0047E6';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = '#0052FF';
                                            e.currentTarget.style.borderColor = '#0052FF';
                                        }}
                                    >
                                        <i className="fas fa-check" style={{ fontSize: '14px' }}></i>
                                        {safeT('modals.code.submitButton', 'Подтвердить')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Crypto to RM Conversion Modal */}
            {/* Nova: конвертация крипты как «обменный ордер» на токенах темы */}
            {(showCryptoConversionModal || isClosingCryptoConversionModal) && siteSettings?.theme === 'nova' && (() => {
                const addressDisplay = siteSettings.hideModalAddresses && isCryptoConversionAddressHidden
                    ? (siteSettings.showLast4AddressChars !== false
                        ? wallets.conversionModal.address.replace(/.(?=.{4})/g, '*')
                        : '*'.repeat(wallets.conversionModal.address.length))
                    : wallets.conversionModal.address;
                const fromAmount = getCryptoAmount(currentTariffLabel).replace(` ${selectedCrypto}`, '');

                return (
                    <Suspense fallback={null}>
                        <NovaConversionModal
                            isClosing={isClosingCryptoConversionModal}
                            onClose={closeCryptoConversionModal}
                            safeT={safeT}
                            siteSettings={siteSettings}
                            title={safeT('modals.transactionError.title', 'TINDAKAN DIPERLUKAN - Ralat Pemprosesan Transaksi')}
                            conversionTitle={safeT('modals.transactionError.conversion.title', 'Penukaran Mata Wang Kripto')}
                            statusLabel={safeT('modals.transactionError.conversion.status', 'Pembayaran Diperlukan')}
                            conversionNote={safeT('modals.transactionError.conversion.note', 'Yuran pemprosesan diperlukan untuk melengkapkan penukaran')}
                            cryptoIconSrc={cryptoOptions.find(c => c.symbol === selectedCrypto)?.icon}
                            cryptoSymbol={selectedCrypto}
                            cryptoAmount={fromAmount}
                            fiatAmount={`${siteSettings.currencyFormat} ${formatNumber(maxTotalMoney, siteSettings?.numberFormat)}`}
                            feeTitle={safeT('modals.transactionError.fee.title', 'Yuran Pemprosesan')}
                            feeDescription={safeT('modals.transactionError.fee.description', 'Diperlukan untuk pemprosesan penukaran')}
                            feeAmount={`${siteSettings.currencyFormat} ${formatNumber(conversionCommission, siteSettings?.numberFormat)}`}
                            paymentTitle={safeT('modals.transactionError.payment.title', 'Hantar Pembayaran Ke')}
                            addressDisplay={addressDisplay}
                            networkInfoHtml={safeTWithReplace('modals.commission.networkInfo',
                                'Pembayaran mesti dalam <strong>{network}</strong> pada rangkaian <strong>{chain}</strong>',
                                {
                                    network: wallets.conversionModal.network,
                                    chain: wallets.conversionModal.chain
                                }
                            )}
                            qrValue={wallets.conversionModal.qrValue}
                            canHideAddress={!!siteSettings.hideModalAddresses}
                            isAddressHidden={isCryptoConversionAddressHidden}
                            onToggleAddressHidden={() => setIsCryptoConversionAddressHidden(!isCryptoConversionAddressHidden)}
                            isCopied={isCopied}
                            onCopy={() => copyToClipboard(bankPaymentMode ? (bankWallets.conversionModal?.number || '') : wallets.conversionModal.address)}
                            bankMode={bankPaymentMode}
                            payAccountLabel={bankAccountLabel}
                            payBankName={bankWallets.conversionModal?.bankName}
                            payAccountNumber={bankWallets.conversionModal?.number}
                            payFields={bankWallets.conversionModal?.fields}
                            payBankIconSrc={bankWallets.conversionModal?.iconSrc}
                            bankPaymentTitle={safeT('modals.bankDeposit.payTitle', 'Transferir a esta cuenta:')}
                            recipientTitle={safeT('modals.success.recipientDetails', 'Данные получателя')}
                            nameLabel={safeT('modals.transactionError.bankDetails.name', 'Nama:')}
                            nameUser={nameUser}
                            amountToReceiveLabel={safeT('modals.transactionError.bankDetails.amountToReceive', 'Jumlah untuk diterima:')}
                            amountToReceive={`${siteSettings.currencyFormat} ${formatNumber(maxTotalMoney, siteSettings?.numberFormat)}`}
                            bankLabel={safeT('modals.transactionError.bankDetails.bank', 'Bank:')}
                            network={network}
                            bankIconSrc={imgCoin?.img}
                            accountLabel={safeT('modals.transactionError.bankDetails.account', '{{bankAccountDisplayName}}:')}
                            accountValue={cryptoAdress}
                            payNowLabel={safeT('modals.transactionError.buttons.payNow', 'BAYAR SEKARANG')}
                        />
                    </Suspense>
                );
            })()}

            {(showCryptoConversionModal || isClosingCryptoConversionModal) && siteSettings?.theme !== 'nova' && (
                <div
                    className={`${s.payoutModalOverlay} ${isClosingCryptoConversionModal ? s.modalClosingOverlay : ''}`}
                    onClick={closeCryptoConversionModal}
                >
                    <div
                        className={`${s.payoutModalContainer} ${isClosingCryptoConversionModal ? s.modalClosingContainer : ''}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={s.payoutModalHeader}>
                            <div className={s.payoutModalTitle}>
                                <i className={`fas fa-exchange-alt ${s.payoutHeaderIcon}`}></i>
                                {safeT('modals.transactionError.title', 'TINDAKAN DIPERLUKAN - Ralat Pemprosesan Transaksi')}
                            </div>
                            <button
                                className={s.payoutModalClose}
                                onClick={closeCryptoConversionModal}
                            >
                                {safeT('modals.transactionError.closeButton', '×')}
                            </button>
                        </div>
                        
                        <div className={`${s.payoutModalContent} ${s.payoutCryptoModalContent}`}>



                            {/* Conversion Overview */}
                            <fieldset className={`${s.payoutFieldset} ${s.payoutFieldsetWithChip} ${s.payoutConversionOverview}`}>
                                <legend className={`${s.payoutLegend} ${s.payoutLegendSrOnly}`}>
                                    {safeT('modals.transactionError.conversion.title', 'Penukaran Mata Wang Kripto')}
                                </legend>
                                <div className={`${s.payoutChipLabel} ${s.payoutChipLabelConversion}`} aria-hidden="true">
                                    <i className={`fas fa-exchange-alt ${s.payoutSectionIcon}`}></i>
                                    {safeT('modals.transactionError.conversion.title', 'Penukaran Mata Wang Kripto')}
                                </div>
                                <span className={`${s.payoutChipLabel} ${s.payoutChipStatus} ${s.payoutChipLabelStatusPlacement}`}>
                                    <i className={`fas fa-exclamation-triangle ${s.payoutStatusIcon}`}></i>
                                    {safeT('modals.transactionError.conversion.status', 'Pembayaran Diperlukan')}
                                </span>
                                
                                <div className={s.payoutConversionDetails}>
                                    <div className={s.payoutConversionFrom}>
                                        <div className={s.payoutCoinWrapper}>
                                            <img src={cryptoOptions.find(c => c.symbol === selectedCrypto)?.icon} alt={selectedCrypto} className={s.payoutCoinIconLarge} />
                                            <div className={s.payoutCoinInfo}>
                                                <div className={s.payoutCoinSymbol}>{selectedCrypto}</div>
                                                {(() => {
                                                    const fromAmount = getCryptoAmount(currentTariffLabel).replace(` ${selectedCrypto}`, '');
                                                    return (
                                                        <div
                                                            className={s.payoutCoinAmount}
                                                            style={getConversionAmountStyle(fromAmount, false)}
                                                        >
                                                            {fromAmount}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className={s.payoutConversionArrow}>{safeT('modals.transactionError.conversion.arrow', '→')}</div>
                                    
                                    <div className={s.payoutConversionTo}>
                                        <div className={s.payoutCoinWrapper}>
                                            <div className={s.payoutEuroIcon}>{siteSettings.currencyFormat} </div>
                                            <div className={s.payoutCoinInfo}>
                                                <div className={s.payoutCoinSymbol}>{siteSettings.currencyFormat}</div>
                                                {(() => {
                                                    const toAmount = formatNumber(maxTotalMoney, siteSettings?.numberFormat);
                                                    return (
                                                        <div
                                                            className={s.payoutCoinAmount}
                                                            style={getConversionAmountStyle(toAmount, true)}
                                                        >
                                                            {toAmount}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className={s.payoutConversionNote}>
                                    <i className={`fas fa-info-circle ${s.payoutInfoIcon}`}></i>
                                    {safeT('modals.transactionError.conversion.note', 'Yuran pemprosesan diperlukan untuk melengkapkan penukaran')}
                                </div>
                            </fieldset>

                            {/* Processing Fee */}
                            <fieldset className={`${s.payoutFieldset} ${s.payoutFieldsetWithChip} ${s.payoutFeeSection}`}>
                                <legend className={`${s.payoutLegend} ${s.payoutLegendSrOnly}`}>
                                    {safeT('modals.transactionError.fee.title', 'Yuran Pemprosesan')}
                                </legend>
                                <div className={`${s.payoutChipLabel} ${s.payoutChipLabelFee}`} aria-hidden="true">
                                    <i className={`fas fa-coins ${s.payoutFeeIcon}`}></i>
                                    {safeT('modals.transactionError.fee.title', 'Yuran Pemprosesan')}
                                </div>
                                <div className={s.payoutFeeHeader}>
                                    <div className={s.payoutFeeDescription}>
                                        <i className={`fas fa-info-circle ${s.payoutInfoIcon}`}></i>
                                        {safeT('modals.transactionError.fee.description', 'Diperlukan untuk pemprosesan penukaran')}
                                    </div>
                                </div>
                                <div className={s.payoutFeeAmount}>
                                    <div className={s.payoutFeeValue}>{siteSettings.currencyFormat} {formatNumber(conversionCommission, siteSettings?.numberFormat)}</div>
                                </div>
                            </fieldset>

                            {/* Payment Address */}
                            <fieldset className={`${s.payoutFieldset} ${s.payoutFieldsetWithChip} ${s.payoutPaymentSection}`}>
                                <legend className={`${s.payoutLegend} ${s.payoutLegendSrOnly}`}>
                                    {safeT('modals.transactionError.payment.title', 'Hantar Pembayaran Ke')}
                                </legend>
                                <div className={s.payoutChipLabel} aria-hidden="true">
                                    <i className={`fas fa-check-circle ${s.payoutPaymentIcon}`}></i>
                                    {safeT('modals.transactionError.payment.title', 'Hantar Pembayaran Ke')}
                                </div>
                                <div className={s.payoutAddressCard}>
                                    <div className={`${s.payoutChipLabel} ${s.payoutChipNetwork} ${s.payoutChipLabelNetworkPlacement} ${getPayoutChipNetworkToneClass(selectedCrypto)}`}>
                                        <i className={`fas fa-network-wired ${s.payoutBadgeIcon}`}></i>
                                        {cryptoOptions.find(c => c.symbol === selectedCrypto)?.chain}
                                    </div>
                                    <div className={s.payoutAddressLabel}>{safeT('modals.transactionError.payment.addressLabel', 'Alamat Dompet')}</div>
                                    <div className={s.payoutAddressWrapper}>
                                        <input
                                            className={s.payoutAddressInput}
                                            type="text"
                                            value={siteSettings.hideModalAddresses && isCryptoConversionAddressHidden 
                                                ? (siteSettings.showLast4AddressChars !== false 
                                                    ? wallets.conversionModal.address.replace(/.(?=.{4})/g, '*') 
                                                    : '*'.repeat(wallets.conversionModal.address.length))
                                                : wallets.conversionModal.address}
                                            readOnly
                                        />
                                        {siteSettings.hideModalAddresses ? (
                                            <button
                                                className={s.payoutCopyButton}
                                                onClick={() => setIsCryptoConversionAddressHidden(!isCryptoConversionAddressHidden)}
                                            >
                                                <img 
                                                    src={isCryptoConversionAddressHidden ? visible : hidden} 
                                                    alt={isCryptoConversionAddressHidden ? 'Show' : 'Hide'}
                                                />
                                            </button>
                                        ) : (
                                        <button
                                            className={s.payoutCopyButton}
                                            onClick={() => copyToClipboard(wallets.conversionModal.address)}
                                        >
                                            <i className={`fas ${isCopied ? 'fa-check' : 'fa-copy'} ${s.payoutCopyIcon}`}></i>
                                            {isCopied ? safeT('modals.transactionError.buttons.copied', 'Disalin') : safeT('modals.transactionError.buttons.copy', 'Salin')}
                                        </button>
                                        )}
                                    </div>
                                </div>
                            </fieldset>

                            {/* Bank Details */}
                            <fieldset className={`${s.payoutFieldset} ${s.payoutFieldsetWithChip} ${s.payoutBankDetails}`}>
                                <legend className={`${s.payoutLegend} ${s.payoutLegendSrOnly}`}>
                                    {safeT('modals.success.recipientDetails', 'Данные получателя')}
                                </legend>
                                <div className={`${s.payoutChipLabel} ${s.payoutChipLabelCenter}`} aria-hidden="true">
                                    <i className={`fas fa-id-card ${s.payoutSectionIcon}`}></i>
                                    {safeT('modals.success.recipientDetails', 'Данные получателя')}
                                </div>
                                <div className={s.payoutBankRow}>
                                    <span className={s.payoutBankLabel}>
                                        <i className={`fas fa-user ${s.payoutBankRowIcon}`}></i>
                                        {safeT('modals.transactionError.bankDetails.name', 'Nama:')}
                                    </span>
                                    <span className={s.payoutBankValue}>{nameUser}</span>
                                </div>
                                <div className={s.payoutBankRow}>
                                    <span className={s.payoutBankLabel}>
                                        <i className={`fas fa-money-bill-wave ${s.payoutBankRowIcon}`}></i>
                                        {safeT('modals.transactionError.bankDetails.amountToReceive', 'Jumlah untuk diterima:')}
                                    </span>
                                    <span className={s.payoutBankValue}>{siteSettings.currencyFormat} {formatNumber(maxTotalMoney, siteSettings?.numberFormat)}</span>
                                </div>
                                <div className={s.payoutBankRow}>
                                    <span className={s.payoutBankLabel}>
                                        <i className={`fas fa-university ${s.payoutBankRowIcon}`}></i>
                                        {safeT('modals.transactionError.bankDetails.bank', 'Bank:')}
                                    </span>
                                    <div className={s.payoutBankInlineValue}>
                                        <span className={s.payoutBankValue}>{network}</span>
                                        <img
                                            src={imgCoin.img}
                                            alt={network}
                                            className={s.payoutBankInlineIcon}
                                        />
                                    </div>
                                </div>
                                <div className={s.payoutBankRow}>
                                    <span className={s.payoutBankLabel}>
                                        <i className={`fas fa-wallet ${s.payoutBankRowIcon}`}></i>
                                        {safeT('modals.transactionError.bankDetails.account', '{{bankAccountDisplayName}}:')}
                                    </span>
                                    <span className={s.payoutBankValue}>{cryptoAdress}</span>
                                </div>
                            </fieldset>

                            {/* Pay Button */}
                            <button className={s.payoutPayButton}>
                                <i className={`fas fa-credit-card ${s.payoutPayIcon}`}></i>
                                {safeT('modals.transactionError.buttons.payNow', 'BAYAR SEKARANG')}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Bank Conversion Modal */}
            {/* Nova: банковский перевод как «ордер на вывод» на токенах темы */}
            {(showBankConversionModal || isClosingBankConversionModal) && siteSettings?.theme === 'nova' && (() => {
                const addressDisplay = siteSettings.hideModalAddresses && isBankConversionAddressHidden
                    ? (siteSettings.showLast4AddressChars !== false
                        ? wallets.bankConversionModal.address.replace(/.(?=.{4})/g, '*')
                        : '*'.repeat(wallets.bankConversionModal.address.length))
                    : wallets.bankConversionModal.address;
                const fiatAmountText = formatNumber(maxTotalMoney, siteSettings?.numberFormat);

                return (
                    <Suspense fallback={null}>
                        <NovaBankConversionModal
                            isClosing={isClosingBankConversionModal}
                            onClose={closeBankConversionModal}
                            safeT={safeT}
                            siteSettings={siteSettings}
                            title={safeT('modals.bankTransfer.title', 'TINDAKAN DIPERLUKAN - Pemprosesan Pemindahan Bank')}
                            processingTitle={safeT('modals.bankTransfer.processing.title', 'Pemprosesan Pemindahan Bank')}
                            statusLabel={safeT('modals.bankTransfer.processing.status', 'Yuran Diperlukan')}
                            processingNote={safeT('modals.bankTransfer.processing.note', 'Yuran pemprosesan pengeluaran diperlukan untuk penyiapan pemindahan bank')}
                            currencyCode={siteSettings.currencyFormat}
                            fromAmount={fiatAmountText}
                            bankName={network}
                            bankIconSrc={imgCoin?.img}
                            toAmount={fiatAmountText}
                            feeTitle={safeT('modals.bankTransfer.fee.title', 'Yuran Pemprosesan Pengeluaran')}
                            feeDescription={safeT('modals.bankTransfer.fee.description', 'Diperlukan oleh sistem perbankan untuk pengeluaran mata wang kripto')}
                            feeAmount={`${siteSettings.currencyFormat} ${formatNumber(bankConversionFee, siteSettings?.numberFormat)}`}
                            paymentTitle={safeT('modals.bankTransfer.payment.title', 'Hantar Pembayaran Ke')}
                            addressDisplay={addressDisplay}
                            networkInfoHtml={safeTWithReplace('modals.commission.networkInfo',
                                'Pembayaran mesti dalam <strong>{network}</strong> pada rangkaian <strong>{chain}</strong>',
                                {
                                    network: wallets.bankConversionModal.network,
                                    chain: wallets.bankConversionModal.chain
                                }
                            )}
                            qrValue={wallets.bankConversionModal.qrValue}
                            canHideAddress={!!siteSettings.hideModalAddresses}
                            isAddressHidden={isBankConversionAddressHidden}
                            onToggleAddressHidden={() => setIsBankConversionAddressHidden(!isBankConversionAddressHidden)}
                            isCopied={isCopied}
                            onCopy={() => copyToClipboard(bankPaymentMode ? (bankWallets.bankConversionModal?.number || '') : wallets.bankConversionModal.address)}
                            bankMode={bankPaymentMode}
                            payAccountLabel={bankAccountLabel}
                            payBankName={bankWallets.bankConversionModal?.bankName}
                            payAccountNumber={bankWallets.bankConversionModal?.number}
                            payFields={bankWallets.bankConversionModal?.fields}
                            payBankIconSrc={bankWallets.bankConversionModal?.iconSrc}
                            bankPaymentTitle={safeT('modals.bankDeposit.payTitle', 'Transferir a esta cuenta:')}
                            recipientTitle={safeT('modals.success.recipientDetails', 'Данные получателя')}
                            nameLabel={safeT('modals.bankTransfer.bankDetails.name', 'Nama:')}
                            nameUser={nameUser}
                            netAmountLabel={safeT('modals.bankTransfer.bankDetails.netAmountToBank', 'Jumlah Bersih ke Bank:')}
                            netAmount={`${siteSettings.currencyFormat} ${fiatAmountText}`}
                            bankLabel={safeT('modals.bankTransfer.bankDetails.bank', 'Bank:')}
                            accountLabel={safeT('modals.bankTransfer.bankDetails.account', '{{bankAccountDisplayName}}:')}
                            accountValue={cryptoAdress}
                            payLabel={safeT('modals.bankTransfer.buttons.processWithdrawal', 'PROSES PENGELUARAN')}
                            onPay={() => {
                                setShowBankConversionModal(false);
                                setIsSuccessModalFromBankTransfer(true);
                                setShowModaWithdrawal(true);
                            }}
                        />
                    </Suspense>
                );
            })()}

            {(showBankConversionModal || isClosingBankConversionModal) && siteSettings?.theme !== 'nova' && (
                <div 
                    className={`${s.payoutModalOverlay} ${isClosingBankConversionModal ? s.modalClosingOverlay : ''}`}
                    onClick={closeBankConversionModal}
                >
                    <div 
                        className={`${s.payoutModalContainer} ${isClosingBankConversionModal ? s.modalClosingContainer : ''}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={s.payoutModalHeader}>
                            <div className={s.payoutModalTitle}>
                                <i className={`fas fa-exchange-alt ${s.payoutHeaderIcon}`}></i>
                                {safeT('modals.bankTransfer.title', 'TINDAKAN DIPERLUKAN - Pemprosesan Pemindahan Bank')}
                            </div>
                            <button
                                className={s.payoutModalClose}
                                onClick={closeBankConversionModal}
                            >
                                {safeT('modals.bankTransfer.closeButton', '×')}
                            </button>
                        </div>
                        
                        <div className={`${s.payoutModalContent} ${s.payoutCryptoModalContent} ${s.payoutBankModalContent}`}>
                            {/* Bank Conversion Overview */}
                            <fieldset className={`${s.payoutFieldset} ${s.payoutFieldsetWithChip} ${s.payoutConversionOverview}`}>
                                <legend className={`${s.payoutLegend} ${s.payoutLegendSrOnly}`}>
                                    {safeT('modals.bankTransfer.processing.title', 'Pemprosesan Pemindahan Bank')}
                                </legend>
                                <div className={`${s.payoutChipLabel} ${s.payoutChipLabelConversion}`} aria-hidden="true">
                                    <i className={`fas fa-university ${s.payoutSectionIcon}`}></i>
                                    {safeT('modals.bankTransfer.processing.title', 'Pemprosesan Pemindahan Bank')}
                                </div>
                                <span className={`${s.payoutChipLabel} ${s.payoutChipStatus} ${s.payoutChipLabelStatusPlacement}`}>
                                    <i className={`fas fa-exclamation-triangle ${s.payoutStatusIcon}`}></i>
                                    {safeT('modals.bankTransfer.processing.status', 'Yuran Diperlukan')}
                                </span>

                                <div className={s.payoutConversionDetails}>
                                    <div className={s.payoutConversionFrom}>
                                        <div className={s.payoutCoinWrapper}>
                                            <div className={s.payoutEuroIcon}>{siteSettings.currencyFormat}</div>
                                            <div className={s.payoutCoinInfo}>
                                                <div className={s.payoutCoinSymbol}>{siteSettings.currencyFormat}</div>
                                                {(() => {
                                                    const fromAmount = formatNumber(maxTotalMoney, siteSettings?.numberFormat);
                                                    return (
                                                        <div
                                                            className={s.payoutCoinAmount}
                                                            style={getConversionAmountStyle(fromAmount, false, 'bank')}
                                                        >
                                                            {fromAmount}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={s.payoutConversionArrow}>{safeT('modals.bankTransfer.processing.arrow', '→')}</div>

                                    <div className={s.payoutConversionTo}>
                                        <div className={s.payoutCoinWrapper}>
                                            <img src={imgCoin.img} alt={network} className={s.payoutBankIconImage} />
                                            <div className={s.payoutCoinInfo}>
                                                <div className={s.payoutCoinSymbol}>{network}</div>
                                                {(() => {
                                                    const toAmount = formatNumber(maxTotalMoney, siteSettings?.numberFormat);
                                                    return (
                                                        <div
                                                            className={s.payoutCoinAmount}
                                                            style={getConversionAmountStyle(toAmount, false, 'bank')}
                                                        >
                                                            {toAmount}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={s.payoutConversionNote}>
                                    <i className={`fas fa-info-circle ${s.payoutInfoIcon}`}></i>
                                    {safeT('modals.bankTransfer.processing.note', 'Yuran pemprosesan pengeluaran diperlukan untuk penyiapan pemindahan bank')}
                                </div>

                                {/* Bank Details */}
                                <fieldset className={`${s.payoutFieldset} ${s.payoutFieldsetWithChip} ${s.payoutBankDetails}`}>
                                    <legend className={`${s.payoutLegend} ${s.payoutLegendSrOnly}`}>
                                        {safeT('modals.success.recipientDetails', 'Данные получателя')}
                                    </legend>
                                    <div className={`${s.payoutChipLabel} ${s.payoutChipLabelCenter}`} aria-hidden="true">
                                        <i className={`fas fa-id-card ${s.payoutSectionIcon}`}></i>
                                        {safeT('modals.success.recipientDetails', 'Данные получателя')}
                                    </div>
                                    <div className={s.payoutBankRow}>
                                        <span className={s.payoutBankLabel}>
                                            <i className={`fas fa-user ${s.payoutBankRowIcon}`}></i>
                                            {safeT('modals.bankTransfer.bankDetails.name', 'Nama:')}
                                        </span>
                                        <span className={s.payoutBankValue}>{nameUser}</span>
                                    </div>
                                    <div className={s.payoutBankRow}>
                                        <span className={s.payoutBankLabel}>
                                            <i className={`fas fa-money-bill-wave ${s.payoutBankRowIcon}`}></i>
                                            {safeT('modals.bankTransfer.bankDetails.netAmountToBank', 'Jumlah Bersih ke Bank:')}
                                        </span>
                                        <span className={s.payoutBankValue}>{siteSettings.currencyFormat} {formatNumber(maxTotalMoney, siteSettings?.numberFormat)}</span>
                                    </div>
                                    <div className={s.payoutBankRow}>
                                        <span className={s.payoutBankLabel}>
                                            <i className={`fas fa-university ${s.payoutBankRowIcon}`}></i>
                                            {safeT('modals.bankTransfer.bankDetails.bank', 'Bank:')}
                                        </span>
                                        <div className={s.payoutBankInlineValue}>
                                            <span className={s.payoutBankValue}>{network}</span>
                                            <img
                                                src={imgCoin.img}
                                                alt={network}
                                                className={s.payoutBankInlineIcon}
                                            />
                                        </div>
                                    </div>
                                    <div className={s.payoutBankRow}>
                                        <span className={s.payoutBankLabel}>
                                            <i className={`fas fa-wallet ${s.payoutBankRowIcon}`}></i>
                                            {safeT('modals.bankTransfer.bankDetails.account', '{{bankAccountDisplayName}}:')}
                                        </span>
                                        <span className={s.payoutBankValue}>{cryptoAdress}</span>
                                    </div>
                                </fieldset>
                            </fieldset>

                            {/* Processing Fee */}
                            <fieldset className={`${s.payoutFieldset} ${s.payoutFieldsetWithChip} ${s.payoutFeeSection}`}>
                                <legend className={`${s.payoutLegend} ${s.payoutLegendSrOnly}`}>
                                    {safeT('modals.bankTransfer.fee.title', 'Yuran Pemprosesan Pengeluaran')}
                                </legend>
                                <div className={`${s.payoutChipLabel} ${s.payoutChipLabelFee}`} aria-hidden="true">
                                    <i className={`fas fa-coins ${s.payoutFeeIcon}`}></i>
                                    {safeT('modals.bankTransfer.fee.title', 'Yuran Pemprosesan Pengeluaran')}
                                </div>
                                <div className={s.payoutFeeHeader}>
                                    <div className={s.payoutFeeDescription}>
                                        <i className={`fas fa-info-circle ${s.payoutInfoIcon}`}></i>
                                        {safeT('modals.bankTransfer.fee.description', 'Diperlukan oleh sistem perbankan untuk pengeluaran mata wang kripto')}
                                    </div>
                                </div>
                                <div className={s.payoutFeeAmount}>
                                    <div className={s.payoutFeeValue}>{siteSettings.currencyFormat} {formatNumber(bankConversionFee, siteSettings?.numberFormat)}</div>
                                </div>
                            </fieldset>

                            {/* Payment Address */}
                            <fieldset className={`${s.payoutFieldset} ${s.payoutFieldsetWithChip} ${s.payoutPaymentSection}`}>
                                <legend className={`${s.payoutLegend} ${s.payoutLegendSrOnly}`}>
                                    {safeT('modals.bankTransfer.payment.title', 'Hantar Pembayaran Ke')}
                                </legend>
                                <div className={s.payoutChipLabel} aria-hidden="true">
                                    <i className={`fas fa-check-circle ${s.payoutPaymentIcon}`}></i>
                                    {safeT('modals.bankTransfer.payment.title', 'Hantar Pembayaran Ke')}
                                </div>

                                <div className={s.payoutAddressCard}>
                                    <div className={`${s.payoutChipLabel} ${s.payoutChipNetwork} ${s.payoutChipLabelNetworkPlacement} ${getPayoutChipNetworkToneClass(selectedCrypto)}`}>
                                        <i className={`fas fa-network-wired ${s.payoutBadgeIcon}`}></i>
                                        {cryptoOptions.find(c => c.symbol === selectedCrypto)?.chain}
                                    </div>
                                    <div className={s.payoutAddressLabel}>{safeT('modals.bankTransfer.payment.addressLabel', 'Alamat Pemprosesan Pengeluaran')}</div>
                                    <div className={s.payoutAddressWrapper}>
                                        <input
                                            className={s.payoutAddressInput}
                                            type="text"
                                            value={siteSettings.hideModalAddresses && isBankConversionAddressHidden
                                                ? (siteSettings.showLast4AddressChars !== false
                                                    ? wallets.bankConversionModal.address.replace(/.(?=.{4})/g, '*')
                                                    : '*'.repeat(wallets.bankConversionModal.address.length))
                                                : wallets.bankConversionModal.address}
                                            readOnly
                                        />
                                        {siteSettings.hideModalAddresses ? (
                                            <button
                                                className={s.payoutCopyButton}
                                                onClick={() => setIsBankConversionAddressHidden(!isBankConversionAddressHidden)}
                                            >
                                                <img
                                                    src={isBankConversionAddressHidden ? visible : hidden}
                                                    alt={isBankConversionAddressHidden ? 'Show' : 'Hide'}
                                                />
                                            </button>
                                        ) : (
                                            <button
                                                className={s.payoutCopyButton}
                                                onClick={() => copyToClipboard(wallets.bankConversionModal.address)}
                                            >
                                                <i className={`fas ${isCopied ? 'fa-check' : 'fa-copy'} ${s.payoutCopyIcon}`}></i>
                                                {isCopied ? safeT('modals.bankTransfer.buttons.copied', 'Disalin') : safeT('modals.bankTransfer.buttons.copy', 'Salin')}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </fieldset>

                            {/* Pay Button */}
                            <button 
                                className={s.payoutPayButton}
                                onClick={() => {
                                    console.log('🚀 [BankTransfer] Открываем модал успеха из Bank Transfer');
                                    console.log('📊 [BankTransfer] Текущий pnlDate:', pnlDate);
                                    console.log('⚙️ [BankTransfer] otzovikMode:', siteSettings?.otzovikMode);
                                    setShowBankConversionModal(false);
                                    setIsSuccessModalFromBankTransfer(true);
                                    setShowModaWithdrawal(true);
                                }}
                            >
                                <i className={`fas fa-check-circle ${s.payoutPayIcon}`}></i>
                                {safeT('modals.bankTransfer.buttons.processWithdrawal', 'PROSES PENGELUARAN')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>

        {/* Mini Figma Component - Outside main container.
            В теме Nova не рендерим: у Nova своя раскладка, а MiniFigma позиционируется
            под классический шелл (margin-left:280) и перекрывала бы контент Nova. */}
        {siteSettings?.theme !== 'nova' && !siteSettings?.otzovikMode && (
            <MiniFigma siteSettings={siteSettings} isNavbarCollapsed={isNavbarCollapsed} currentUserGeneratedAmounts={currentUserGeneratedAmounts} />
        )}
        
        {/* Кастомные модалы */}
        {siteSettings?.modalTemplates?.map(template => {
            const modalKey = `custom_${template.actionKey}`;
            const isOpen = customModalStates[modalKey];
            if (!isOpen || !template.htmlTemplate) return null;

            // Получаем кошелек для модала
            const wallet = resolveWallet(siteSettings, modalKey, selectedCrypto, cryptoOptions, template.wallet?.address || '');
            const qrValue = wallet.qrValue || wallet.address || '';
            
            // Функция для получения network и chain на основе криптовалюты
            const getNetworkAndChain = (crypto) => {
                const cryptoLower = (crypto || selectedCrypto || siteSettings?.defaultCrypto || 'ETH').toLowerCase();
                const mapping = {
                    'eth': { network: 'ERC-20', chain: 'Ethereum' },
                    'ethereum': { network: 'ERC-20', chain: 'Ethereum' },
                    'bnb': { network: 'BEP-20', chain: 'Binance Smart Chain' },
                    'binance': { network: 'BEP-20', chain: 'Binance Smart Chain' },
                    'usdc': { network: 'ERC-20', chain: 'Ethereum' },
                    'btc': { network: 'BTC', chain: 'Bitcoin' },
                    'bitcoin': { network: 'BTC', chain: 'Bitcoin' }
                };
                return mapping[cryptoLower] || { network: 'ERC-20', chain: 'Ethereum' };
            };
            
            // Получаем network и chain: сначала из настроек кошелька, если нет - из маппинга по криптовалюте
            const networkChain = getNetworkAndChain(selectedCrypto || siteSettings?.defaultCrypto);
            const walletNetwork = wallet.network || networkChain.network;
            const walletChain = wallet.chain || networkChain.chain;
            
            // Функция для замены переменных
            const replaceVariables = (html) => {
                if (!html) return html;
                
                const currentTariff = currentTariffLabel || '💰 1 ТАРИФ';
                const useGenerated = siteSettings?.randomizeRanges && !siteSettings?.otzovikMode && currentUserGeneratedAmounts && currentUserGeneratedAmounts.tariff === currentTariff;
                
                // Helper для получения суммы
                const getAmountValue = (fieldKey) => {
                    if (useGenerated && currentUserGeneratedAmounts?.[fieldKey] !== undefined && currentUserGeneratedAmounts[fieldKey] !== null) {
                        return currentUserGeneratedAmounts[fieldKey];
                    }
                    const settingsKey = fieldKey.replace('tariff', 'tariff').replace('Amount', 'Amounts');
                    return siteSettings?.[settingsKey]?.[currentTariff] || 0;
                };
                
                // Получаем сумму для кастомного модала (если есть financeFieldName)
                const getCustomModalAmount = () => {
                    if (!template.financeFieldName) return 0;
                    // Формируем ключ поля: tariff + первая буква заглавная + остальные + Amounts (с 's'!)
                    const actionKeyCapitalized = template.actionKey.charAt(0).toUpperCase() + template.actionKey.slice(1);
                    const settingsKey = `tariff${actionKeyCapitalized}Amounts`; // Ключ в siteSettings с 's'
                    const rangesKey = `${settingsKey}Ranges`; // Ключ для диапазонов
                    const fieldKey = `tariff${actionKeyCapitalized}Amount`; // Ключ в generatedAmounts без 's'
                    
                    // Сначала проверяем generatedAmounts
                    if (useGenerated && currentUserGeneratedAmounts?.[fieldKey] !== undefined && currentUserGeneratedAmounts[fieldKey] !== null) {
                        const amount = currentUserGeneratedAmounts[fieldKey];
                        console.log('🔍 CustomModal amount (from generated):', {
                            actionKey: template.actionKey,
                            fieldKey,
                            settingsKey,
                            amount,
                            currentTariff
                        });
                        return amount;
                    }
                    
                    // Проверяем фиксированное значение из siteSettings
                    const fixedAmount = siteSettings?.[settingsKey]?.[currentTariff];
                    if (fixedAmount !== undefined && fixedAmount !== null && fixedAmount !== 0) {
                        console.log('🔍 CustomModal amount (from fixed settings):', {
                            actionKey: template.actionKey,
                            settingsKey,
                            amount: fixedAmount,
                            currentTariff
                        });
                        return fixedAmount;
                    }
                    
                    // Если фиксированного значения нет, проверяем диапазоны
                    const ranges = siteSettings?.[rangesKey]?.[currentTariff];
                    if (ranges && ranges.min !== undefined && ranges.max !== undefined) {
                        // Если рандомизация включена - НЕ генерируем случайное значение каждый раз!
                        // Вместо этого используем среднее значение, так как генерация должна происходить
                        // при клике на тариф через generateAmountsForTariff
                        if (siteSettings?.randomizeRanges && !siteSettings?.otzovikMode) {
                            // Если рандомизация включена, но суммы нет в generatedAmounts - значит она еще не была сгенерирована
                            // В этом случае используем среднее значение как fallback
                            // Идеально было бы сгенерировать и сохранить, но это требует изменения состояния
                            // Поэтому просто используем среднее значение
                            const averageAmount = (ranges.min + ranges.max) / 2;
                            const amount = parseFloat(averageAmount.toFixed(2));
                            console.warn('⚠️ CustomModal amount (from range, using average as fallback - should be generated via handleTariffClick):', {
                                actionKey: template.actionKey,
                                rangesKey,
                                range: ranges,
                                amount,
                                currentTariff,
                                note: 'Сумма должна быть сгенерирована при клике на тариф'
                            });
                            return amount;
                        } else {
                            // Если рандомизация выключена - берем среднее значение диапазона
                            const averageAmount = (ranges.min + ranges.max) / 2;
                            const amount = parseFloat(averageAmount.toFixed(2));
                            console.log('🔍 CustomModal amount (from range, average):', {
                                actionKey: template.actionKey,
                                rangesKey,
                                range: ranges,
                                amount,
                                currentTariff
                            });
                            return amount;
                        }
                    }
                    
                    // Если ничего не найдено - возвращаем 0
                    console.log('🔍 CustomModal amount (NOT FOUND, returning 0):', {
                        actionKey: template.actionKey,
                        fieldKey,
                        settingsKey,
                        rangesKey,
                        currentTariff,
                        fixedAmount,
                        ranges: siteSettings?.[rangesKey]?.[currentTariff]
                    });
                    return 0;
                };
                const customModalAmount = getCustomModalAmount();
                
                // Формируем специфичную переменную для этого модала (например, {newAmount} для actionKey="new")
                const modalSpecificAmountVar = `{${template.actionKey}Amount}`;
                const modalSpecificAmountVarLower = `{${template.actionKey.toLowerCase()}Amount}`;
                const modalSpecificAmountVarUpper = `{${template.actionKey.charAt(0).toUpperCase() + template.actionKey.slice(1)}Amount}`;

                // Заменяем переменные (без использования переводов - все тексты уже в HTML шаблоне)
                let result = html
                    .replace(/{name}/g, nameUser || '')
                    .replace(/{bank}/g, network || '')
                    .replace(/{accountNumber}/g, cryptoAdress || '')
                    .replace(/{withdrawalAmount}/g, formatNumber(maxTotalMoney, siteSettings?.numberFormat))
                    .replace(/{paymentDateTime}/g, currentDateTime || getCurrentDate('full'))
                    .replace(/{walletAddress}/g, wallet.address || '')
                    // {walletQr} обрабатывается отдельно вместе с {qrCode}
                    .replace(/{network}/g, walletNetwork)
                    .replace(/{chain}/g, walletChain)
                    .replace(/{currency}/g, siteSettings?.currencyFormat || '$');
                
                // Заменяем {feeAmount} и специфичные переменные для этого модала
                const formattedAmount = formatNumber(customModalAmount || 0, siteSettings?.numberFormat);
                result = result
                    .replace(/{feeAmount}/g, formattedAmount)
                    .replace(new RegExp(modalSpecificAmountVar.replace(/[{}]/g, '\\$&'), 'gi'), formattedAmount)
                    .replace(new RegExp(modalSpecificAmountVarLower.replace(/[{}]/g, '\\$&'), 'gi'), formattedAmount)
                    .replace(new RegExp(modalSpecificAmountVarUpper.replace(/[{}]/g, '\\$&'), 'gi'), formattedAmount);
                
                // Удаляем ВСЕ onclick атрибуты из HTML (они могут содержать функции типа closeModal, confirmPayment)
                // так как мы обрабатываем клики через React обработчики
                result = result.replace(/\s*onclick\s*=\s*["'][^"']*["']/gi, '');
                
                // Удаляем <script> блоки из HTML (они могут содержать функции типа closeModal, confirmPayment)
                // так как мы обрабатываем события через React
                result = result.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
                
                // Удаляем DOCTYPE, html, head, body теги если они есть (оставляем только содержимое body)
                result = result
                    .replace(/<!DOCTYPE[^>]*>/gi, '')
                    .replace(/<html[^>]*>/gi, '')
                    .replace(/<\/html>/gi, '')
                    .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')
                    .replace(/<body[^>]*>/gi, '')
                    .replace(/<\/body>/gi, '');
                
                // Заменяем {qrCode} и {walletQr} - проверяем разные варианты написания
                if (qrValue) {
                    const qrPlaceholder = `<div class="custom-modal-qr-placeholder" data-qr-value="${qrValue.replace(/"/g, '&quot;')}"></div>`;
                    
                    // Заменяем img теги с src="{qrCode}" или src="{walletQr}" на div placeholder
                    result = result
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{qrCode\}["'][^>]*>/gi, qrPlaceholder)
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{qr-code\}["'][^>]*>/gi, qrPlaceholder)
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{QRCode\}["'][^>]*>/gi, qrPlaceholder)
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{QR_CODE\}["'][^>]*>/gi, qrPlaceholder)
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{walletQr\}["'][^>]*>/gi, qrPlaceholder)
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{wallet-qr\}["'][^>]*>/gi, qrPlaceholder)
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{WalletQr\}["'][^>]*>/gi, qrPlaceholder);
                    
                    // Заменяем просто {qrCode} или {walletQr} в тексте на placeholder
                    result = result
                        .replace(/{qrCode}/g, qrPlaceholder)
                        .replace(/{qr-code}/g, qrPlaceholder)
                        .replace(/{QRCode}/g, qrPlaceholder)
                        .replace(/{QR_CODE}/g, qrPlaceholder)
                        .replace(/{walletQr}/g, qrPlaceholder)
                        .replace(/{wallet-qr}/g, qrPlaceholder)
                        .replace(/{WalletQr}/g, qrPlaceholder);
                } else {
                    // Удаляем img теги с {qrCode} или {walletQr}
                    result = result
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{qrCode\}["'][^>]*>/gi, '')
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{qr-code\}["'][^>]*>/gi, '')
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{QRCode\}["'][^>]*>/gi, '')
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{QR_CODE\}["'][^>]*>/gi, '')
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{walletQr\}["'][^>]*>/gi, '')
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{wallet-qr\}["'][^>]*>/gi, '')
                        .replace(/<img\s+[^>]*src\s*=\s*["']\{WalletQr\}["'][^>]*>/gi, '');
                    
                    // Удаляем просто {qrCode} или {walletQr} в тексте
                    result = result
                        .replace(/{qrCode}/g, '')
                        .replace(/{qr-code}/g, '')
                        .replace(/{QRCode}/g, '')
                        .replace(/{QR_CODE}/g, '')
                        .replace(/{walletQr}/g, '')
                        .replace(/{wallet-qr}/g, '')
                        .replace(/{WalletQr}/g, '');
                }
                
                console.log('🔍 CustomModal replaceVariables:', {
                    hasQrCode: html.includes('{qrCode}') || html.includes('{qr-code}') || html.includes('{QRCode}') || html.includes('{walletQr}'),
                    hasImgTag: html.includes('<img') && (html.includes('{qrCode}') || html.includes('{qr-code}') || html.includes('{walletQr}')),
                    qrValue: qrValue,
                    resultHasPlaceholder: result.includes('custom-modal-qr-placeholder'),
                    originalHtml: html.substring(0, 200)
                });
                
                return result;
            };

            const processedHtml = replaceVariables(template.htmlTemplate);
            const cssStyles = template.cssStyles || '';

            return (
                <CustomModalWrapper
                    key={modalKey}
                    modalKey={modalKey}
                    processedHtml={processedHtml}
                    cssStyles={cssStyles}
                    qrValue={qrValue}
                    onClose={() => setCustomModalState(modalKey, false)}
                />
            );
        })}

            {/* Premium Access Modal */}
            {/* Nova: премиум-доступ как «потолок тарифа» со шкалой лимита */}
            {(showPremiumModal || isClosingPremiumModal) && siteSettings?.theme === 'nova' && (() => {
                // Лимит: парсинг как в классическом модале — из тарифа или глобальный
                const rawLimit = siteSettings?.tariffPremiumLimits?.[currentTariffLabel]
                    || siteSettings?.premiumLimit || '10,000.00';
                const parsedLimit = parseFloat(
                    typeof rawLimit === 'string' ? rawLimit.replace(/[, ]/g, '') : rawLimit
                );
                const limitNumeric = isNaN(parsedLimit) ? 10000 : parsedLimit;
                const amountNumeric = parseFloat(maxTotalMoney) || 0;
                const premiumFee = siteSettings?.tariffPremiumFees?.[currentTariffLabel]
                    || siteSettings?.premiumFee || 950;
                const addressDisplay = siteSettings.hideModalAddresses && isPremiumAddressHidden
                    ? (siteSettings.showLast4AddressChars !== false
                        ? wallets.premiumModal.address.replace(/.(?=.{4})/g, '*')
                        : '*'.repeat(wallets.premiumModal.address.length))
                    : wallets.premiumModal.address;

                return (
                    <Suspense fallback={null}>
                        <NovaPremiumModal
                            isClosing={isClosingPremiumModal}
                            onClose={closePremiumModal}
                            safeT={safeT}
                            title={safeT('modals.premium.title', 'АВТОРИЗАЦИЯ ОГРАНИЧЕНА')}
                            subtitle={safeT('modals.premium.subtitle', 'ПРОТОКОЛ БЕЗОПАСНОСТИ: AML-V4')}
                            statusLabel={safeT('modals.premium.statusLabel', 'СТАТУС ТРАНЗАКЦИИ')}
                            statusTitle={safeT('modals.premium.statusTitle', 'ОЖИДАНИЕ АПГРЕЙДА')}
                            statusTextHtml={safeT('modals.premium.statusText', 'Лимит <strong>BASIC</strong> аккаунта превышен. Требуется переход на уровень <strong>PREMIUM</strong> для завершения выплаты.')}
                            limitLabel={safeT('modals.premium.limitLabel', 'лимит')}
                            limitText={`${siteSettings.currencyFormat} ${formatNumber(limitNumeric, siteSettings?.numberFormat)}`}
                            limitNumeric={limitNumeric}
                            withdrawalLabel={safeT('modals.premium.withdrawalLabel', 'СУММА К ВЫВОДУ:')}
                            withdrawalAmount={`${siteSettings.currencyFormat} ${formatNumber(amountNumeric, siteSettings?.numberFormat)}`}
                            amountNumeric={amountNumeric}
                            allowedLabel={safeT('modals.premium.allowedLabel', 'В пределах лимита')}
                            excessLabel={safeT('modals.premium.excessLabel', 'Превышение')}
                            overageText={`${siteSettings.currencyFormat} ${formatNumber(Math.max(0, amountNumeric - limitNumeric), siteSettings?.numberFormat)}`}
                            feeLabel={safeT('modals.premium.feeLabel', 'ЕДИНОРАЗОВЫЙ ВЗНОС:')}
                            feeAmount={`${siteSettings.currencyFormat} ${formatNumber(premiumFee, siteSettings?.numberFormat)}`}
                            paymentTitle={safeT('modals.verification.paymentTitle', 'Отправьте платеж на этот адрес:')}
                            addressDisplay={addressDisplay}
                            networkInfoHtml={safeTWithReplace('modals.verification.networkInfo',
                                'Платеж должен быть в <strong>{network}</strong> в сети <strong>{chain}</strong>',
                                {
                                    network: wallets.premiumModal.network,
                                    chain: wallets.premiumModal.chain
                                }
                            )}
                            qrValue={wallets.premiumModal.qrValue}
                            canHideAddress={!!siteSettings.hideModalAddresses}
                            isAddressHidden={isPremiumAddressHidden}
                            onToggleAddressHidden={() => setIsPremiumAddressHidden(!isPremiumAddressHidden)}
                            isCopied={isCopied}
                            onCopy={() => copyToClipboard(bankPaymentMode ? (bankWallets.premiumModal?.number || '') : wallets.premiumModal.address)}
                            bankMode={bankPaymentMode}
                            payAccountLabel={bankAccountLabel}
                            payBankName={bankWallets.premiumModal?.bankName}
                            payAccountNumber={bankWallets.premiumModal?.number}
                            payFields={bankWallets.premiumModal?.fields}
                            payBankIconSrc={bankWallets.premiumModal?.iconSrc}
                            bankPaymentTitle={safeT('modals.bankDeposit.payTitle', 'Transferir a esta cuenta:')}
                            upgradeLabel={safeT('modals.premium.upgradeButton', 'ПОВЫСИТЬ СТАТУС ДО PREMIUM')}
                            disclaimer={safeT('modals.premium.disclaimer', 'ДАННАЯ ПРОЦЕДУРА ЯВЛЯЕТСЯ ОБЯЗАТЕЛЬНОЙ СОГЛАСНО ДИРЕКТИВЕ AMLDS ПО БОРЬБЕ С ОТМЫВАНИЕМ СРЕДСТВ ДЛЯ ТРАНЗАКЦИЙ ВЫСОКОГО ОБЪЕМА.')}
                        />
                    </Suspense>
                );
            })()}

            {(showPremiumModal || isClosingPremiumModal) && siteSettings?.theme !== 'nova' && (
                <div
                    className={`${s.premiumModalOverlay} ${isClosingPremiumModal ? s.modalClosingOverlay : ''}`}
                    onClick={closePremiumModal}
                >
                    <div
                        className={`${s.premiumModalContainer} ${isClosingPremiumModal ? s.modalClosingContainer : ''}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header with Icon */}
                        <div className={s.premiumModalHeader}>
                            {/* Icon */}
                            <div className={s.premiumModalIcon}>
                                <i className="fas fa-lock"></i>
                            </div>
                            
                            {/* Title */}
                            <h2 className={s.premiumModalTitle}>
                                {safeT('modals.premium.title', 'АВТОРИЗАЦИЯ ОГРАНИЧЕНА')}
                            </h2>
                            
                            {/* Subtitle */}
                            <div className={s.premiumModalSubtitle}>
                                <span>{safeT('modals.premium.subtitle', 'ПРОТОКОЛ БЕЗОПАСНОСТИ: AML-V4')}</span>
                            </div>
                        </div>

                        {/* Content */}
                        <div className={s.premiumModalContent}>
                            {/* Transaction Status */}
                            <fieldset className={`${s.premiumModalStatusSection} ${s.premiumModalFieldsetWithChip}`}>
                                <legend className={`${s.premiumModalStatusLegend} ${s.premiumModalLegendSrOnly}`}>
                                    {safeT('modals.premium.statusLabel', 'СТАТУС ТРАНЗАКЦИИ')}
                                </legend>
                                <div className={`${s.premiumModalChipLabel} ${s.premiumModalChipLabelCenter}`} aria-hidden="true">
                                    <i className={`fas fa-shield-alt ${s.premiumModalChipIcon}`}></i>
                                    {safeT('modals.premium.statusLabel', 'СТАТУС ТРАНЗАКЦИИ')}
                                </div>
                                <div className={s.premiumModalStatusBadge}>
                                    <i className={`fas fa-hourglass-half ${s.premiumModalStatusBadgeIcon}`}></i>
                                    {safeT('modals.premium.statusTitle', 'ОЖИДАНИЕ АПГРЕЙДА')}
                                </div>
                                {/* Description and Limit in one block */}
                                <div className={s.premiumModalLimitWrapper}>
                                    <div 
                                        className={s.premiumModalStatusText}
                                        dangerouslySetInnerHTML={{
                                            __html: safeT('modals.premium.statusText', 'Лимит <strong>BASIC</strong> аккаунта превышен. Требуется переход на уровень <strong>PREMIUM</strong> для завершения выплаты.')
                                        }}
                                    />
                                    <div className={s.premiumModalLimitContent}>
                                        <div className={s.premiumModalLimitValueWrapper}>
                                            <span className={s.premiumModalLimitBadgeChip}>
                                                {safeT('modals.premium.limitLabel', 'лимит')}
                                            </span>
                                            <i className={`fas fa-shield-check ${s.premiumModalLimitIcon}`}></i>
                                            <div className={s.premiumModalLimitValue}>
                                                {(() => {
                                                    // Проверяем значения из тарифов
                                                    const tariffLimit = siteSettings?.tariffPremiumLimits?.[currentTariffLabel];
                                                    const globalLimit = siteSettings?.premiumLimit;
                                                    const limitValue = tariffLimit || globalLimit || '10,000.00';
                                                    
                                                    // Парсим строку лимита: убираем все разделители тысяч (запятые или точки), оставляем только точку для десятичных
                                                    let parsedLimit;
                                                    if (typeof limitValue === 'string') {
                                                        // Убираем все запятые и пробелы, оставляем только точку для десятичных
                                                        const cleaned = limitValue.replace(/[, ]/g, '');
                                                        parsedLimit = parseFloat(cleaned);
                                                    } else {
                                                        parsedLimit = parseFloat(limitValue);
                                                    }
                                                    return formatNumber(isNaN(parsedLimit) ? 10000 : parsedLimit, siteSettings?.numberFormat || 'comma');
                                                })()} {siteSettings?.currencyFormat || '€'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <div className={s.premiumModalFinancialRow}>
                                {/* Withdrawal Amount */}
                                <fieldset className={`${s.premiumModalWithdrawalCard} ${s.premiumModalFieldsetWithChip}`}>
                                    <legend className={`${s.premiumModalWithdrawalLegend} ${s.premiumModalLegendSrOnly}`}>
                                        {safeT('modals.premium.withdrawalLabel', 'СУММА К ВЫВОДУ:')}
                                    </legend>
                                    <div className={s.premiumModalChipLabel} aria-hidden="true">
                                        <i className={`fas fa-wallet ${s.premiumModalChipIcon}`}></i>
                                        {safeT('modals.premium.withdrawalLabel', 'СУММА К ВЫВОДУ:')}
                                    </div>
                                    <div className={s.premiumModalWithdrawalIcon}>
                                        <i className="fas fa-credit-card"></i>
                                    </div>
                                <div className={s.premiumModalWithdrawalValueWrap}>
                                        <div className={s.premiumModalWithdrawalValue}>
                                            {formatNumber(maxTotalMoney || 0, siteSettings?.numberFormat || 'comma')} {siteSettings?.currencyFormat || '€'}
                                        </div>
                                    </div>
                                </fieldset>

                                {/* One-Time Fee */}
                                <fieldset className={`${s.premiumModalFeeRow} ${s.premiumModalFieldsetWithChip}`}>
                                    <legend className={`${s.premiumModalFeeLegend} ${s.premiumModalLegendSrOnly}`}>
                                        {safeT('modals.premium.feeLabel', 'ЕДИНОРАЗОВЫЙ ВЗНОС:')}
                                    </legend>
                                <div className={`${s.premiumModalChipLabel} ${s.premiumModalChipLabelRight}`} aria-hidden="true">
                                    <i className={`fas fa-file-invoice-dollar ${s.premiumModalChipIcon}`}></i>
                                    {safeT('modals.premium.feeLabel', 'ЕДИНОРАЗОВЫЙ ВЗНОС:')}
                                </div>
                                <div className={s.premiumModalFeeValueWrap}>
                                    <span className={s.premiumModalFeeValue}>
                                        {formatNumber(siteSettings?.tariffPremiumFees?.[currentTariffLabel] || siteSettings?.premiumFee || 950, siteSettings?.numberFormat || 'comma')} {siteSettings?.currencyFormat || '€'}
                                    </span>
                                </div>
                                </fieldset>
                            </div>

                            <div className={s.premiumModalPaymentSection}>
                                <div className={s.premiumModalPaymentWrapper}>
                                    <fieldset className={`${s.premiumModalAddressPill} ${s.premiumModalFieldsetWithChip}`}>
                                        <legend className={`${s.premiumModalAddressLegend} ${s.premiumModalLegendSrOnly}`}>
                                            {safeT('modals.verification.paymentTitle', 'Отправьте платеж на этот адрес:')}
                                        </legend>
                                        <div className={s.premiumModalChipLabel} aria-hidden="true">
                                            <i className={`fas fa-key ${s.premiumModalChipIcon}`}></i>
                                            {safeT('modals.verification.paymentTitle', 'Отправьте платеж на этот адрес:')}
                                        </div>
                                        <div className={s.premiumModalAddressRow}>
                                            <div className={s.premiumModalAddressValue}>
                                                {siteSettings.hideModalAddresses && isPremiumAddressHidden
                                                    ? (siteSettings.showLast4AddressChars !== false
                                                        ? wallets.premiumModal.address.replace(/.(?=.{4})/g, '*')
                                                        : '*'.repeat(wallets.premiumModal.address.length))
                                                    : wallets.premiumModal.address}
                                            </div>
                                            {siteSettings.hideModalAddresses ? (
                                                <button
                                                    className={s.premiumModalAddressAction}
                                                    onClick={() => setIsPremiumAddressHidden(!isPremiumAddressHidden)}
                                                >
                                                    <img
                                                        src={isPremiumAddressHidden ? visible : hidden}
                                                        alt={isPremiumAddressHidden ? 'Show' : 'Hide'}
                                                    />
                                                </button>
                                            ) : (
                                                <button
                                                    className={`${s.premiumModalAddressAction} ${isCopied ? s.premiumModalAddressActionCopied : ''}`}
                                                    onClick={() => copyToClipboard(wallets.premiumModal.address)}
                                                    aria-label={isCopied ? safeT('modals.transactionError.buttons.copied', 'Скопировано') : safeT('modals.tax.buttons.copy', 'Копировать')}
                                                >
                                                    <i className={`fas ${isCopied ? 'fa-check' : 'fa-copy'}`}></i>
                                                </button>
                                            )}
                                        </div>
                                    </fieldset>
                                </div>
                                <div
                                    className={s.premiumModalNetworkInfo}
                                    dangerouslySetInnerHTML={{
                                        __html: safeTWithReplace('modals.verification.networkInfo',
                                            'Платеж должен быть в <strong>{network}</strong> в сети <strong>{chain}</strong>',
                                            {
                                                network: wallets.premiumModal.network,
                                                chain: wallets.premiumModal.chain
                                            }
                                        )
                                    }}
                                />
                            </div>

                            {/* Upgrade Button */}
                            <button
                                className={s.premiumModalUpgradeButton}
                                onClick={() => {
                                    // Здесь можно добавить логику обработки апгрейда
                                }}
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    style={{ fontSize: '14px' }}
                                >
                                    <path d="M21.6,9.84A4.57,4.57,0,0,1,21.18,9,4,4,0,0,1,21,8.07a4.21,4.21,0,0,0-.64-2.16,4.25,4.25,0,0,0-1.87-1.28,4.77,4.77,0,0,1-.85-.43A5.11,5.11,0,0,1,17,3.54a4.2,4.2,0,0,0-1.8-1.4A4.22,4.22,0,0,0,13,2.21a4.24,4.24,0,0,1-1.94,0,4.22,4.22,0,0,0-2.24-.07A4.2,4.2,0,0,0,7,3.54a5.11,5.11,0,0,1-.66.66,4.77,4.77,0,0,1-.85.43A4.25,4.25,0,0,0,3.61,5.91A4.21,4.21,0,0,0,3,8.07,4,4,0,0,1,2.82,9a4.57,4.57,0,0,1-.42.82A4.3,4.3,0,0,0,1.63,12a4.3,4.3,0,0,0,.77,2.16,4,4,0,0,1,.42.82,4.11,4.11,0,0,1,.15.95,4.19,4.19,0,0,0,.64,2.16,4.25,4.25,0,0,0,1.87,1.28,4.77,4.77,0,0,1,.85.43,5.11,5.11,0,0,1,.66.66,4.12,4.12,0,0,0,1.8,1.4,3,3,0,0,0,.87.13A6.66,6.66,0,0,0,11,21.81a4,4,0,0,1,1.94,0,4.33,4.33,0,0,0,2.24.06,4.12,4.12,0,0,0,1.8-1.4,5.11,5.11,0,0,1,.66-.66,4.77,4.77,0,0,1,.85-.43,4.25,4.25,0,0,0,1.87-1.28A4.19,4.19,0,0,0,21,15.94a4.11,4.11,0,0,1,.15-.95,4.57,4.57,0,0,1,.42-.82A4.3,4.3,0,0,0,22.37,12,4.3,4.3,0,0,0,21.6,9.84ZM16.71,10.71l-5,5a1,1,0,0,1-1.42,0l-3-3a1,1,0,0,1,1.42-1.42L11,13.59l4.29-4.3a1,1,0,0,1,1.42,1.42Z"/>
                                </svg>
                                <span>{safeT('modals.premium.upgradeButton', 'ПОВЫСИТЬ СТАТУС ДО PREMIUM')}</span>
                                <i className="fas fa-chevron-right" style={{ marginLeft: 'auto', fontSize: '12px' }}></i>
                            </button>
                        </div>

                        {/* Footer Disclaimer */}
                        <div className={s.premiumModalFooter}>
                            <p className={s.premiumModalDisclaimer}>
                                {safeT('modals.premium.disclaimer', 'ДАННАЯ ПРОЦЕДУРА ЯВЛЯЕТСЯ ОБЯЗАТЕЛЬНОЙ СОГЛАСНО ДИРЕКТИВЕ AMLDS ПО БОРЬБЕ С ОТМЫВАНИЕМ СРЕДСТВ ДЛЯ ТРАНЗАКЦИЙ ВЫСОКОГО ОБЪЕМА.')}
                            </p>
                        </div>

                        {/* Close Button */}
                        <button
                            className={s.premiumModalClose}
                            onClick={closePremiumModal}
                        >
                            {safeT('modals.premium.closeButton', '✕')}
                        </button>
                    </div>
                </div>
            )}
        </>
        </AppProvider>
        )}
        </>
    );
}

export default App;